!(function (e) {
    var t = {};
    function a(s) {
        if (t[s]) return t[s].exports;
        var i = (t[s] = { i: s, l: !1, exports: {} });
        return e[s].call(i.exports, i, i.exports, a), (i.l = !0), i.exports;
    }
    (a.m = e),
        (a.c = t),
        (a.d = function (e, t, s) {
            a.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: s });
        }),
        (a.r = function (e) {
            "undefined" != typeof Symbol &&
                Symbol.toStringTag &&
                Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
                Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (a.t = function (e, t) {
            if ((1 & t && (e = a(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var s = Object.create(null);
            if (
                (a.r(s),
                Object.defineProperty(s, "default", { enumerable: !0, value: e }),
                2 & t && "string" != typeof e)
            )
                for (var i in e)
                    a.d(
                        s,
                        i,
                        function (t) {
                            return e[t];
                        }.bind(null, i)
                    );
            return s;
        }),
        (a.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return a.d(t, "a", t), t;
        }),
        (a.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (a.p = ""),
        a((a.s = 287));
})({
    1: function (e, t, a) {
        "use strict";
        t.a = function (e, t) {
            return (
                (t = t || {}),
                new Promise(function (a, s) {
                    var i = new XMLHttpRequest(),
                        n = [],
                        r = [],
                        o = {},
                        l = function () {
                            return {
                                ok: 2 == ((i.status / 100) | 0),
                                statusText: i.statusText,
                                status: i.status,
                                url: i.responseURL,
                                text: function () {
                                    return Promise.resolve(i.responseText);
                                },
                                json: function () {
                                    return Promise.resolve(i.responseText).then(JSON.parse);
                                },
                                blob: function () {
                                    return Promise.resolve(new Blob([i.response]));
                                },
                                clone: l,
                                headers: {
                                    keys: function () {
                                        return n;
                                    },
                                    entries: function () {
                                        return r;
                                    },
                                    get: function (e) {
                                        return o[e.toLowerCase()];
                                    },
                                    has: function (e) {
                                        return e.toLowerCase() in o;
                                    },
                                },
                            };
                        };
                    for (var d in (i.open(t.method || "get", e, !0),
                    (i.onload = function () {
                        i.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, t, a) {
                            n.push((t = t.toLowerCase())), r.push([t, a]), (o[t] = o[t] ? o[t] + "," + a : a);
                        }),
                            a(l());
                    }),
                    (i.onerror = s),
                    (i.withCredentials = "include" == t.credentials),
                    t.headers))
                        i.setRequestHeader(d, t.headers[d]);
                    i.send(t.body || null);
                })
            );
        };
    },
    162: function (e, t, a) {
        "use strict";
        function s() {
            const e = document.querySelectorAll("[data-size-guide-popup]");
            e.length &&
                e.forEach((e) => {
                    const t = e.querySelector("[data-product-size-guide-supprting-text]"),
                        a = e.querySelectorAll("[data-size-guide-item]");
                    if (null == a || null == t) return;
                    const s = t.innerHTML;
                    a.forEach((e) => {
                        e.addEventListener("mouseover", () => {
                            const a = e.getAttribute("data-size-guide-item-supporting-text");
                            t.innerHTML = a;
                        }),
                            e.addEventListener("mouseleave", () => {
                                t.innerHTML = s;
                            }),
                            e.addEventListener("focus", () => {
                                const a = e.getAttribute("data-size-guide-item-supporting-text");
                                t.innerHTML = a;
                            }),
                            e.addEventListener("blur", () => {
                                t.innerHTML = s;
                            });
                    });
                });
        }
        a.d(t, "a", function () {
            return s;
        }),
            document.addEventListener("DOMContentLoaded", () => {
                s();
            }),
            document.addEventListener("shopify:section:load", () => {
                s();
            });
    },
    18: function (e, t) {
        document.addEventListener("DOMContentLoaded", () => {
            !(function () {
                const e = document.querySelector("[data-collection-filter]"),
                    t = document.querySelector("[data-collection-sorting-mobile]"),
                    a = document.querySelectorAll("[data-collection-mobile-toggle]"),
                    s = document.querySelector("[data-collection-filter-toggle]"),
                    i = document.querySelector("[data-collection-sort-toggle]"),
                    n = document.querySelector("[data-collection-filter-clear]"),
                    r = document.querySelector("[data-collection-grid-wrapper]"),
                    o = document.querySelector("[data-site-footer]");
                a.forEach((a) => {
                    a.addEventListener("click", () => {
                        a.hasAttribute("data-collection-filter-toggle")
                            ? (i.classList.remove("active"),
                              t.classList.remove("active"),
                              s.classList.toggle("active"),
                              e.classList.toggle("active"))
                            : (s.classList.remove("active"),
                              e.classList.remove("active"),
                              i.classList.toggle("active"),
                              t.classList.toggle("active")),
                            a.classList.contains("active")
                                ? (o.classList.add("small--hide"),
                                  r.classList.add("small--hide"),
                                  n && n.classList.add("hide"))
                                : (o.classList.remove("small--hide"),
                                  r.classList.remove("small--hide"),
                                  n && n.classList.remove("hide"));
                    });
                });
            })();
        });
    },
    2: function (e, t, a) {
        "use strict";
        function s(e) {
            return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
        }
        function i(e, t) {
            void 0 === e && (e = {}),
                void 0 === t && (t = {}),
                Object.keys(t).forEach(function (a) {
                    void 0 === e[a]
                        ? (e[a] = t[a])
                        : s(t[a]) && s(e[a]) && Object.keys(t[a]).length > 0 && i(e[a], t[a]);
                });
        }
        var n = "undefined" != typeof document ? document : {},
            r = {
                body: {},
                addEventListener: function () {},
                removeEventListener: function () {},
                activeElement: { blur: function () {}, nodeName: "" },
                querySelector: function () {
                    return null;
                },
                querySelectorAll: function () {
                    return [];
                },
                getElementById: function () {
                    return null;
                },
                createEvent: function () {
                    return { initEvent: function () {} };
                },
                createElement: function () {
                    return {
                        children: [],
                        childNodes: [],
                        style: {},
                        setAttribute: function () {},
                        getElementsByTagName: function () {
                            return [];
                        },
                    };
                },
                createElementNS: function () {
                    return {};
                },
                importNode: function () {
                    return null;
                },
                location: {
                    hash: "",
                    host: "",
                    hostname: "",
                    href: "",
                    origin: "",
                    pathname: "",
                    protocol: "",
                    search: "",
                },
            };
        i(n, r);
        var o = "undefined" != typeof window ? window : {};
        i(o, {
            document: r,
            navigator: { userAgent: "" },
            location: {
                hash: "",
                host: "",
                hostname: "",
                href: "",
                origin: "",
                pathname: "",
                protocol: "",
                search: "",
            },
            history: {
                replaceState: function () {},
                pushState: function () {},
                go: function () {},
                back: function () {},
            },
            CustomEvent: function () {
                return this;
            },
            addEventListener: function () {},
            removeEventListener: function () {},
            getComputedStyle: function () {
                return {
                    getPropertyValue: function () {
                        return "";
                    },
                };
            },
            Image: function () {},
            Date: function () {},
            screen: {},
            setTimeout: function () {},
            clearTimeout: function () {},
            matchMedia: function () {
                return {};
            },
        });
        class l {
            constructor(e) {
                const t = this;
                for (let a = 0; a < e.length; a += 1) t[a] = e[a];
                return (t.length = e.length), this;
            }
        }
        function d(e, t) {
            const a = [];
            let s = 0;
            if (e && !t && e instanceof l) return e;
            if (e)
                if ("string" == typeof e) {
                    let i, r;
                    const o = e.trim();
                    if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
                        let e = "div";
                        for (
                            0 === o.indexOf("<li") && (e = "ul"),
                                0 === o.indexOf("<tr") && (e = "tbody"),
                                (0 !== o.indexOf("<td") && 0 !== o.indexOf("<th")) || (e = "tr"),
                                0 === o.indexOf("<tbody") && (e = "table"),
                                0 === o.indexOf("<option") && (e = "select"),
                                r = n.createElement(e),
                                r.innerHTML = o,
                                s = 0;
                            s < r.childNodes.length;
                            s += 1
                        )
                            a.push(r.childNodes[s]);
                    } else
                        for (
                            i =
                                t || "#" !== e[0] || e.match(/[ .<>:~]/)
                                    ? (t || n).querySelectorAll(e.trim())
                                    : [n.getElementById(e.trim().split("#")[1])],
                                s = 0;
                            s < i.length;
                            s += 1
                        )
                            i[s] && a.push(i[s]);
                } else if (e.nodeType || e === o || e === n) a.push(e);
                else if (e.length > 0 && e[0].nodeType) for (s = 0; s < e.length; s += 1) a.push(e[s]);
            return new l(a);
        }
        function c(e) {
            const t = [];
            for (let a = 0; a < e.length; a += 1) -1 === t.indexOf(e[a]) && t.push(e[a]);
            return t;
        }
        (d.fn = l.prototype), (d.Class = l), (d.Dom7 = l);
        "resize scroll".split(" ");
        const u = {
            addClass: function (e) {
                if (void 0 === e) return this;
                const t = e.split(" ");
                for (let e = 0; e < t.length; e += 1)
                    for (let a = 0; a < this.length; a += 1)
                        void 0 !== this[a] && void 0 !== this[a].classList && this[a].classList.add(t[e]);
                return this;
            },
            removeClass: function (e) {
                const t = e.split(" ");
                for (let e = 0; e < t.length; e += 1)
                    for (let a = 0; a < this.length; a += 1)
                        void 0 !== this[a] && void 0 !== this[a].classList && this[a].classList.remove(t[e]);
                return this;
            },
            hasClass: function (e) {
                return !!this[0] && this[0].classList.contains(e);
            },
            toggleClass: function (e) {
                const t = e.split(" ");
                for (let e = 0; e < t.length; e += 1)
                    for (let a = 0; a < this.length; a += 1)
                        void 0 !== this[a] && void 0 !== this[a].classList && this[a].classList.toggle(t[e]);
                return this;
            },
            attr: function (e, t) {
                if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
                for (let a = 0; a < this.length; a += 1)
                    if (2 === arguments.length) this[a].setAttribute(e, t);
                    else for (const t in e) (this[a][t] = e[t]), this[a].setAttribute(t, e[t]);
                return this;
            },
            removeAttr: function (e) {
                for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
                return this;
            },
            data: function (e, t) {
                let a;
                if (void 0 !== t) {
                    for (let s = 0; s < this.length; s += 1)
                        (a = this[s]),
                            a.dom7ElementDataStorage || (a.dom7ElementDataStorage = {}),
                            (a.dom7ElementDataStorage[e] = t);
                    return this;
                }
                if (((a = this[0]), a)) {
                    if (a.dom7ElementDataStorage && e in a.dom7ElementDataStorage) return a.dom7ElementDataStorage[e];
                    const t = a.getAttribute("data-" + e);
                    return t || void 0;
                }
            },
            transform: function (e) {
                for (let t = 0; t < this.length; t += 1) {
                    const a = this[t].style;
                    (a.webkitTransform = e), (a.transform = e);
                }
                return this;
            },
            transition: function (e) {
                "string" != typeof e && (e += "ms");
                for (let t = 0; t < this.length; t += 1) {
                    const a = this[t].style;
                    (a.webkitTransitionDuration = e), (a.transitionDuration = e);
                }
                return this;
            },
            on: function (...e) {
                let [t, a, s, i] = e;
                function n(e) {
                    const t = e.target;
                    if (!t) return;
                    const i = e.target.dom7EventData || [];
                    if ((i.indexOf(e) < 0 && i.unshift(e), d(t).is(a))) s.apply(t, i);
                    else {
                        const e = d(t).parents();
                        for (let t = 0; t < e.length; t += 1) d(e[t]).is(a) && s.apply(e[t], i);
                    }
                }
                function r(e) {
                    const t = (e && e.target && e.target.dom7EventData) || [];
                    t.indexOf(e) < 0 && t.unshift(e), s.apply(this, t);
                }
                "function" == typeof e[1] && (([t, s, i] = e), (a = void 0)), i || (i = !1);
                const o = t.split(" ");
                let l;
                for (let e = 0; e < this.length; e += 1) {
                    const t = this[e];
                    if (a)
                        for (l = 0; l < o.length; l += 1) {
                            const e = o[l];
                            t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                                t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                                t.dom7LiveListeners[e].push({ listener: s, proxyListener: n }),
                                t.addEventListener(e, n, i);
                        }
                    else
                        for (l = 0; l < o.length; l += 1) {
                            const e = o[l];
                            t.dom7Listeners || (t.dom7Listeners = {}),
                                t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                                t.dom7Listeners[e].push({ listener: s, proxyListener: r }),
                                t.addEventListener(e, r, i);
                        }
                }
                return this;
            },
            off: function (...e) {
                let [t, a, s, i] = e;
                "function" == typeof e[1] && (([t, s, i] = e), (a = void 0)), i || (i = !1);
                const n = t.split(" ");
                for (let e = 0; e < n.length; e += 1) {
                    const t = n[e];
                    for (let e = 0; e < this.length; e += 1) {
                        const n = this[e];
                        let r;
                        if (
                            (!a && n.dom7Listeners
                                ? (r = n.dom7Listeners[t])
                                : a && n.dom7LiveListeners && (r = n.dom7LiveListeners[t]),
                            r && r.length)
                        )
                            for (let e = r.length - 1; e >= 0; e -= 1) {
                                const a = r[e];
                                (s && a.listener === s) ||
                                (s && a.listener && a.listener.dom7proxy && a.listener.dom7proxy === s)
                                    ? (n.removeEventListener(t, a.proxyListener, i), r.splice(e, 1))
                                    : s || (n.removeEventListener(t, a.proxyListener, i), r.splice(e, 1));
                            }
                    }
                }
                return this;
            },
            trigger: function (...e) {
                const t = e[0].split(" "),
                    a = e[1];
                for (let s = 0; s < t.length; s += 1) {
                    const i = t[s];
                    for (let t = 0; t < this.length; t += 1) {
                        const s = this[t];
                        let r;
                        try {
                            r = new o.CustomEvent(i, { detail: a, bubbles: !0, cancelable: !0 });
                        } catch (e) {
                            (r = n.createEvent("Event")), r.initEvent(i, !0, !0), (r.detail = a);
                        }
                        (s.dom7EventData = e.filter((e, t) => t > 0)),
                            s.dispatchEvent(r),
                            (s.dom7EventData = []),
                            delete s.dom7EventData;
                    }
                }
                return this;
            },
            transitionEnd: function (e) {
                const t = ["webkitTransitionEnd", "transitionend"],
                    a = this;
                let s;
                function i(n) {
                    if (n.target === this) for (e.call(this, n), s = 0; s < t.length; s += 1) a.off(t[s], i);
                }
                if (e) for (s = 0; s < t.length; s += 1) a.on(t[s], i);
                return this;
            },
            outerWidth: function (e) {
                if (this.length > 0) {
                    if (e) {
                        const e = this.styles();
                        return (
                            this[0].offsetWidth +
                            parseFloat(e.getPropertyValue("margin-right")) +
                            parseFloat(e.getPropertyValue("margin-left"))
                        );
                    }
                    return this[0].offsetWidth;
                }
                return null;
            },
            outerHeight: function (e) {
                if (this.length > 0) {
                    if (e) {
                        const e = this.styles();
                        return (
                            this[0].offsetHeight +
                            parseFloat(e.getPropertyValue("margin-top")) +
                            parseFloat(e.getPropertyValue("margin-bottom"))
                        );
                    }
                    return this[0].offsetHeight;
                }
                return null;
            },
            offset: function () {
                if (this.length > 0) {
                    const e = this[0],
                        t = e.getBoundingClientRect(),
                        a = n.body,
                        s = e.clientTop || a.clientTop || 0,
                        i = e.clientLeft || a.clientLeft || 0,
                        r = e === o ? o.scrollY : e.scrollTop,
                        l = e === o ? o.scrollX : e.scrollLeft;
                    return { top: t.top + r - s, left: t.left + l - i };
                }
                return null;
            },
            css: function (e, t) {
                let a;
                if (1 === arguments.length) {
                    if ("string" != typeof e) {
                        for (a = 0; a < this.length; a += 1) for (let t in e) this[a].style[t] = e[t];
                        return this;
                    }
                    if (this[0]) return o.getComputedStyle(this[0], null).getPropertyValue(e);
                }
                if (2 === arguments.length && "string" == typeof e) {
                    for (a = 0; a < this.length; a += 1) this[a].style[e] = t;
                    return this;
                }
                return this;
            },
            each: function (e) {
                if (!e) return this;
                for (let t = 0; t < this.length; t += 1) if (!1 === e.call(this[t], t, this[t])) return this;
                return this;
            },
            html: function (e) {
                if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
                for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
                return this;
            },
            text: function (e) {
                if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
                for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
                return this;
            },
            is: function (e) {
                const t = this[0];
                let a, s;
                if (!t || void 0 === e) return !1;
                if ("string" == typeof e) {
                    if (t.matches) return t.matches(e);
                    if (t.webkitMatchesSelector) return t.webkitMatchesSelector(e);
                    if (t.msMatchesSelector) return t.msMatchesSelector(e);
                    for (a = d(e), s = 0; s < a.length; s += 1) if (a[s] === t) return !0;
                    return !1;
                }
                if (e === n) return t === n;
                if (e === o) return t === o;
                if (e.nodeType || e instanceof l) {
                    for (a = e.nodeType ? [e] : e, s = 0; s < a.length; s += 1) if (a[s] === t) return !0;
                    return !1;
                }
                return !1;
            },
            index: function () {
                let e,
                    t = this[0];
                if (t) {
                    for (e = 0; null !== (t = t.previousSibling); ) 1 === t.nodeType && (e += 1);
                    return e;
                }
            },
            eq: function (e) {
                if (void 0 === e) return this;
                const t = this.length;
                let a;
                return e > t - 1 ? new l([]) : e < 0 ? ((a = t + e), new l(a < 0 ? [] : [this[a]])) : new l([this[e]]);
            },
            append: function (...e) {
                let t;
                for (let a = 0; a < e.length; a += 1) {
                    t = e[a];
                    for (let e = 0; e < this.length; e += 1)
                        if ("string" == typeof t) {
                            const a = n.createElement("div");
                            for (a.innerHTML = t; a.firstChild; ) this[e].appendChild(a.firstChild);
                        } else if (t instanceof l) for (let a = 0; a < t.length; a += 1) this[e].appendChild(t[a]);
                        else this[e].appendChild(t);
                }
                return this;
            },
            prepend: function (e) {
                let t, a;
                for (t = 0; t < this.length; t += 1)
                    if ("string" == typeof e) {
                        const s = n.createElement("div");
                        for (s.innerHTML = e, a = s.childNodes.length - 1; a >= 0; a -= 1)
                            this[t].insertBefore(s.childNodes[a], this[t].childNodes[0]);
                    } else if (e instanceof l)
                        for (a = 0; a < e.length; a += 1) this[t].insertBefore(e[a], this[t].childNodes[0]);
                    else this[t].insertBefore(e, this[t].childNodes[0]);
                return this;
            },
            next: function (e) {
                return this.length > 0
                    ? e
                        ? this[0].nextElementSibling && d(this[0].nextElementSibling).is(e)
                            ? new l([this[0].nextElementSibling])
                            : new l([])
                        : this[0].nextElementSibling
                          ? new l([this[0].nextElementSibling])
                          : new l([])
                    : new l([]);
            },
            nextAll: function (e) {
                const t = [];
                let a = this[0];
                if (!a) return new l([]);
                for (; a.nextElementSibling; ) {
                    const s = a.nextElementSibling;
                    e ? d(s).is(e) && t.push(s) : t.push(s), (a = s);
                }
                return new l(t);
            },
            prev: function (e) {
                if (this.length > 0) {
                    const t = this[0];
                    return e
                        ? t.previousElementSibling && d(t.previousElementSibling).is(e)
                            ? new l([t.previousElementSibling])
                            : new l([])
                        : t.previousElementSibling
                          ? new l([t.previousElementSibling])
                          : new l([]);
                }
                return new l([]);
            },
            prevAll: function (e) {
                const t = [];
                let a = this[0];
                if (!a) return new l([]);
                for (; a.previousElementSibling; ) {
                    const s = a.previousElementSibling;
                    e ? d(s).is(e) && t.push(s) : t.push(s), (a = s);
                }
                return new l(t);
            },
            parent: function (e) {
                const t = [];
                for (let a = 0; a < this.length; a += 1)
                    null !== this[a].parentNode &&
                        (e ? d(this[a].parentNode).is(e) && t.push(this[a].parentNode) : t.push(this[a].parentNode));
                return d(c(t));
            },
            parents: function (e) {
                const t = [];
                for (let a = 0; a < this.length; a += 1) {
                    let s = this[a].parentNode;
                    for (; s; ) e ? d(s).is(e) && t.push(s) : t.push(s), (s = s.parentNode);
                }
                return d(c(t));
            },
            closest: function (e) {
                let t = this;
                return void 0 === e ? new l([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
            },
            find: function (e) {
                const t = [];
                for (let a = 0; a < this.length; a += 1) {
                    const s = this[a].querySelectorAll(e);
                    for (let e = 0; e < s.length; e += 1) t.push(s[e]);
                }
                return new l(t);
            },
            children: function (e) {
                const t = [];
                for (let a = 0; a < this.length; a += 1) {
                    const s = this[a].childNodes;
                    for (let a = 0; a < s.length; a += 1)
                        e ? 1 === s[a].nodeType && d(s[a]).is(e) && t.push(s[a]) : 1 === s[a].nodeType && t.push(s[a]);
                }
                return new l(c(t));
            },
            filter: function (e) {
                const t = [],
                    a = this;
                for (let s = 0; s < a.length; s += 1) e.call(a[s], s, a[s]) && t.push(a[s]);
                return new l(t);
            },
            remove: function () {
                for (let e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
                return this;
            },
            add: function (...e) {
                const t = this;
                let a, s;
                for (a = 0; a < e.length; a += 1) {
                    const i = d(e[a]);
                    for (s = 0; s < i.length; s += 1) (t[t.length] = i[s]), (t.length += 1);
                }
                return t;
            },
            styles: function () {
                return this[0] ? o.getComputedStyle(this[0], null) : {};
            },
        };
        Object.keys(u).forEach((e) => {
            d.fn[e] = d.fn[e] || u[e];
        });
        const p = {
                deleteProps(e) {
                    const t = e;
                    Object.keys(t).forEach((e) => {
                        try {
                            t[e] = null;
                        } catch (e) {}
                        try {
                            delete t[e];
                        } catch (e) {}
                    });
                },
                nextTick: (e, t = 0) => setTimeout(e, t),
                now: () => Date.now(),
                getTranslate(e, t = "x") {
                    let a, s, i;
                    const n = o.getComputedStyle(e, null);
                    return (
                        o.WebKitCSSMatrix
                            ? ((s = n.transform || n.webkitTransform),
                              s.split(",").length > 6 &&
                                  (s = s
                                      .split(", ")
                                      .map((e) => e.replace(",", "."))
                                      .join(", ")),
                              (i = new o.WebKitCSSMatrix("none" === s ? "" : s)))
                            : ((i =
                                  n.MozTransform ||
                                  n.OTransform ||
                                  n.MsTransform ||
                                  n.msTransform ||
                                  n.transform ||
                                  n.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")),
                              (a = i.toString().split(","))),
                        "x" === t &&
                            (s = o.WebKitCSSMatrix ? i.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])),
                        "y" === t &&
                            (s = o.WebKitCSSMatrix ? i.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])),
                        s || 0
                    );
                },
                parseUrlQuery(e) {
                    const t = {};
                    let a,
                        s,
                        i,
                        n,
                        r = e || o.location.href;
                    if ("string" == typeof r && r.length)
                        for (
                            r = r.indexOf("?") > -1 ? r.replace(/\S*\?/, "") : "",
                                s = r.split("&").filter((e) => "" !== e),
                                n = s.length,
                                a = 0;
                            a < n;
                            a += 1
                        )
                            (i = s[a].replace(/#\S+/g, "").split("=")),
                                (t[decodeURIComponent(i[0])] =
                                    void 0 === i[1] ? void 0 : decodeURIComponent(i[1]) || "");
                    return t;
                },
                isObject: (e) => "object" == typeof e && null !== e && e.constructor && e.constructor === Object,
                extend(...e) {
                    const t = Object(e[0]);
                    for (let a = 1; a < e.length; a += 1) {
                        const s = e[a];
                        if (null != s) {
                            const e = Object.keys(Object(s));
                            for (let a = 0, i = e.length; a < i; a += 1) {
                                const i = e[a],
                                    n = Object.getOwnPropertyDescriptor(s, i);
                                void 0 !== n &&
                                    n.enumerable &&
                                    (p.isObject(t[i]) && p.isObject(s[i])
                                        ? p.extend(t[i], s[i])
                                        : !p.isObject(t[i]) && p.isObject(s[i])
                                          ? ((t[i] = {}), p.extend(t[i], s[i]))
                                          : (t[i] = s[i]));
                            }
                        }
                    }
                    return t;
                },
            },
            h = {
                touch: !!("ontouchstart" in o || (o.DocumentTouch && n instanceof o.DocumentTouch)),
                pointerEvents: !!o.PointerEvent && "maxTouchPoints" in o.navigator && o.navigator.maxTouchPoints >= 0,
                observer: "MutationObserver" in o || "WebkitMutationObserver" in o,
                passiveListener: (function () {
                    let e = !1;
                    try {
                        const t = Object.defineProperty({}, "passive", {
                            get() {
                                e = !0;
                            },
                        });
                        o.addEventListener("testPassiveListener", null, t);
                    } catch (e) {}
                    return e;
                })(),
                gestures: "ongesturestart" in o,
            };
        class m {
            constructor(e = {}) {
                const t = this;
                (t.params = e),
                    (t.eventsListeners = {}),
                    t.params &&
                        t.params.on &&
                        Object.keys(t.params.on).forEach((e) => {
                            t.on(e, t.params.on[e]);
                        });
            }
            on(e, t, a) {
                const s = this;
                if ("function" != typeof t) return s;
                const i = a ? "unshift" : "push";
                return (
                    e.split(" ").forEach((e) => {
                        s.eventsListeners[e] || (s.eventsListeners[e] = []), s.eventsListeners[e][i](t);
                    }),
                    s
                );
            }
            once(e, t, a) {
                const s = this;
                if ("function" != typeof t) return s;
                function i(...a) {
                    s.off(e, i), i.f7proxy && delete i.f7proxy, t.apply(s, a);
                }
                return (i.f7proxy = t), s.on(e, i, a);
            }
            off(e, t) {
                const a = this;
                return a.eventsListeners
                    ? (e.split(" ").forEach((e) => {
                          void 0 === t
                              ? (a.eventsListeners[e] = [])
                              : a.eventsListeners[e] &&
                                a.eventsListeners[e].length &&
                                a.eventsListeners[e].forEach((s, i) => {
                                    (s === t || (s.f7proxy && s.f7proxy === t)) && a.eventsListeners[e].splice(i, 1);
                                });
                      }),
                      a)
                    : a;
            }
            emit(...e) {
                const t = this;
                if (!t.eventsListeners) return t;
                let a, s, i;
                "string" == typeof e[0] || Array.isArray(e[0])
                    ? ((a = e[0]), (s = e.slice(1, e.length)), (i = t))
                    : ((a = e[0].events), (s = e[0].data), (i = e[0].context || t));
                return (
                    (Array.isArray(a) ? a : a.split(" ")).forEach((e) => {
                        if (t.eventsListeners && t.eventsListeners[e]) {
                            const a = [];
                            t.eventsListeners[e].forEach((e) => {
                                a.push(e);
                            }),
                                a.forEach((e) => {
                                    e.apply(i, s);
                                });
                        }
                    }),
                    t
                );
            }
            useModulesParams(e) {
                const t = this;
                t.modules &&
                    Object.keys(t.modules).forEach((a) => {
                        const s = t.modules[a];
                        s.params && p.extend(e, s.params);
                    });
            }
            useModules(e = {}) {
                const t = this;
                t.modules &&
                    Object.keys(t.modules).forEach((a) => {
                        const s = t.modules[a],
                            i = e[a] || {};
                        s.instance &&
                            Object.keys(s.instance).forEach((e) => {
                                const a = s.instance[e];
                                t[e] = "function" == typeof a ? a.bind(t) : a;
                            }),
                            s.on &&
                                t.on &&
                                Object.keys(s.on).forEach((e) => {
                                    t.on(e, s.on[e]);
                                }),
                            s.create && s.create.bind(t)(i);
                    });
            }
            static set components(e) {
                this.use && this.use(e);
            }
            static installModule(e, ...t) {
                const a = this;
                a.prototype.modules || (a.prototype.modules = {});
                const s = e.name || `${Object.keys(a.prototype.modules).length}_${p.now()}`;
                return (
                    (a.prototype.modules[s] = e),
                    e.proto &&
                        Object.keys(e.proto).forEach((t) => {
                            a.prototype[t] = e.proto[t];
                        }),
                    e.static &&
                        Object.keys(e.static).forEach((t) => {
                            a[t] = e.static[t];
                        }),
                    e.install && e.install.apply(a, t),
                    a
                );
            }
            static use(e, ...t) {
                const a = this;
                return Array.isArray(e) ? (e.forEach((e) => a.installModule(e)), a) : a.installModule(e, ...t);
            }
        }
        var f = {
            updateSize: function () {
                const e = this;
                let t, a;
                const s = e.$el;
                (t = void 0 !== e.params.width ? e.params.width : s[0].clientWidth),
                    (a = void 0 !== e.params.height ? e.params.height : s[0].clientHeight),
                    (0 === t && e.isHorizontal()) ||
                        (0 === a && e.isVertical()) ||
                        ((t = t - parseInt(s.css("padding-left"), 10) - parseInt(s.css("padding-right"), 10)),
                        (a = a - parseInt(s.css("padding-top"), 10) - parseInt(s.css("padding-bottom"), 10)),
                        p.extend(e, { width: t, height: a, size: e.isHorizontal() ? t : a }));
            },
            updateSlides: function () {
                const e = this,
                    t = e.params,
                    { $wrapperEl: a, size: s, rtlTranslate: i, wrongRTL: n } = e,
                    r = e.virtual && t.virtual.enabled,
                    l = r ? e.virtual.slides.length : e.slides.length,
                    d = a.children("." + e.params.slideClass),
                    c = r ? e.virtual.slides.length : d.length;
                let u = [];
                const h = [],
                    m = [];
                function f(e) {
                    return !t.cssMode || e !== d.length - 1;
                }
                let g = t.slidesOffsetBefore;
                "function" == typeof g && (g = t.slidesOffsetBefore.call(e));
                let v = t.slidesOffsetAfter;
                "function" == typeof v && (v = t.slidesOffsetAfter.call(e));
                const b = e.snapGrid.length,
                    y = e.snapGrid.length;
                let w,
                    S,
                    x = t.spaceBetween,
                    E = -g,
                    T = 0,
                    C = 0;
                if (void 0 === s) return;
                "string" == typeof x && x.indexOf("%") >= 0 && (x = (parseFloat(x.replace("%", "")) / 100) * s),
                    (e.virtualSize = -x),
                    i ? d.css({ marginLeft: "", marginTop: "" }) : d.css({ marginRight: "", marginBottom: "" }),
                    t.slidesPerColumn > 1 &&
                        ((w =
                            Math.floor(c / t.slidesPerColumn) === c / e.params.slidesPerColumn
                                ? c
                                : Math.ceil(c / t.slidesPerColumn) * t.slidesPerColumn),
                        "auto" !== t.slidesPerView &&
                            "row" === t.slidesPerColumnFill &&
                            (w = Math.max(w, t.slidesPerView * t.slidesPerColumn)));
                const M = t.slidesPerColumn,
                    L = w / M,
                    $ = Math.floor(c / t.slidesPerColumn);
                for (let a = 0; a < c; a += 1) {
                    S = 0;
                    const i = d.eq(a);
                    if (t.slidesPerColumn > 1) {
                        let s, n, r;
                        if ("row" === t.slidesPerColumnFill && t.slidesPerGroup > 1) {
                            const e = Math.floor(a / (t.slidesPerGroup * t.slidesPerColumn)),
                                o = a - t.slidesPerColumn * t.slidesPerGroup * e,
                                l =
                                    0 === e
                                        ? t.slidesPerGroup
                                        : Math.min(Math.ceil((c - e * M * t.slidesPerGroup) / M), t.slidesPerGroup);
                            (r = Math.floor(o / l)),
                                (n = o - r * l + e * t.slidesPerGroup),
                                (s = n + (r * w) / M),
                                i.css({
                                    "-webkit-box-ordinal-group": s,
                                    "-moz-box-ordinal-group": s,
                                    "-ms-flex-order": s,
                                    "-webkit-order": s,
                                    order: s,
                                });
                        } else
                            "column" === t.slidesPerColumnFill
                                ? ((n = Math.floor(a / M)),
                                  (r = a - n * M),
                                  (n > $ || (n === $ && r === M - 1)) && ((r += 1), r >= M && ((r = 0), (n += 1))))
                                : ((r = Math.floor(a / L)), (n = a - r * L));
                        i.css(
                            "margin-" + (e.isHorizontal() ? "top" : "left"),
                            0 !== r && t.spaceBetween && t.spaceBetween + "px"
                        );
                    }
                    if ("none" !== i.css("display")) {
                        if ("auto" === t.slidesPerView) {
                            const a = o.getComputedStyle(i[0], null),
                                s = i[0].style.transform,
                                n = i[0].style.webkitTransform;
                            if (
                                (s && (i[0].style.transform = "none"),
                                n && (i[0].style.webkitTransform = "none"),
                                t.roundLengths)
                            )
                                S = e.isHorizontal() ? i.outerWidth(!0) : i.outerHeight(!0);
                            else if (e.isHorizontal()) {
                                const e = parseFloat(a.getPropertyValue("width")),
                                    t = parseFloat(a.getPropertyValue("padding-left")),
                                    s = parseFloat(a.getPropertyValue("padding-right")),
                                    i = parseFloat(a.getPropertyValue("margin-left")),
                                    n = parseFloat(a.getPropertyValue("margin-right")),
                                    r = a.getPropertyValue("box-sizing");
                                S = r && "border-box" === r ? e + i + n : e + t + s + i + n;
                            } else {
                                const e = parseFloat(a.getPropertyValue("height")),
                                    t = parseFloat(a.getPropertyValue("padding-top")),
                                    s = parseFloat(a.getPropertyValue("padding-bottom")),
                                    i = parseFloat(a.getPropertyValue("margin-top")),
                                    n = parseFloat(a.getPropertyValue("margin-bottom")),
                                    r = a.getPropertyValue("box-sizing");
                                S = r && "border-box" === r ? e + i + n : e + t + s + i + n;
                            }
                            s && (i[0].style.transform = s),
                                n && (i[0].style.webkitTransform = n),
                                t.roundLengths && (S = Math.floor(S));
                        } else
                            (S = (s - (t.slidesPerView - 1) * x) / t.slidesPerView),
                                t.roundLengths && (S = Math.floor(S)),
                                d[a] &&
                                    (e.isHorizontal() ? (d[a].style.width = S + "px") : (d[a].style.height = S + "px"));
                        d[a] && (d[a].swiperSlideSize = S),
                            m.push(S),
                            t.centeredSlides
                                ? ((E = E + S / 2 + T / 2 + x),
                                  0 === T && 0 !== a && (E = E - s / 2 - x),
                                  0 === a && (E = E - s / 2 - x),
                                  Math.abs(E) < 0.001 && (E = 0),
                                  t.roundLengths && (E = Math.floor(E)),
                                  C % t.slidesPerGroup == 0 && u.push(E),
                                  h.push(E))
                                : (t.roundLengths && (E = Math.floor(E)),
                                  (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup == 0 &&
                                      u.push(E),
                                  h.push(E),
                                  (E = E + S + x)),
                            (e.virtualSize += S + x),
                            (T = S),
                            (C += 1);
                    }
                }
                let k;
                if (
                    ((e.virtualSize = Math.max(e.virtualSize, s) + v),
                    i &&
                        n &&
                        ("slide" === t.effect || "coverflow" === t.effect) &&
                        a.css({ width: e.virtualSize + t.spaceBetween + "px" }),
                    t.setWrapperSize &&
                        (e.isHorizontal()
                            ? a.css({ width: e.virtualSize + t.spaceBetween + "px" })
                            : a.css({ height: e.virtualSize + t.spaceBetween + "px" })),
                    t.slidesPerColumn > 1 &&
                        ((e.virtualSize = (S + t.spaceBetween) * w),
                        (e.virtualSize = Math.ceil(e.virtualSize / t.slidesPerColumn) - t.spaceBetween),
                        e.isHorizontal()
                            ? a.css({ width: e.virtualSize + t.spaceBetween + "px" })
                            : a.css({ height: e.virtualSize + t.spaceBetween + "px" }),
                        t.centeredSlides))
                ) {
                    k = [];
                    for (let a = 0; a < u.length; a += 1) {
                        let s = u[a];
                        t.roundLengths && (s = Math.floor(s)), u[a] < e.virtualSize + u[0] && k.push(s);
                    }
                    u = k;
                }
                if (!t.centeredSlides) {
                    k = [];
                    for (let a = 0; a < u.length; a += 1) {
                        let i = u[a];
                        t.roundLengths && (i = Math.floor(i)), u[a] <= e.virtualSize - s && k.push(i);
                    }
                    (u = k),
                        Math.floor(e.virtualSize - s) - Math.floor(u[u.length - 1]) > 1 && u.push(e.virtualSize - s);
                }
                if (
                    (0 === u.length && (u = [0]),
                    0 !== t.spaceBetween &&
                        (e.isHorizontal()
                            ? i
                                ? d.filter(f).css({ marginLeft: x + "px" })
                                : d.filter(f).css({ marginRight: x + "px" })
                            : d.filter(f).css({ marginBottom: x + "px" })),
                    t.centeredSlides && t.centeredSlidesBounds)
                ) {
                    let e = 0;
                    m.forEach((a) => {
                        e += a + (t.spaceBetween ? t.spaceBetween : 0);
                    }),
                        (e -= t.spaceBetween);
                    const a = e - s;
                    u = u.map((e) => (e < 0 ? -g : e > a ? a + v : e));
                }
                if (t.centerInsufficientSlides) {
                    let e = 0;
                    if (
                        (m.forEach((a) => {
                            e += a + (t.spaceBetween ? t.spaceBetween : 0);
                        }),
                        (e -= t.spaceBetween),
                        e < s)
                    ) {
                        const t = (s - e) / 2;
                        u.forEach((e, a) => {
                            u[a] = e - t;
                        }),
                            h.forEach((e, a) => {
                                h[a] = e + t;
                            });
                    }
                }
                p.extend(e, { slides: d, snapGrid: u, slidesGrid: h, slidesSizesGrid: m }),
                    c !== l && e.emit("slidesLengthChange"),
                    u.length !== b && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
                    h.length !== y && e.emit("slidesGridLengthChange"),
                    (t.watchSlidesProgress || t.watchSlidesVisibility) && e.updateSlidesOffset();
            },
            updateAutoHeight: function (e) {
                const t = this,
                    a = [];
                let s,
                    i = 0;
                if (
                    ("number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed),
                    "auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
                )
                    if (t.params.centeredSlides)
                        t.visibleSlides.each((e, t) => {
                            a.push(t);
                        });
                    else
                        for (s = 0; s < Math.ceil(t.params.slidesPerView); s += 1) {
                            const e = t.activeIndex + s;
                            if (e > t.slides.length) break;
                            a.push(t.slides.eq(e)[0]);
                        }
                else a.push(t.slides.eq(t.activeIndex)[0]);
                for (s = 0; s < a.length; s += 1)
                    if (void 0 !== a[s]) {
                        const e = a[s].offsetHeight;
                        i = e > i ? e : i;
                    }
                i && t.$wrapperEl.css("height", i + "px");
            },
            updateSlidesOffset: function () {
                const e = this,
                    t = e.slides;
                for (let a = 0; a < t.length; a += 1)
                    t[a].swiperSlideOffset = e.isHorizontal() ? t[a].offsetLeft : t[a].offsetTop;
            },
            updateSlidesProgress: function (e = (this && this.translate) || 0) {
                const t = this,
                    a = t.params,
                    { slides: s, rtlTranslate: i } = t;
                if (0 === s.length) return;
                void 0 === s[0].swiperSlideOffset && t.updateSlidesOffset();
                let n = -e;
                i && (n = e), s.removeClass(a.slideVisibleClass), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
                for (let e = 0; e < s.length; e += 1) {
                    const r = s[e],
                        o =
                            (n + (a.centeredSlides ? t.minTranslate() : 0) - r.swiperSlideOffset) /
                            (r.swiperSlideSize + a.spaceBetween);
                    if (a.watchSlidesVisibility || (a.centeredSlides && a.autoHeight)) {
                        const i = -(n - r.swiperSlideOffset),
                            o = i + t.slidesSizesGrid[e];
                        ((i >= 0 && i < t.size - 1) || (o > 1 && o <= t.size) || (i <= 0 && o >= t.size)) &&
                            (t.visibleSlides.push(r),
                            t.visibleSlidesIndexes.push(e),
                            s.eq(e).addClass(a.slideVisibleClass));
                    }
                    r.progress = i ? -o : o;
                }
                t.visibleSlides = d(t.visibleSlides);
            },
            updateProgress: function (e) {
                const t = this;
                if (void 0 === e) {
                    const a = t.rtlTranslate ? -1 : 1;
                    e = (t && t.translate && t.translate * a) || 0;
                }
                const a = t.params,
                    s = t.maxTranslate() - t.minTranslate();
                let { progress: i, isBeginning: n, isEnd: r } = t;
                const o = n,
                    l = r;
                0 === s
                    ? ((i = 0), (n = !0), (r = !0))
                    : ((i = (e - t.minTranslate()) / s), (n = i <= 0), (r = i >= 1)),
                    p.extend(t, { progress: i, isBeginning: n, isEnd: r }),
                    (a.watchSlidesProgress || a.watchSlidesVisibility || (a.centeredSlides && a.autoHeight)) &&
                        t.updateSlidesProgress(e),
                    n && !o && t.emit("reachBeginning toEdge"),
                    r && !l && t.emit("reachEnd toEdge"),
                    ((o && !n) || (l && !r)) && t.emit("fromEdge"),
                    t.emit("progress", i);
            },
            updateSlidesClasses: function () {
                const e = this,
                    { slides: t, params: a, $wrapperEl: s, activeIndex: i, realIndex: n } = e,
                    r = e.virtual && a.virtual.enabled;
                let o;
                t.removeClass(
                    `${a.slideActiveClass} ${a.slideNextClass} ${a.slidePrevClass} ${a.slideDuplicateActiveClass} ${a.slideDuplicateNextClass} ${a.slideDuplicatePrevClass}`
                ),
                    (o = r ? e.$wrapperEl.find(`.${a.slideClass}[data-swiper-slide-index="${i}"]`) : t.eq(i)),
                    o.addClass(a.slideActiveClass),
                    a.loop &&
                        (o.hasClass(a.slideDuplicateClass)
                            ? s
                                  .children(
                                      `.${a.slideClass}:not(.${a.slideDuplicateClass})[data-swiper-slide-index="${n}"]`
                                  )
                                  .addClass(a.slideDuplicateActiveClass)
                            : s
                                  .children(`.${a.slideClass}.${a.slideDuplicateClass}[data-swiper-slide-index="${n}"]`)
                                  .addClass(a.slideDuplicateActiveClass));
                let l = o
                    .nextAll("." + a.slideClass)
                    .eq(0)
                    .addClass(a.slideNextClass);
                a.loop && 0 === l.length && ((l = t.eq(0)), l.addClass(a.slideNextClass));
                let d = o
                    .prevAll("." + a.slideClass)
                    .eq(0)
                    .addClass(a.slidePrevClass);
                a.loop && 0 === d.length && ((d = t.eq(-1)), d.addClass(a.slidePrevClass)),
                    a.loop &&
                        (l.hasClass(a.slideDuplicateClass)
                            ? s
                                  .children(
                                      `.${a.slideClass}:not(.${a.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`
                                  )
                                  .addClass(a.slideDuplicateNextClass)
                            : s
                                  .children(
                                      `.${a.slideClass}.${a.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`
                                  )
                                  .addClass(a.slideDuplicateNextClass),
                        d.hasClass(a.slideDuplicateClass)
                            ? s
                                  .children(
                                      `.${a.slideClass}:not(.${a.slideDuplicateClass})[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`
                                  )
                                  .addClass(a.slideDuplicatePrevClass)
                            : s
                                  .children(
                                      `.${a.slideClass}.${a.slideDuplicateClass}[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`
                                  )
                                  .addClass(a.slideDuplicatePrevClass));
            },
            updateActiveIndex: function (e) {
                const t = this,
                    a = t.rtlTranslate ? t.translate : -t.translate,
                    { slidesGrid: s, snapGrid: i, params: n, activeIndex: r, realIndex: o, snapIndex: l } = t;
                let d,
                    c = e;
                if (void 0 === c) {
                    for (let e = 0; e < s.length; e += 1)
                        void 0 !== s[e + 1]
                            ? a >= s[e] && a < s[e + 1] - (s[e + 1] - s[e]) / 2
                                ? (c = e)
                                : a >= s[e] && a < s[e + 1] && (c = e + 1)
                            : a >= s[e] && (c = e);
                    n.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0);
                }
                if (i.indexOf(a) >= 0) d = i.indexOf(a);
                else {
                    const e = Math.min(n.slidesPerGroupSkip, c);
                    d = e + Math.floor((c - e) / n.slidesPerGroup);
                }
                if ((d >= i.length && (d = i.length - 1), c === r))
                    return void (d !== l && ((t.snapIndex = d), t.emit("snapIndexChange")));
                const u = parseInt(t.slides.eq(c).attr("data-swiper-slide-index") || c, 10);
                p.extend(t, { snapIndex: d, realIndex: u, previousIndex: r, activeIndex: c }),
                    t.emit("activeIndexChange"),
                    t.emit("snapIndexChange"),
                    o !== u && t.emit("realIndexChange"),
                    (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
            },
            updateClickedSlide: function (e) {
                const t = this,
                    a = t.params,
                    s = d(e.target).closest("." + a.slideClass)[0];
                let i = !1;
                if (s) for (let e = 0; e < t.slides.length; e += 1) t.slides[e] === s && (i = !0);
                if (!s || !i) return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
                (t.clickedSlide = s),
                    t.virtual && t.params.virtual.enabled
                        ? (t.clickedIndex = parseInt(d(s).attr("data-swiper-slide-index"), 10))
                        : (t.clickedIndex = d(s).index()),
                    a.slideToClickedSlide &&
                        void 0 !== t.clickedIndex &&
                        t.clickedIndex !== t.activeIndex &&
                        t.slideToClickedSlide();
            },
        };
        var g = {
            getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
                const { params: t, rtlTranslate: a, translate: s, $wrapperEl: i } = this;
                if (t.virtualTranslate) return a ? -s : s;
                if (t.cssMode) return s;
                let n = p.getTranslate(i[0], e);
                return a && (n = -n), n || 0;
            },
            setTranslate: function (e, t) {
                const a = this,
                    { rtlTranslate: s, params: i, $wrapperEl: n, wrapperEl: r, progress: o } = a;
                let l,
                    d = 0,
                    c = 0;
                a.isHorizontal() ? (d = s ? -e : e) : (c = e),
                    i.roundLengths && ((d = Math.floor(d)), (c = Math.floor(c))),
                    i.cssMode
                        ? (r[a.isHorizontal() ? "scrollLeft" : "scrollTop"] = a.isHorizontal() ? -d : -c)
                        : i.virtualTranslate || n.transform(`translate3d(${d}px, ${c}px, 0px)`),
                    (a.previousTranslate = a.translate),
                    (a.translate = a.isHorizontal() ? d : c);
                const u = a.maxTranslate() - a.minTranslate();
                (l = 0 === u ? 0 : (e - a.minTranslate()) / u),
                    l !== o && a.updateProgress(e),
                    a.emit("setTranslate", a.translate, t);
            },
            minTranslate: function () {
                return -this.snapGrid[0];
            },
            maxTranslate: function () {
                return -this.snapGrid[this.snapGrid.length - 1];
            },
            translateTo: function (e = 0, t = this.params.speed, a = !0, s = !0, i) {
                const n = this,
                    { params: r, wrapperEl: o } = n;
                if (n.animating && r.preventInteractionOnTransition) return !1;
                const l = n.minTranslate(),
                    d = n.maxTranslate();
                let c;
                if (((c = s && e > l ? l : s && e < d ? d : e), n.updateProgress(c), r.cssMode)) {
                    const e = n.isHorizontal();
                    return (
                        0 === t
                            ? (o[e ? "scrollLeft" : "scrollTop"] = -c)
                            : o.scrollTo
                              ? o.scrollTo({ [e ? "left" : "top"]: -c, behavior: "smooth" })
                              : (o[e ? "scrollLeft" : "scrollTop"] = -c),
                        !0
                    );
                }
                return (
                    0 === t
                        ? (n.setTransition(0),
                          n.setTranslate(c),
                          a && (n.emit("beforeTransitionStart", t, i), n.emit("transitionEnd")))
                        : (n.setTransition(t),
                          n.setTranslate(c),
                          a && (n.emit("beforeTransitionStart", t, i), n.emit("transitionStart")),
                          n.animating ||
                              ((n.animating = !0),
                              n.onTranslateToWrapperTransitionEnd ||
                                  (n.onTranslateToWrapperTransitionEnd = function (e) {
                                      n &&
                                          !n.destroyed &&
                                          e.target === this &&
                                          (n.$wrapperEl[0].removeEventListener(
                                              "transitionend",
                                              n.onTranslateToWrapperTransitionEnd
                                          ),
                                          n.$wrapperEl[0].removeEventListener(
                                              "webkitTransitionEnd",
                                              n.onTranslateToWrapperTransitionEnd
                                          ),
                                          (n.onTranslateToWrapperTransitionEnd = null),
                                          delete n.onTranslateToWrapperTransitionEnd,
                                          a && n.emit("transitionEnd"));
                                  }),
                              n.$wrapperEl[0].addEventListener("transitionend", n.onTranslateToWrapperTransitionEnd),
                              n.$wrapperEl[0].addEventListener(
                                  "webkitTransitionEnd",
                                  n.onTranslateToWrapperTransitionEnd
                              ))),
                    !0
                );
            },
        };
        var v = {
            setTransition: function (e, t) {
                const a = this;
                a.params.cssMode || a.$wrapperEl.transition(e), a.emit("setTransition", e, t);
            },
            transitionStart: function (e = !0, t) {
                const a = this,
                    { activeIndex: s, params: i, previousIndex: n } = a;
                if (i.cssMode) return;
                i.autoHeight && a.updateAutoHeight();
                let r = t;
                if ((r || (r = s > n ? "next" : s < n ? "prev" : "reset"), a.emit("transitionStart"), e && s !== n)) {
                    if ("reset" === r) return void a.emit("slideResetTransitionStart");
                    a.emit("slideChangeTransitionStart"),
                        "next" === r ? a.emit("slideNextTransitionStart") : a.emit("slidePrevTransitionStart");
                }
            },
            transitionEnd: function (e = !0, t) {
                const a = this,
                    { activeIndex: s, previousIndex: i, params: n } = a;
                if (((a.animating = !1), n.cssMode)) return;
                a.setTransition(0);
                let r = t;
                if ((r || (r = s > i ? "next" : s < i ? "prev" : "reset"), a.emit("transitionEnd"), e && s !== i)) {
                    if ("reset" === r) return void a.emit("slideResetTransitionEnd");
                    a.emit("slideChangeTransitionEnd"),
                        "next" === r ? a.emit("slideNextTransitionEnd") : a.emit("slidePrevTransitionEnd");
                }
            },
        };
        var b = {
            slideTo: function (e = 0, t = this.params.speed, a = !0, s) {
                const i = this;
                let n = e;
                n < 0 && (n = 0);
                const {
                    params: r,
                    snapGrid: o,
                    slidesGrid: l,
                    previousIndex: d,
                    activeIndex: c,
                    rtlTranslate: u,
                    wrapperEl: p,
                } = i;
                if (i.animating && r.preventInteractionOnTransition) return !1;
                const h = Math.min(i.params.slidesPerGroupSkip, n);
                let m = h + Math.floor((n - h) / i.params.slidesPerGroup);
                m >= o.length && (m = o.length - 1),
                    (c || r.initialSlide || 0) === (d || 0) && a && i.emit("beforeSlideChangeStart");
                const f = -o[m];
                if ((i.updateProgress(f), r.normalizeSlideIndex))
                    for (let e = 0; e < l.length; e += 1) -Math.floor(100 * f) >= Math.floor(100 * l[e]) && (n = e);
                if (i.initialized && n !== c) {
                    if (!i.allowSlideNext && f < i.translate && f < i.minTranslate()) return !1;
                    if (!i.allowSlidePrev && f > i.translate && f > i.maxTranslate() && (c || 0) !== n) return !1;
                }
                let g;
                if (
                    ((g = n > c ? "next" : n < c ? "prev" : "reset"),
                    (u && -f === i.translate) || (!u && f === i.translate))
                )
                    return (
                        i.updateActiveIndex(n),
                        r.autoHeight && i.updateAutoHeight(),
                        i.updateSlidesClasses(),
                        "slide" !== r.effect && i.setTranslate(f),
                        "reset" !== g && (i.transitionStart(a, g), i.transitionEnd(a, g)),
                        !1
                    );
                if (r.cssMode) {
                    const e = i.isHorizontal();
                    let a = -f;
                    return (
                        u && (a = p.scrollWidth - p.offsetWidth - a),
                        0 === t
                            ? (p[e ? "scrollLeft" : "scrollTop"] = a)
                            : p.scrollTo
                              ? p.scrollTo({ [e ? "left" : "top"]: a, behavior: "smooth" })
                              : (p[e ? "scrollLeft" : "scrollTop"] = a),
                        !0
                    );
                }
                return (
                    0 === t
                        ? (i.setTransition(0),
                          i.setTranslate(f),
                          i.updateActiveIndex(n),
                          i.updateSlidesClasses(),
                          i.emit("beforeTransitionStart", t, s),
                          i.transitionStart(a, g),
                          i.transitionEnd(a, g))
                        : (i.setTransition(t),
                          i.setTranslate(f),
                          i.updateActiveIndex(n),
                          i.updateSlidesClasses(),
                          i.emit("beforeTransitionStart", t, s),
                          i.transitionStart(a, g),
                          i.animating ||
                              ((i.animating = !0),
                              i.onSlideToWrapperTransitionEnd ||
                                  (i.onSlideToWrapperTransitionEnd = function (e) {
                                      i &&
                                          !i.destroyed &&
                                          e.target === this &&
                                          (i.$wrapperEl[0].removeEventListener(
                                              "transitionend",
                                              i.onSlideToWrapperTransitionEnd
                                          ),
                                          i.$wrapperEl[0].removeEventListener(
                                              "webkitTransitionEnd",
                                              i.onSlideToWrapperTransitionEnd
                                          ),
                                          (i.onSlideToWrapperTransitionEnd = null),
                                          delete i.onSlideToWrapperTransitionEnd,
                                          i.transitionEnd(a, g));
                                  }),
                              i.$wrapperEl[0].addEventListener("transitionend", i.onSlideToWrapperTransitionEnd),
                              i.$wrapperEl[0].addEventListener(
                                  "webkitTransitionEnd",
                                  i.onSlideToWrapperTransitionEnd
                              ))),
                    !0
                );
            },
            slideToLoop: function (e = 0, t = this.params.speed, a = !0, s) {
                const i = this;
                let n = e;
                return i.params.loop && (n += i.loopedSlides), i.slideTo(n, t, a, s);
            },
            slideNext: function (e = this.params.speed, t = !0, a) {
                const s = this,
                    { params: i, animating: n } = s,
                    r = s.activeIndex < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup;
                if (i.loop) {
                    if (n) return !1;
                    s.loopFix(), (s._clientLeft = s.$wrapperEl[0].clientLeft);
                }
                return s.slideTo(s.activeIndex + r, e, t, a);
            },
            slidePrev: function (e = this.params.speed, t = !0, a) {
                const s = this,
                    { params: i, animating: n, snapGrid: r, slidesGrid: o, rtlTranslate: l } = s;
                if (i.loop) {
                    if (n) return !1;
                    s.loopFix(), (s._clientLeft = s.$wrapperEl[0].clientLeft);
                }
                function d(e) {
                    return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
                }
                const c = d(l ? s.translate : -s.translate),
                    u = r.map((e) => d(e));
                o.map((e) => d(e)), r[u.indexOf(c)];
                let p,
                    h = r[u.indexOf(c) - 1];
                return (
                    void 0 === h &&
                        i.cssMode &&
                        r.forEach((e) => {
                            !h && c >= e && (h = e);
                        }),
                    void 0 !== h && ((p = o.indexOf(h)), p < 0 && (p = s.activeIndex - 1)),
                    s.slideTo(p, e, t, a)
                );
            },
            slideReset: function (e = this.params.speed, t = !0, a) {
                return this.slideTo(this.activeIndex, e, t, a);
            },
            slideToClosest: function (e = this.params.speed, t = !0, a, s = 0.5) {
                const i = this;
                let n = i.activeIndex;
                const r = Math.min(i.params.slidesPerGroupSkip, n),
                    o = r + Math.floor((n - r) / i.params.slidesPerGroup),
                    l = i.rtlTranslate ? i.translate : -i.translate;
                if (l >= i.snapGrid[o]) {
                    const e = i.snapGrid[o];
                    l - e > (i.snapGrid[o + 1] - e) * s && (n += i.params.slidesPerGroup);
                } else {
                    const e = i.snapGrid[o - 1];
                    l - e <= (i.snapGrid[o] - e) * s && (n -= i.params.slidesPerGroup);
                }
                return (n = Math.max(n, 0)), (n = Math.min(n, i.slidesGrid.length - 1)), i.slideTo(n, e, t, a);
            },
            slideToClickedSlide: function () {
                const e = this,
                    { params: t, $wrapperEl: a } = e,
                    s = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
                let i,
                    n = e.clickedIndex;
                if (t.loop) {
                    if (e.animating) return;
                    (i = parseInt(d(e.clickedSlide).attr("data-swiper-slide-index"), 10)),
                        t.centeredSlides
                            ? n < e.loopedSlides - s / 2 || n > e.slides.length - e.loopedSlides + s / 2
                                ? (e.loopFix(),
                                  (n = a
                                      .children(
                                          `.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`
                                      )
                                      .eq(0)
                                      .index()),
                                  p.nextTick(() => {
                                      e.slideTo(n);
                                  }))
                                : e.slideTo(n)
                            : n > e.slides.length - s
                              ? (e.loopFix(),
                                (n = a
                                    .children(
                                        `.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`
                                    )
                                    .eq(0)
                                    .index()),
                                p.nextTick(() => {
                                    e.slideTo(n);
                                }))
                              : e.slideTo(n);
                } else e.slideTo(n);
            },
        };
        var y = {
            loopCreate: function () {
                const e = this,
                    { params: t, $wrapperEl: a } = e;
                a.children(`.${t.slideClass}.${t.slideDuplicateClass}`).remove();
                let s = a.children("." + t.slideClass);
                if (t.loopFillGroupWithBlank) {
                    const e = t.slidesPerGroup - (s.length % t.slidesPerGroup);
                    if (e !== t.slidesPerGroup) {
                        for (let s = 0; s < e; s += 1) {
                            const e = d(n.createElement("div")).addClass(`${t.slideClass} ${t.slideBlankClass}`);
                            a.append(e);
                        }
                        s = a.children("." + t.slideClass);
                    }
                }
                "auto" !== t.slidesPerView || t.loopedSlides || (t.loopedSlides = s.length),
                    (e.loopedSlides = Math.ceil(parseFloat(t.loopedSlides || t.slidesPerView, 10))),
                    (e.loopedSlides += t.loopAdditionalSlides),
                    e.loopedSlides > s.length && (e.loopedSlides = s.length);
                const i = [],
                    r = [];
                s.each((t, a) => {
                    const n = d(a);
                    t < e.loopedSlides && r.push(a),
                        t < s.length && t >= s.length - e.loopedSlides && i.push(a),
                        n.attr("data-swiper-slide-index", t);
                });
                for (let e = 0; e < r.length; e += 1) a.append(d(r[e].cloneNode(!0)).addClass(t.slideDuplicateClass));
                for (let e = i.length - 1; e >= 0; e -= 1)
                    a.prepend(d(i[e].cloneNode(!0)).addClass(t.slideDuplicateClass));
            },
            loopFix: function () {
                const e = this;
                e.emit("beforeLoopFix");
                const {
                    activeIndex: t,
                    slides: a,
                    loopedSlides: s,
                    allowSlidePrev: i,
                    allowSlideNext: n,
                    snapGrid: r,
                    rtlTranslate: o,
                } = e;
                let l;
                (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
                const d = -r[t] - e.getTranslate();
                if (t < s) {
                    (l = a.length - 3 * s + t), (l += s);
                    e.slideTo(l, 0, !1, !0) && 0 !== d && e.setTranslate((o ? -e.translate : e.translate) - d);
                } else if (t >= a.length - s) {
                    (l = -a.length + t + s), (l += s);
                    e.slideTo(l, 0, !1, !0) && 0 !== d && e.setTranslate((o ? -e.translate : e.translate) - d);
                }
                (e.allowSlidePrev = i), (e.allowSlideNext = n), e.emit("loopFix");
            },
            loopDestroy: function () {
                const { $wrapperEl: e, params: t, slides: a } = this;
                e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(),
                    a.removeAttr("data-swiper-slide-index");
            },
        };
        var w = {
            setGrabCursor: function (e) {
                if (
                    h.touch ||
                    !this.params.simulateTouch ||
                    (this.params.watchOverflow && this.isLocked) ||
                    this.params.cssMode
                )
                    return;
                const t = this.el;
                (t.style.cursor = "move"),
                    (t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
                    (t.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
                    (t.style.cursor = e ? "grabbing" : "grab");
            },
            unsetGrabCursor: function () {
                h.touch ||
                    (this.params.watchOverflow && this.isLocked) ||
                    this.params.cssMode ||
                    (this.el.style.cursor = "");
            },
        };
        var S = {
            appendSlide: function (e) {
                const t = this,
                    { $wrapperEl: a, params: s } = t;
                if ((s.loop && t.loopDestroy(), "object" == typeof e && "length" in e))
                    for (let t = 0; t < e.length; t += 1) e[t] && a.append(e[t]);
                else a.append(e);
                s.loop && t.loopCreate(), (s.observer && h.observer) || t.update();
            },
            prependSlide: function (e) {
                const t = this,
                    { params: a, $wrapperEl: s, activeIndex: i } = t;
                a.loop && t.loopDestroy();
                let n = i + 1;
                if ("object" == typeof e && "length" in e) {
                    for (let t = 0; t < e.length; t += 1) e[t] && s.prepend(e[t]);
                    n = i + e.length;
                } else s.prepend(e);
                a.loop && t.loopCreate(), (a.observer && h.observer) || t.update(), t.slideTo(n, 0, !1);
            },
            addSlide: function (e, t) {
                const a = this,
                    { $wrapperEl: s, params: i, activeIndex: n } = a;
                let r = n;
                i.loop && ((r -= a.loopedSlides), a.loopDestroy(), (a.slides = s.children("." + i.slideClass)));
                const o = a.slides.length;
                if (e <= 0) return void a.prependSlide(t);
                if (e >= o) return void a.appendSlide(t);
                let l = r > e ? r + 1 : r;
                const d = [];
                for (let t = o - 1; t >= e; t -= 1) {
                    const e = a.slides.eq(t);
                    e.remove(), d.unshift(e);
                }
                if ("object" == typeof t && "length" in t) {
                    for (let e = 0; e < t.length; e += 1) t[e] && s.append(t[e]);
                    l = r > e ? r + t.length : r;
                } else s.append(t);
                for (let e = 0; e < d.length; e += 1) s.append(d[e]);
                i.loop && a.loopCreate(),
                    (i.observer && h.observer) || a.update(),
                    i.loop ? a.slideTo(l + a.loopedSlides, 0, !1) : a.slideTo(l, 0, !1);
            },
            removeSlide: function (e) {
                const t = this,
                    { params: a, $wrapperEl: s, activeIndex: i } = t;
                let n = i;
                a.loop && ((n -= t.loopedSlides), t.loopDestroy(), (t.slides = s.children("." + a.slideClass)));
                let r,
                    o = n;
                if ("object" == typeof e && "length" in e) {
                    for (let a = 0; a < e.length; a += 1)
                        (r = e[a]), t.slides[r] && t.slides.eq(r).remove(), r < o && (o -= 1);
                    o = Math.max(o, 0);
                } else (r = e), t.slides[r] && t.slides.eq(r).remove(), r < o && (o -= 1), (o = Math.max(o, 0));
                a.loop && t.loopCreate(),
                    (a.observer && h.observer) || t.update(),
                    a.loop ? t.slideTo(o + t.loopedSlides, 0, !1) : t.slideTo(o, 0, !1);
            },
            removeAllSlides: function () {
                const e = this,
                    t = [];
                for (let a = 0; a < e.slides.length; a += 1) t.push(a);
                e.removeSlide(t);
            },
        };
        const x = (function () {
            const e = o.navigator.platform,
                t = o.navigator.userAgent,
                a = {
                    ios: !1,
                    android: !1,
                    androidChrome: !1,
                    desktop: !1,
                    iphone: !1,
                    ipod: !1,
                    ipad: !1,
                    edge: !1,
                    ie: !1,
                    firefox: !1,
                    macos: !1,
                    windows: !1,
                    cordova: !(!o.cordova && !o.phonegap),
                    phonegap: !(!o.cordova && !o.phonegap),
                    electron: !1,
                },
                s = o.screen.width,
                i = o.screen.height,
                n = t.match(/(Android);?[\s\/]+([\d.]+)?/);
            let r = t.match(/(iPad).*OS\s([\d_]+)/);
            const l = t.match(/(iPod)(.*OS\s([\d_]+))?/),
                d = !r && t.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                c = t.indexOf("MSIE ") >= 0 || t.indexOf("Trident/") >= 0,
                u = t.indexOf("Edge/") >= 0,
                p = t.indexOf("Gecko/") >= 0 && t.indexOf("Firefox/") >= 0,
                m = "Win32" === e,
                f = t.toLowerCase().indexOf("electron") >= 0;
            let g = "MacIntel" === e;
            return (
                !r &&
                    g &&
                    h.touch &&
                    ((1024 === s && 1366 === i) ||
                        (834 === s && 1194 === i) ||
                        (834 === s && 1112 === i) ||
                        (768 === s && 1024 === i)) &&
                    ((r = t.match(/(Version)\/([\d.]+)/)), (g = !1)),
                (a.ie = c),
                (a.edge = u),
                (a.firefox = p),
                n &&
                    !m &&
                    ((a.os = "android"),
                    (a.osVersion = n[2]),
                    (a.android = !0),
                    (a.androidChrome = t.toLowerCase().indexOf("chrome") >= 0)),
                (r || d || l) && ((a.os = "ios"), (a.ios = !0)),
                d && !l && ((a.osVersion = d[2].replace(/_/g, ".")), (a.iphone = !0)),
                r && ((a.osVersion = r[2].replace(/_/g, ".")), (a.ipad = !0)),
                l && ((a.osVersion = l[3] ? l[3].replace(/_/g, ".") : null), (a.ipod = !0)),
                a.ios &&
                    a.osVersion &&
                    t.indexOf("Version/") >= 0 &&
                    "10" === a.osVersion.split(".")[0] &&
                    (a.osVersion = t.toLowerCase().split("version/")[1].split(" ")[0]),
                (a.webView =
                    !(!(d || r || l) || (!t.match(/.*AppleWebKit(?!.*Safari)/i) && !o.navigator.standalone)) ||
                    (o.matchMedia && o.matchMedia("(display-mode: standalone)").matches)),
                (a.webview = a.webView),
                (a.standalone = a.webView),
                (a.desktop = !(a.ios || a.android) || f),
                a.desktop &&
                    ((a.electron = f),
                    (a.macos = g),
                    (a.windows = m),
                    a.macos && (a.os = "macos"),
                    a.windows && (a.os = "windows")),
                (a.pixelRatio = o.devicePixelRatio || 1),
                a
            );
        })();
        function E(e) {
            const t = this,
                a = t.touchEventsData,
                { params: s, touches: i } = t;
            if (t.animating && s.preventInteractionOnTransition) return;
            let r = e;
            r.originalEvent && (r = r.originalEvent);
            const l = d(r.target);
            if ("wrapper" === s.touchEventsTarget && !l.closest(t.wrapperEl).length) return;
            if (((a.isTouchEvent = "touchstart" === r.type), !a.isTouchEvent && "which" in r && 3 === r.which)) return;
            if (!a.isTouchEvent && "button" in r && r.button > 0) return;
            if (a.isTouched && a.isMoved) return;
            if (s.noSwiping && l.closest(s.noSwipingSelector ? s.noSwipingSelector : "." + s.noSwipingClass)[0])
                return void (t.allowClick = !0);
            if (s.swipeHandler && !l.closest(s.swipeHandler)[0]) return;
            (i.currentX = "touchstart" === r.type ? r.targetTouches[0].pageX : r.pageX),
                (i.currentY = "touchstart" === r.type ? r.targetTouches[0].pageY : r.pageY);
            const c = i.currentX,
                u = i.currentY,
                h = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection,
                m = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold;
            if (!h || !(c <= m || c >= o.screen.width - m)) {
                if (
                    (p.extend(a, {
                        isTouched: !0,
                        isMoved: !1,
                        allowTouchCallbacks: !0,
                        isScrolling: void 0,
                        startMoving: void 0,
                    }),
                    (i.startX = c),
                    (i.startY = u),
                    (a.touchStartTime = p.now()),
                    (t.allowClick = !0),
                    t.updateSize(),
                    (t.swipeDirection = void 0),
                    s.threshold > 0 && (a.allowThresholdMove = !1),
                    "touchstart" !== r.type)
                ) {
                    let e = !0;
                    l.is(a.formElements) && (e = !1),
                        n.activeElement &&
                            d(n.activeElement).is(a.formElements) &&
                            n.activeElement !== l[0] &&
                            n.activeElement.blur();
                    const i = e && t.allowTouchMove && s.touchStartPreventDefault;
                    (s.touchStartForcePreventDefault || i) && r.preventDefault();
                }
                t.emit("touchStart", r);
            }
        }
        function T(e) {
            const t = this,
                a = t.touchEventsData,
                { params: s, touches: i, rtlTranslate: r } = t;
            let o = e;
            if ((o.originalEvent && (o = o.originalEvent), !a.isTouched))
                return void (a.startMoving && a.isScrolling && t.emit("touchMoveOpposite", o));
            if (a.isTouchEvent && "touchmove" !== o.type) return;
            const l = "touchmove" === o.type && o.targetTouches && (o.targetTouches[0] || o.changedTouches[0]),
                c = "touchmove" === o.type ? l.pageX : o.pageX,
                u = "touchmove" === o.type ? l.pageY : o.pageY;
            if (o.preventedByNestedSwiper) return (i.startX = c), void (i.startY = u);
            if (!t.allowTouchMove)
                return (
                    (t.allowClick = !1),
                    void (
                        a.isTouched &&
                        (p.extend(i, { startX: c, startY: u, currentX: c, currentY: u }), (a.touchStartTime = p.now()))
                    )
                );
            if (a.isTouchEvent && s.touchReleaseOnEdges && !s.loop)
                if (t.isVertical()) {
                    if (
                        (u < i.startY && t.translate <= t.maxTranslate()) ||
                        (u > i.startY && t.translate >= t.minTranslate())
                    )
                        return (a.isTouched = !1), void (a.isMoved = !1);
                } else if (
                    (c < i.startX && t.translate <= t.maxTranslate()) ||
                    (c > i.startX && t.translate >= t.minTranslate())
                )
                    return;
            if (a.isTouchEvent && n.activeElement && o.target === n.activeElement && d(o.target).is(a.formElements))
                return (a.isMoved = !0), void (t.allowClick = !1);
            if ((a.allowTouchCallbacks && t.emit("touchMove", o), o.targetTouches && o.targetTouches.length > 1))
                return;
            (i.currentX = c), (i.currentY = u);
            const h = i.currentX - i.startX,
                m = i.currentY - i.startY;
            if (t.params.threshold && Math.sqrt(h ** 2 + m ** 2) < t.params.threshold) return;
            if (void 0 === a.isScrolling) {
                let e;
                (t.isHorizontal() && i.currentY === i.startY) || (t.isVertical() && i.currentX === i.startX)
                    ? (a.isScrolling = !1)
                    : h * h + m * m >= 25 &&
                      ((e = (180 * Math.atan2(Math.abs(m), Math.abs(h))) / Math.PI),
                      (a.isScrolling = t.isHorizontal() ? e > s.touchAngle : 90 - e > s.touchAngle));
            }
            if (
                (a.isScrolling && t.emit("touchMoveOpposite", o),
                void 0 === a.startMoving &&
                    ((i.currentX === i.startX && i.currentY === i.startY) || (a.startMoving = !0)),
                a.isScrolling)
            )
                return void (a.isTouched = !1);
            if (!a.startMoving) return;
            (t.allowClick = !1),
                !s.cssMode && o.cancelable && o.preventDefault(),
                s.touchMoveStopPropagation && !s.nested && o.stopPropagation(),
                a.isMoved ||
                    (s.loop && t.loopFix(),
                    (a.startTranslate = t.getTranslate()),
                    t.setTransition(0),
                    t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                    (a.allowMomentumBounce = !1),
                    !s.grabCursor || (!0 !== t.allowSlideNext && !0 !== t.allowSlidePrev) || t.setGrabCursor(!0),
                    t.emit("sliderFirstMove", o)),
                t.emit("sliderMove", o),
                (a.isMoved = !0);
            let f = t.isHorizontal() ? h : m;
            (i.diff = f),
                (f *= s.touchRatio),
                r && (f = -f),
                (t.swipeDirection = f > 0 ? "prev" : "next"),
                (a.currentTranslate = f + a.startTranslate);
            let g = !0,
                v = s.resistanceRatio;
            if (
                (s.touchReleaseOnEdges && (v = 0),
                f > 0 && a.currentTranslate > t.minTranslate()
                    ? ((g = !1),
                      s.resistance &&
                          (a.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + a.startTranslate + f) ** v))
                    : f < 0 &&
                      a.currentTranslate < t.maxTranslate() &&
                      ((g = !1),
                      s.resistance &&
                          (a.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - a.startTranslate - f) ** v)),
                g && (o.preventedByNestedSwiper = !0),
                !t.allowSlideNext &&
                    "next" === t.swipeDirection &&
                    a.currentTranslate < a.startTranslate &&
                    (a.currentTranslate = a.startTranslate),
                !t.allowSlidePrev &&
                    "prev" === t.swipeDirection &&
                    a.currentTranslate > a.startTranslate &&
                    (a.currentTranslate = a.startTranslate),
                s.threshold > 0)
            ) {
                if (!(Math.abs(f) > s.threshold || a.allowThresholdMove))
                    return void (a.currentTranslate = a.startTranslate);
                if (!a.allowThresholdMove)
                    return (
                        (a.allowThresholdMove = !0),
                        (i.startX = i.currentX),
                        (i.startY = i.currentY),
                        (a.currentTranslate = a.startTranslate),
                        void (i.diff = t.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY)
                    );
            }
            s.followFinger &&
                !s.cssMode &&
                ((s.freeMode || s.watchSlidesProgress || s.watchSlidesVisibility) &&
                    (t.updateActiveIndex(), t.updateSlidesClasses()),
                s.freeMode &&
                    (0 === a.velocities.length &&
                        a.velocities.push({
                            position: i[t.isHorizontal() ? "startX" : "startY"],
                            time: a.touchStartTime,
                        }),
                    a.velocities.push({ position: i[t.isHorizontal() ? "currentX" : "currentY"], time: p.now() })),
                t.updateProgress(a.currentTranslate),
                t.setTranslate(a.currentTranslate));
        }
        function C(e) {
            const t = this,
                a = t.touchEventsData,
                { params: s, touches: i, rtlTranslate: n, $wrapperEl: r, slidesGrid: o, snapGrid: l } = t;
            let d = e;
            if (
                (d.originalEvent && (d = d.originalEvent),
                a.allowTouchCallbacks && t.emit("touchEnd", d),
                (a.allowTouchCallbacks = !1),
                !a.isTouched)
            )
                return a.isMoved && s.grabCursor && t.setGrabCursor(!1), (a.isMoved = !1), void (a.startMoving = !1);
            s.grabCursor &&
                a.isMoved &&
                a.isTouched &&
                (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
                t.setGrabCursor(!1);
            const c = p.now(),
                u = c - a.touchStartTime;
            if (
                (t.allowClick &&
                    (t.updateClickedSlide(d),
                    t.emit("tap click", d),
                    u < 300 && c - a.lastClickTime < 300 && t.emit("doubleTap doubleClick", d)),
                (a.lastClickTime = p.now()),
                p.nextTick(() => {
                    t.destroyed || (t.allowClick = !0);
                }),
                !a.isTouched ||
                    !a.isMoved ||
                    !t.swipeDirection ||
                    0 === i.diff ||
                    a.currentTranslate === a.startTranslate)
            )
                return (a.isTouched = !1), (a.isMoved = !1), void (a.startMoving = !1);
            let h;
            if (
                ((a.isTouched = !1),
                (a.isMoved = !1),
                (a.startMoving = !1),
                (h = s.followFinger ? (n ? t.translate : -t.translate) : -a.currentTranslate),
                s.cssMode)
            )
                return;
            if (s.freeMode) {
                if (h < -t.minTranslate()) return void t.slideTo(t.activeIndex);
                if (h > -t.maxTranslate())
                    return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
                if (s.freeModeMomentum) {
                    if (a.velocities.length > 1) {
                        const e = a.velocities.pop(),
                            i = a.velocities.pop(),
                            n = e.position - i.position,
                            r = e.time - i.time;
                        (t.velocity = n / r),
                            (t.velocity /= 2),
                            Math.abs(t.velocity) < s.freeModeMinimumVelocity && (t.velocity = 0),
                            (r > 150 || p.now() - e.time > 300) && (t.velocity = 0);
                    } else t.velocity = 0;
                    (t.velocity *= s.freeModeMomentumVelocityRatio), (a.velocities.length = 0);
                    let e = 1e3 * s.freeModeMomentumRatio;
                    const i = t.velocity * e;
                    let o = t.translate + i;
                    n && (o = -o);
                    let d,
                        c = !1;
                    const u = 20 * Math.abs(t.velocity) * s.freeModeMomentumBounceRatio;
                    let h;
                    if (o < t.maxTranslate())
                        s.freeModeMomentumBounce
                            ? (o + t.maxTranslate() < -u && (o = t.maxTranslate() - u),
                              (d = t.maxTranslate()),
                              (c = !0),
                              (a.allowMomentumBounce = !0))
                            : (o = t.maxTranslate()),
                            s.loop && s.centeredSlides && (h = !0);
                    else if (o > t.minTranslate())
                        s.freeModeMomentumBounce
                            ? (o - t.minTranslate() > u && (o = t.minTranslate() + u),
                              (d = t.minTranslate()),
                              (c = !0),
                              (a.allowMomentumBounce = !0))
                            : (o = t.minTranslate()),
                            s.loop && s.centeredSlides && (h = !0);
                    else if (s.freeModeSticky) {
                        let e;
                        for (let t = 0; t < l.length; t += 1)
                            if (l[t] > -o) {
                                e = t;
                                break;
                            }
                        (o =
                            Math.abs(l[e] - o) < Math.abs(l[e - 1] - o) || "next" === t.swipeDirection
                                ? l[e]
                                : l[e - 1]),
                            (o = -o);
                    }
                    if (
                        (h &&
                            t.once("transitionEnd", () => {
                                t.loopFix();
                            }),
                        0 !== t.velocity)
                    ) {
                        if (
                            ((e = n
                                ? Math.abs((-o - t.translate) / t.velocity)
                                : Math.abs((o - t.translate) / t.velocity)),
                            s.freeModeSticky)
                        ) {
                            const a = Math.abs((n ? -o : o) - t.translate),
                                i = t.slidesSizesGrid[t.activeIndex];
                            e = a < i ? s.speed : a < 2 * i ? 1.5 * s.speed : 2.5 * s.speed;
                        }
                    } else if (s.freeModeSticky) return void t.slideToClosest();
                    s.freeModeMomentumBounce && c
                        ? (t.updateProgress(d),
                          t.setTransition(e),
                          t.setTranslate(o),
                          t.transitionStart(!0, t.swipeDirection),
                          (t.animating = !0),
                          r.transitionEnd(() => {
                              t &&
                                  !t.destroyed &&
                                  a.allowMomentumBounce &&
                                  (t.emit("momentumBounce"),
                                  t.setTransition(s.speed),
                                  setTimeout(() => {
                                      t.setTranslate(d),
                                          r.transitionEnd(() => {
                                              t && !t.destroyed && t.transitionEnd();
                                          });
                                  }, 0));
                          }))
                        : t.velocity
                          ? (t.updateProgress(o),
                            t.setTransition(e),
                            t.setTranslate(o),
                            t.transitionStart(!0, t.swipeDirection),
                            t.animating ||
                                ((t.animating = !0),
                                r.transitionEnd(() => {
                                    t && !t.destroyed && t.transitionEnd();
                                })))
                          : t.updateProgress(o),
                        t.updateActiveIndex(),
                        t.updateSlidesClasses();
                } else if (s.freeModeSticky) return void t.slideToClosest();
                return void (
                    (!s.freeModeMomentum || u >= s.longSwipesMs) &&
                    (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses())
                );
            }
            let m = 0,
                f = t.slidesSizesGrid[0];
            for (let e = 0; e < o.length; e += e < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
                const t = e < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
                void 0 !== o[e + t]
                    ? h >= o[e] && h < o[e + t] && ((m = e), (f = o[e + t] - o[e]))
                    : h >= o[e] && ((m = e), (f = o[o.length - 1] - o[o.length - 2]));
            }
            const g = (h - o[m]) / f,
                v = m < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
            if (u > s.longSwipesMs) {
                if (!s.longSwipes) return void t.slideTo(t.activeIndex);
                "next" === t.swipeDirection && (g >= s.longSwipesRatio ? t.slideTo(m + v) : t.slideTo(m)),
                    "prev" === t.swipeDirection && (g > 1 - s.longSwipesRatio ? t.slideTo(m + v) : t.slideTo(m));
            } else {
                if (!s.shortSwipes) return void t.slideTo(t.activeIndex);
                t.navigation && (d.target === t.navigation.nextEl || d.target === t.navigation.prevEl)
                    ? d.target === t.navigation.nextEl
                        ? t.slideTo(m + v)
                        : t.slideTo(m)
                    : ("next" === t.swipeDirection && t.slideTo(m + v), "prev" === t.swipeDirection && t.slideTo(m));
            }
        }
        function M() {
            const e = this,
                { params: t, el: a } = e;
            if (a && 0 === a.offsetWidth) return;
            t.breakpoints && e.setBreakpoint();
            const { allowSlideNext: s, allowSlidePrev: i, snapGrid: n } = e;
            (e.allowSlideNext = !0),
                (e.allowSlidePrev = !0),
                e.updateSize(),
                e.updateSlides(),
                e.updateSlidesClasses(),
                ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
                e.isEnd &&
                !e.isBeginning &&
                !e.params.centeredSlides
                    ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                    : e.slideTo(e.activeIndex, 0, !1, !0),
                e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
                (e.allowSlidePrev = i),
                (e.allowSlideNext = s),
                e.params.watchOverflow && n !== e.snapGrid && e.checkOverflow();
        }
        function L(e) {
            const t = this;
            t.allowClick ||
                (t.params.preventClicks && e.preventDefault(),
                t.params.preventClicksPropagation &&
                    t.animating &&
                    (e.stopPropagation(), e.stopImmediatePropagation()));
        }
        function $() {
            const e = this,
                { wrapperEl: t, rtlTranslate: a } = e;
            let s;
            (e.previousTranslate = e.translate),
                e.isHorizontal()
                    ? (e.translate = a ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft)
                    : (e.translate = -t.scrollTop),
                -0 === e.translate && (e.translate = 0),
                e.updateActiveIndex(),
                e.updateSlidesClasses();
            const i = e.maxTranslate() - e.minTranslate();
            (s = 0 === i ? 0 : (e.translate - e.minTranslate()) / i),
                s !== e.progress && e.updateProgress(a ? -e.translate : e.translate),
                e.emit("setTranslate", e.translate, !1);
        }
        let k = !1;
        function P() {}
        var z = {
            init: !0,
            direction: "horizontal",
            touchEventsTarget: "container",
            initialSlide: 0,
            speed: 300,
            cssMode: !1,
            updateOnWindowResize: !0,
            preventInteractionOnTransition: !1,
            edgeSwipeDetection: !1,
            edgeSwipeThreshold: 20,
            freeMode: !1,
            freeModeMomentum: !0,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: !0,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: !1,
            freeModeMinimumVelocity: 0.02,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: "slide",
            breakpoints: void 0,
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: "column",
            slidesPerGroup: 1,
            slidesPerGroupSkip: 0,
            centeredSlides: !1,
            centeredSlidesBounds: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            normalizeSlideIndex: !0,
            centerInsufficientSlides: !1,
            watchOverflow: !1,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: !0,
            allowTouchMove: !0,
            threshold: 0,
            touchMoveStopPropagation: !1,
            touchStartPreventDefault: !0,
            touchStartForcePreventDefault: !1,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            resistance: !0,
            resistanceRatio: 0.85,
            watchSlidesProgress: !1,
            watchSlidesVisibility: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            preloadImages: !0,
            updateOnImagesReady: !0,
            loop: !1,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            loopFillGroupWithBlank: !1,
            allowSlidePrev: !0,
            allowSlideNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: "swiper-no-swiping",
            noSwipingSelector: null,
            passiveListeners: !0,
            containerModifierClass: "swiper-container-",
            slideClass: "swiper-slide",
            slideBlankClass: "swiper-slide-invisible-blank",
            slideActiveClass: "swiper-slide-active",
            slideDuplicateActiveClass: "swiper-slide-duplicate-active",
            slideVisibleClass: "swiper-slide-visible",
            slideDuplicateClass: "swiper-slide-duplicate",
            slideNextClass: "swiper-slide-next",
            slideDuplicateNextClass: "swiper-slide-duplicate-next",
            slidePrevClass: "swiper-slide-prev",
            slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
            wrapperClass: "swiper-wrapper",
            runCallbacksOnInit: !0,
        };
        const q = {
                update: f,
                translate: g,
                transition: v,
                slide: b,
                loop: y,
                grabCursor: w,
                manipulation: S,
                events: {
                    attachEvents: function () {
                        const e = this,
                            { params: t, touchEvents: a, el: s, wrapperEl: i } = e;
                        (e.onTouchStart = E.bind(e)),
                            (e.onTouchMove = T.bind(e)),
                            (e.onTouchEnd = C.bind(e)),
                            t.cssMode && (e.onScroll = $.bind(e)),
                            (e.onClick = L.bind(e));
                        const r = !!t.nested;
                        if (!h.touch && h.pointerEvents)
                            s.addEventListener(a.start, e.onTouchStart, !1),
                                n.addEventListener(a.move, e.onTouchMove, r),
                                n.addEventListener(a.end, e.onTouchEnd, !1);
                        else {
                            if (h.touch) {
                                const i = !("touchstart" !== a.start || !h.passiveListener || !t.passiveListeners) && {
                                    passive: !0,
                                    capture: !1,
                                };
                                s.addEventListener(a.start, e.onTouchStart, i),
                                    s.addEventListener(
                                        a.move,
                                        e.onTouchMove,
                                        h.passiveListener ? { passive: !1, capture: r } : r
                                    ),
                                    s.addEventListener(a.end, e.onTouchEnd, i),
                                    a.cancel && s.addEventListener(a.cancel, e.onTouchEnd, i),
                                    k || (n.addEventListener("touchstart", P), (k = !0));
                            }
                            ((t.simulateTouch && !x.ios && !x.android) || (t.simulateTouch && !h.touch && x.ios)) &&
                                (s.addEventListener("mousedown", e.onTouchStart, !1),
                                n.addEventListener("mousemove", e.onTouchMove, r),
                                n.addEventListener("mouseup", e.onTouchEnd, !1));
                        }
                        (t.preventClicks || t.preventClicksPropagation) && s.addEventListener("click", e.onClick, !0),
                            t.cssMode && i.addEventListener("scroll", e.onScroll),
                            t.updateOnWindowResize
                                ? e.on(
                                      x.ios || x.android
                                          ? "resize orientationchange observerUpdate"
                                          : "resize observerUpdate",
                                      M,
                                      !0
                                  )
                                : e.on("observerUpdate", M, !0);
                    },
                    detachEvents: function () {
                        const e = this,
                            { params: t, touchEvents: a, el: s, wrapperEl: i } = e,
                            r = !!t.nested;
                        if (!h.touch && h.pointerEvents)
                            s.removeEventListener(a.start, e.onTouchStart, !1),
                                n.removeEventListener(a.move, e.onTouchMove, r),
                                n.removeEventListener(a.end, e.onTouchEnd, !1);
                        else {
                            if (h.touch) {
                                const i = !(
                                    "onTouchStart" !== a.start ||
                                    !h.passiveListener ||
                                    !t.passiveListeners
                                ) && { passive: !0, capture: !1 };
                                s.removeEventListener(a.start, e.onTouchStart, i),
                                    s.removeEventListener(a.move, e.onTouchMove, r),
                                    s.removeEventListener(a.end, e.onTouchEnd, i),
                                    a.cancel && s.removeEventListener(a.cancel, e.onTouchEnd, i);
                            }
                            ((t.simulateTouch && !x.ios && !x.android) || (t.simulateTouch && !h.touch && x.ios)) &&
                                (s.removeEventListener("mousedown", e.onTouchStart, !1),
                                n.removeEventListener("mousemove", e.onTouchMove, r),
                                n.removeEventListener("mouseup", e.onTouchEnd, !1));
                        }
                        (t.preventClicks || t.preventClicksPropagation) &&
                            s.removeEventListener("click", e.onClick, !0),
                            t.cssMode && i.removeEventListener("scroll", e.onScroll),
                            e.off(
                                x.ios || x.android
                                    ? "resize orientationchange observerUpdate"
                                    : "resize observerUpdate",
                                M
                            );
                    },
                },
                breakpoints: {
                    setBreakpoint: function () {
                        const e = this,
                            { activeIndex: t, initialized: a, loopedSlides: s = 0, params: i, $el: n } = e,
                            r = i.breakpoints;
                        if (!r || (r && 0 === Object.keys(r).length)) return;
                        const o = e.getBreakpoint(r);
                        if (o && e.currentBreakpoint !== o) {
                            const l = o in r ? r[o] : void 0;
                            l &&
                                [
                                    "slidesPerView",
                                    "spaceBetween",
                                    "slidesPerGroup",
                                    "slidesPerGroupSkip",
                                    "slidesPerColumn",
                                ].forEach((e) => {
                                    const t = l[e];
                                    void 0 !== t &&
                                        (l[e] =
                                            "slidesPerView" !== e || ("AUTO" !== t && "auto" !== t)
                                                ? "slidesPerView" === e
                                                    ? parseFloat(t)
                                                    : parseInt(t, 10)
                                                : "auto");
                                });
                            const d = l || e.originalParams,
                                c = i.slidesPerColumn > 1,
                                u = d.slidesPerColumn > 1;
                            c && !u
                                ? n.removeClass(
                                      `${i.containerModifierClass}multirow ${i.containerModifierClass}multirow-column`
                                  )
                                : !c &&
                                  u &&
                                  (n.addClass(i.containerModifierClass + "multirow"),
                                  "column" === d.slidesPerColumnFill &&
                                      n.addClass(i.containerModifierClass + "multirow-column"));
                            const h = d.direction && d.direction !== i.direction,
                                m = i.loop && (d.slidesPerView !== i.slidesPerView || h);
                            h && a && e.changeDirection(),
                                p.extend(e.params, d),
                                p.extend(e, {
                                    allowTouchMove: e.params.allowTouchMove,
                                    allowSlideNext: e.params.allowSlideNext,
                                    allowSlidePrev: e.params.allowSlidePrev,
                                }),
                                (e.currentBreakpoint = o),
                                m &&
                                    a &&
                                    (e.loopDestroy(),
                                    e.loopCreate(),
                                    e.updateSlides(),
                                    e.slideTo(t - s + e.loopedSlides, 0, !1)),
                                e.emit("breakpoint", d);
                        }
                    },
                    getBreakpoint: function (e) {
                        if (!e) return;
                        let t = !1;
                        const a = Object.keys(e).map((e) => {
                            if ("string" == typeof e && 0 === e.indexOf("@")) {
                                const t = parseFloat(e.substr(1));
                                return { value: o.innerHeight * t, point: e };
                            }
                            return { value: e, point: e };
                        });
                        a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
                        for (let e = 0; e < a.length; e += 1) {
                            const { point: s, value: i } = a[e];
                            i <= o.innerWidth && (t = s);
                        }
                        return t || "max";
                    },
                },
                checkOverflow: {
                    checkOverflow: function () {
                        const e = this,
                            t = e.params,
                            a = e.isLocked,
                            s =
                                e.slides.length > 0 &&
                                t.slidesOffsetBefore +
                                    t.spaceBetween * (e.slides.length - 1) +
                                    e.slides[0].offsetWidth * e.slides.length;
                        t.slidesOffsetBefore && t.slidesOffsetAfter && s
                            ? (e.isLocked = s <= e.size)
                            : (e.isLocked = 1 === e.snapGrid.length),
                            (e.allowSlideNext = !e.isLocked),
                            (e.allowSlidePrev = !e.isLocked),
                            a !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
                            a && a !== e.isLocked && ((e.isEnd = !1), e.navigation && e.navigation.update());
                    },
                },
                classes: {
                    addClasses: function () {
                        const { classNames: e, params: t, rtl: a, $el: s } = this,
                            i = [];
                        i.push("initialized"),
                            i.push(t.direction),
                            t.freeMode && i.push("free-mode"),
                            t.autoHeight && i.push("autoheight"),
                            a && i.push("rtl"),
                            t.slidesPerColumn > 1 &&
                                (i.push("multirow"), "column" === t.slidesPerColumnFill && i.push("multirow-column")),
                            x.android && i.push("android"),
                            x.ios && i.push("ios"),
                            t.cssMode && i.push("css-mode"),
                            i.forEach((a) => {
                                e.push(t.containerModifierClass + a);
                            }),
                            s.addClass(e.join(" "));
                    },
                    removeClasses: function () {
                        const { $el: e, classNames: t } = this;
                        e.removeClass(t.join(" "));
                    },
                },
                images: {
                    loadImage: function (e, t, a, s, i, n) {
                        let r;
                        function l() {
                            n && n();
                        }
                        d(e).parent("picture")[0] || (e.complete && i)
                            ? l()
                            : t
                              ? ((r = new o.Image()),
                                (r.onload = l),
                                (r.onerror = l),
                                s && (r.sizes = s),
                                a && (r.srcset = a),
                                t && (r.src = t))
                              : l();
                    },
                    preloadImages: function () {
                        const e = this;
                        function t() {
                            null != e &&
                                e &&
                                !e.destroyed &&
                                (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                                e.imagesLoaded === e.imagesToLoad.length &&
                                    (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
                        }
                        e.imagesToLoad = e.$el.find("img");
                        for (let a = 0; a < e.imagesToLoad.length; a += 1) {
                            const s = e.imagesToLoad[a];
                            e.loadImage(
                                s,
                                s.currentSrc || s.getAttribute("src"),
                                s.srcset || s.getAttribute("srcset"),
                                s.sizes || s.getAttribute("sizes"),
                                !0,
                                t
                            );
                        }
                    },
                },
            },
            O = {};
        class A extends m {
            constructor(...e) {
                let t, a;
                1 === e.length && e[0].constructor && e[0].constructor === Object ? (a = e[0]) : ([t, a] = e),
                    a || (a = {}),
                    (a = p.extend({}, a)),
                    t && !a.el && (a.el = t),
                    super(a),
                    Object.keys(q).forEach((e) => {
                        Object.keys(q[e]).forEach((t) => {
                            A.prototype[t] || (A.prototype[t] = q[e][t]);
                        });
                    });
                const s = this;
                void 0 === s.modules && (s.modules = {}),
                    Object.keys(s.modules).forEach((e) => {
                        const t = s.modules[e];
                        if (t.params) {
                            const e = Object.keys(t.params)[0],
                                s = t.params[e];
                            if ("object" != typeof s || null === s) return;
                            if (!(e in a) || !("enabled" in s)) return;
                            !0 === a[e] && (a[e] = { enabled: !0 }),
                                "object" != typeof a[e] || "enabled" in a[e] || (a[e].enabled = !0),
                                a[e] || (a[e] = { enabled: !1 });
                        }
                    });
                const i = p.extend({}, z);
                s.useModulesParams(i),
                    (s.params = p.extend({}, i, O, a)),
                    (s.originalParams = p.extend({}, s.params)),
                    (s.passedParams = p.extend({}, a)),
                    (s.$ = d);
                const n = d(s.params.el);
                if (((t = n[0]), !t)) return;
                if (n.length > 1) {
                    const e = [];
                    return (
                        n.each((t, s) => {
                            const i = p.extend({}, a, { el: s });
                            e.push(new A(i));
                        }),
                        e
                    );
                }
                let r;
                return (
                    (t.swiper = s),
                    n.data("swiper", s),
                    t && t.shadowRoot && t.shadowRoot.querySelector
                        ? ((r = d(t.shadowRoot.querySelector("." + s.params.wrapperClass))),
                          (r.children = (e) => n.children(e)))
                        : (r = n.children("." + s.params.wrapperClass)),
                    p.extend(s, {
                        $el: n,
                        el: t,
                        $wrapperEl: r,
                        wrapperEl: r[0],
                        classNames: [],
                        slides: d(),
                        slidesGrid: [],
                        snapGrid: [],
                        slidesSizesGrid: [],
                        isHorizontal: () => "horizontal" === s.params.direction,
                        isVertical: () => "vertical" === s.params.direction,
                        rtl: "rtl" === t.dir.toLowerCase() || "rtl" === n.css("direction"),
                        rtlTranslate:
                            "horizontal" === s.params.direction &&
                            ("rtl" === t.dir.toLowerCase() || "rtl" === n.css("direction")),
                        wrongRTL: "-webkit-box" === r.css("display"),
                        activeIndex: 0,
                        realIndex: 0,
                        isBeginning: !0,
                        isEnd: !1,
                        translate: 0,
                        previousTranslate: 0,
                        progress: 0,
                        velocity: 0,
                        animating: !1,
                        allowSlideNext: s.params.allowSlideNext,
                        allowSlidePrev: s.params.allowSlidePrev,
                        touchEvents: (function () {
                            const e = ["touchstart", "touchmove", "touchend", "touchcancel"];
                            let t = ["mousedown", "mousemove", "mouseup"];
                            return (
                                h.pointerEvents && (t = ["pointerdown", "pointermove", "pointerup"]),
                                (s.touchEventsTouch = { start: e[0], move: e[1], end: e[2], cancel: e[3] }),
                                (s.touchEventsDesktop = { start: t[0], move: t[1], end: t[2] }),
                                h.touch || !s.params.simulateTouch ? s.touchEventsTouch : s.touchEventsDesktop
                            );
                        })(),
                        touchEventsData: {
                            isTouched: void 0,
                            isMoved: void 0,
                            allowTouchCallbacks: void 0,
                            touchStartTime: void 0,
                            isScrolling: void 0,
                            currentTranslate: void 0,
                            startTranslate: void 0,
                            allowThresholdMove: void 0,
                            formElements: "input, select, option, textarea, button, video, label",
                            lastClickTime: p.now(),
                            clickTimeout: void 0,
                            velocities: [],
                            allowMomentumBounce: void 0,
                            isTouchEvent: void 0,
                            startMoving: void 0,
                        },
                        allowClick: !0,
                        allowTouchMove: s.params.allowTouchMove,
                        touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                        imagesToLoad: [],
                        imagesLoaded: 0,
                    }),
                    s.useModules(),
                    s.params.init && s.init(),
                    s
                );
            }
            slidesPerViewDynamic() {
                const { params: e, slides: t, slidesGrid: a, size: s, activeIndex: i } = this;
                let n = 1;
                if (e.centeredSlides) {
                    let e,
                        a = t[i].swiperSlideSize;
                    for (let r = i + 1; r < t.length; r += 1)
                        t[r] && !e && ((a += t[r].swiperSlideSize), (n += 1), a > s && (e = !0));
                    for (let r = i - 1; r >= 0; r -= 1)
                        t[r] && !e && ((a += t[r].swiperSlideSize), (n += 1), a > s && (e = !0));
                } else for (let e = i + 1; e < t.length; e += 1) a[e] - a[i] < s && (n += 1);
                return n;
            }
            update() {
                const e = this;
                if (!e || e.destroyed) return;
                const { snapGrid: t, params: a } = e;
                function s() {
                    const t = e.rtlTranslate ? -1 * e.translate : e.translate,
                        a = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                    e.setTranslate(a), e.updateActiveIndex(), e.updateSlidesClasses();
                }
                let i;
                a.breakpoints && e.setBreakpoint(),
                    e.updateSize(),
                    e.updateSlides(),
                    e.updateProgress(),
                    e.updateSlidesClasses(),
                    e.params.freeMode
                        ? (s(), e.params.autoHeight && e.updateAutoHeight())
                        : ((i =
                              ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) &&
                              e.isEnd &&
                              !e.params.centeredSlides
                                  ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                                  : e.slideTo(e.activeIndex, 0, !1, !0)),
                          i || s()),
                    a.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                    e.emit("update");
            }
            changeDirection(e, t = !0) {
                const a = this,
                    s = a.params.direction;
                return (
                    e || (e = "horizontal" === s ? "vertical" : "horizontal"),
                    e === s ||
                        ("horizontal" !== e && "vertical" !== e) ||
                        (a.$el
                            .removeClass(`${a.params.containerModifierClass}${s}`)
                            .addClass(`${a.params.containerModifierClass}${e}`),
                        (a.params.direction = e),
                        a.slides.each((t, a) => {
                            "vertical" === e ? (a.style.width = "") : (a.style.height = "");
                        }),
                        a.emit("changeDirection"),
                        t && a.update()),
                    a
                );
            }
            init() {
                const e = this;
                e.initialized ||
                    (e.emit("beforeInit"),
                    e.params.breakpoints && e.setBreakpoint(),
                    e.addClasses(),
                    e.params.loop && e.loopCreate(),
                    e.updateSize(),
                    e.updateSlides(),
                    e.params.watchOverflow && e.checkOverflow(),
                    e.params.grabCursor && e.setGrabCursor(),
                    e.params.preloadImages && e.preloadImages(),
                    e.params.loop
                        ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit)
                        : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit),
                    e.attachEvents(),
                    (e.initialized = !0),
                    e.emit("init"));
            }
            destroy(e = !0, t = !0) {
                const a = this,
                    { params: s, $el: i, $wrapperEl: n, slides: r } = a;
                return (
                    void 0 === a.params ||
                        a.destroyed ||
                        (a.emit("beforeDestroy"),
                        (a.initialized = !1),
                        a.detachEvents(),
                        s.loop && a.loopDestroy(),
                        t &&
                            (a.removeClasses(),
                            i.removeAttr("style"),
                            n.removeAttr("style"),
                            r &&
                                r.length &&
                                r
                                    .removeClass(
                                        [
                                            s.slideVisibleClass,
                                            s.slideActiveClass,
                                            s.slideNextClass,
                                            s.slidePrevClass,
                                        ].join(" ")
                                    )
                                    .removeAttr("style")
                                    .removeAttr("data-swiper-slide-index")),
                        a.emit("destroy"),
                        Object.keys(a.eventsListeners).forEach((e) => {
                            a.off(e);
                        }),
                        !1 !== e && ((a.$el[0].swiper = null), a.$el.data("swiper", null), p.deleteProps(a)),
                        (a.destroyed = !0)),
                    null
                );
            }
            static extendDefaults(e) {
                p.extend(O, e);
            }
            static get extendedDefaults() {
                return O;
            }
            static get defaults() {
                return z;
            }
            static get Class() {
                return m;
            }
            static get $() {
                return d;
            }
        }
        var I = { name: "device", proto: { device: x }, static: { device: x } },
            D = { name: "support", proto: { support: h }, static: { support: h } };
        const H = {
            isEdge: !!o.navigator.userAgent.match(/Edge/g),
            isSafari: (function () {
                const e = o.navigator.userAgent.toLowerCase();
                return e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0;
            })(),
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(o.navigator.userAgent),
        };
        var N = { name: "browser", proto: { browser: H }, static: { browser: H } },
            j = {
                name: "resize",
                create() {
                    const e = this;
                    p.extend(e, {
                        resize: {
                            resizeHandler() {
                                e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"));
                            },
                            orientationChangeHandler() {
                                e && !e.destroyed && e.initialized && e.emit("orientationchange");
                            },
                        },
                    });
                },
                on: {
                    init() {
                        o.addEventListener("resize", this.resize.resizeHandler),
                            o.addEventListener("orientationchange", this.resize.orientationChangeHandler);
                    },
                    destroy() {
                        o.removeEventListener("resize", this.resize.resizeHandler),
                            o.removeEventListener("orientationchange", this.resize.orientationChangeHandler);
                    },
                },
            };
        const G = {
            func: o.MutationObserver || o.WebkitMutationObserver,
            attach(e, t = {}) {
                const a = this,
                    s = new (0, G.func)((e) => {
                        if (1 === e.length) return void a.emit("observerUpdate", e[0]);
                        const t = function () {
                            a.emit("observerUpdate", e[0]);
                        };
                        o.requestAnimationFrame ? o.requestAnimationFrame(t) : o.setTimeout(t, 0);
                    });
                s.observe(e, {
                    attributes: void 0 === t.attributes || t.attributes,
                    childList: void 0 === t.childList || t.childList,
                    characterData: void 0 === t.characterData || t.characterData,
                }),
                    a.observer.observers.push(s);
            },
            init() {
                const e = this;
                if (h.observer && e.params.observer) {
                    if (e.params.observeParents) {
                        const t = e.$el.parents();
                        for (let a = 0; a < t.length; a += 1) e.observer.attach(t[a]);
                    }
                    e.observer.attach(e.$el[0], { childList: e.params.observeSlideChildren }),
                        e.observer.attach(e.$wrapperEl[0], { attributes: !1 });
                }
            },
            destroy() {
                this.observer.observers.forEach((e) => {
                    e.disconnect();
                }),
                    (this.observer.observers = []);
            },
        };
        var B = {
            name: "observer",
            params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
            create() {
                p.extend(this, {
                    observer: {
                        init: G.init.bind(this),
                        attach: G.attach.bind(this),
                        destroy: G.destroy.bind(this),
                        observers: [],
                    },
                });
            },
            on: {
                init() {
                    this.observer.init();
                },
                destroy() {
                    this.observer.destroy();
                },
            },
        };
        const _ = {
            update(e) {
                const t = this,
                    { slidesPerView: a, slidesPerGroup: s, centeredSlides: i } = t.params,
                    { addSlidesBefore: n, addSlidesAfter: r } = t.params.virtual,
                    { from: o, to: l, slides: d, slidesGrid: c, renderSlide: u, offset: h } = t.virtual;
                t.updateActiveIndex();
                const m = t.activeIndex || 0;
                let f, g, v;
                (f = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top"),
                    i
                        ? ((g = Math.floor(a / 2) + s + n), (v = Math.floor(a / 2) + s + r))
                        : ((g = a + (s - 1) + n), (v = s + r));
                const b = Math.max((m || 0) - v, 0),
                    y = Math.min((m || 0) + g, d.length - 1),
                    w = (t.slidesGrid[b] || 0) - (t.slidesGrid[0] || 0);
                function S() {
                    t.updateSlides(),
                        t.updateProgress(),
                        t.updateSlidesClasses(),
                        t.lazy && t.params.lazy.enabled && t.lazy.load();
                }
                if (
                    (p.extend(t.virtual, { from: b, to: y, offset: w, slidesGrid: t.slidesGrid }),
                    o === b && l === y && !e)
                )
                    return t.slidesGrid !== c && w !== h && t.slides.css(f, w + "px"), void t.updateProgress();
                if (t.params.virtual.renderExternal)
                    return (
                        t.params.virtual.renderExternal.call(t, {
                            offset: w,
                            from: b,
                            to: y,
                            slides: (function () {
                                const e = [];
                                for (let t = b; t <= y; t += 1) e.push(d[t]);
                                return e;
                            })(),
                        }),
                        void S()
                    );
                const x = [],
                    E = [];
                if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();
                else
                    for (let e = o; e <= l; e += 1)
                        (e < b || e > y) &&
                            t.$wrapperEl.find(`.${t.params.slideClass}[data-swiper-slide-index="${e}"]`).remove();
                for (let t = 0; t < d.length; t += 1)
                    t >= b && t <= y && (void 0 === l || e ? E.push(t) : (t > l && E.push(t), t < o && x.push(t)));
                E.forEach((e) => {
                    t.$wrapperEl.append(u(d[e], e));
                }),
                    x
                        .sort((e, t) => t - e)
                        .forEach((e) => {
                            t.$wrapperEl.prepend(u(d[e], e));
                        }),
                    t.$wrapperEl.children(".swiper-slide").css(f, w + "px"),
                    S();
            },
            renderSlide(e, t) {
                const a = this,
                    s = a.params.virtual;
                if (s.cache && a.virtual.cache[t]) return a.virtual.cache[t];
                const i = s.renderSlide
                    ? d(s.renderSlide.call(a, e, t))
                    : d(`<div class="${a.params.slideClass}" data-swiper-slide-index="${t}">${e}</div>`);
                return (
                    i.attr("data-swiper-slide-index") || i.attr("data-swiper-slide-index", t),
                    s.cache && (a.virtual.cache[t] = i),
                    i
                );
            },
            appendSlide(e) {
                const t = this;
                if ("object" == typeof e && "length" in e)
                    for (let a = 0; a < e.length; a += 1) e[a] && t.virtual.slides.push(e[a]);
                else t.virtual.slides.push(e);
                t.virtual.update(!0);
            },
            prependSlide(e) {
                const t = this,
                    a = t.activeIndex;
                let s = a + 1,
                    i = 1;
                if (Array.isArray(e)) {
                    for (let a = 0; a < e.length; a += 1) e[a] && t.virtual.slides.unshift(e[a]);
                    (s = a + e.length), (i = e.length);
                } else t.virtual.slides.unshift(e);
                if (t.params.virtual.cache) {
                    const e = t.virtual.cache,
                        a = {};
                    Object.keys(e).forEach((t) => {
                        const s = e[t],
                            n = s.attr("data-swiper-slide-index");
                        n && s.attr("data-swiper-slide-index", parseInt(n, 10) + 1), (a[parseInt(t, 10) + i] = s);
                    }),
                        (t.virtual.cache = a);
                }
                t.virtual.update(!0), t.slideTo(s, 0);
            },
            removeSlide(e) {
                const t = this;
                if (null == e) return;
                let a = t.activeIndex;
                if (Array.isArray(e))
                    for (let s = e.length - 1; s >= 0; s -= 1)
                        t.virtual.slides.splice(e[s], 1),
                            t.params.virtual.cache && delete t.virtual.cache[e[s]],
                            e[s] < a && (a -= 1),
                            (a = Math.max(a, 0));
                else
                    t.virtual.slides.splice(e, 1),
                        t.params.virtual.cache && delete t.virtual.cache[e],
                        e < a && (a -= 1),
                        (a = Math.max(a, 0));
                t.virtual.update(!0), t.slideTo(a, 0);
            },
            removeAllSlides() {
                const e = this;
                (e.virtual.slides = []),
                    e.params.virtual.cache && (e.virtual.cache = {}),
                    e.virtual.update(!0),
                    e.slideTo(0, 0);
            },
        };
        var X = {
            name: "virtual",
            params: {
                virtual: {
                    enabled: !1,
                    slides: [],
                    cache: !0,
                    renderSlide: null,
                    renderExternal: null,
                    addSlidesBefore: 0,
                    addSlidesAfter: 0,
                },
            },
            create() {
                p.extend(this, {
                    virtual: {
                        update: _.update.bind(this),
                        appendSlide: _.appendSlide.bind(this),
                        prependSlide: _.prependSlide.bind(this),
                        removeSlide: _.removeSlide.bind(this),
                        removeAllSlides: _.removeAllSlides.bind(this),
                        renderSlide: _.renderSlide.bind(this),
                        slides: this.params.virtual.slides,
                        cache: {},
                    },
                });
            },
            on: {
                beforeInit() {
                    const e = this;
                    if (!e.params.virtual.enabled) return;
                    e.classNames.push(e.params.containerModifierClass + "virtual");
                    const t = { watchSlidesProgress: !0 };
                    p.extend(e.params, t), p.extend(e.originalParams, t), e.params.initialSlide || e.virtual.update();
                },
                setTranslate() {
                    this.params.virtual.enabled && this.virtual.update();
                },
            },
        };
        const R = {
            handle(e) {
                const t = this,
                    { rtlTranslate: a } = t;
                let s = e;
                s.originalEvent && (s = s.originalEvent);
                const i = s.keyCode || s.charCode,
                    r = t.params.keyboard.pageUpDown,
                    l = r && 33 === i,
                    d = r && 34 === i,
                    c = 37 === i,
                    u = 39 === i,
                    p = 38 === i,
                    h = 40 === i;
                if (!t.allowSlideNext && ((t.isHorizontal() && u) || (t.isVertical() && h) || d)) return !1;
                if (!t.allowSlidePrev && ((t.isHorizontal() && c) || (t.isVertical() && p) || l)) return !1;
                if (
                    !(
                        s.shiftKey ||
                        s.altKey ||
                        s.ctrlKey ||
                        s.metaKey ||
                        (n.activeElement &&
                            n.activeElement.nodeName &&
                            ("input" === n.activeElement.nodeName.toLowerCase() ||
                                "textarea" === n.activeElement.nodeName.toLowerCase()))
                    )
                ) {
                    if (t.params.keyboard.onlyInViewport && (l || d || c || u || p || h)) {
                        let e = !1;
                        if (
                            t.$el.parents("." + t.params.slideClass).length > 0 &&
                            0 === t.$el.parents("." + t.params.slideActiveClass).length
                        )
                            return;
                        const s = o.innerWidth,
                            i = o.innerHeight,
                            n = t.$el.offset();
                        a && (n.left -= t.$el[0].scrollLeft);
                        const r = [
                            [n.left, n.top],
                            [n.left + t.width, n.top],
                            [n.left, n.top + t.height],
                            [n.left + t.width, n.top + t.height],
                        ];
                        for (let t = 0; t < r.length; t += 1) {
                            const a = r[t];
                            a[0] >= 0 && a[0] <= s && a[1] >= 0 && a[1] <= i && (e = !0);
                        }
                        if (!e) return;
                    }
                    t.isHorizontal()
                        ? ((l || d || c || u) && (s.preventDefault ? s.preventDefault() : (s.returnValue = !1)),
                          (((d || u) && !a) || ((l || c) && a)) && t.slideNext(),
                          (((l || c) && !a) || ((d || u) && a)) && t.slidePrev())
                        : ((l || d || p || h) && (s.preventDefault ? s.preventDefault() : (s.returnValue = !1)),
                          (d || h) && t.slideNext(),
                          (l || p) && t.slidePrev()),
                        t.emit("keyPress", i);
                }
            },
            enable() {
                this.keyboard.enabled || (d(n).on("keydown", this.keyboard.handle), (this.keyboard.enabled = !0));
            },
            disable() {
                this.keyboard.enabled && (d(n).off("keydown", this.keyboard.handle), (this.keyboard.enabled = !1));
            },
        };
        var F = {
            name: "keyboard",
            params: { keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } },
            create() {
                p.extend(this, {
                    keyboard: {
                        enabled: !1,
                        enable: R.enable.bind(this),
                        disable: R.disable.bind(this),
                        handle: R.handle.bind(this),
                    },
                });
            },
            on: {
                init() {
                    const e = this;
                    e.params.keyboard.enabled && e.keyboard.enable();
                },
                destroy() {
                    const e = this;
                    e.keyboard.enabled && e.keyboard.disable();
                },
            },
        };
        const V = {
            lastScrollTime: p.now(),
            lastEventBeforeSnap: void 0,
            recentWheelEvents: [],
            event: () =>
                o.navigator.userAgent.indexOf("firefox") > -1
                    ? "DOMMouseScroll"
                    : (function () {
                            let e = "onwheel" in n;
                            if (!e) {
                                const t = n.createElement("div");
                                t.setAttribute("onwheel", "return;"), (e = "function" == typeof t.onwheel);
                            }
                            return (
                                !e &&
                                    n.implementation &&
                                    n.implementation.hasFeature &&
                                    !0 !== n.implementation.hasFeature("", "") &&
                                    (e = n.implementation.hasFeature("Events.wheel", "3.0")),
                                e
                            );
                        })()
                      ? "wheel"
                      : "mousewheel",
            normalize(e) {
                let t = 0,
                    a = 0,
                    s = 0,
                    i = 0;
                return (
                    "detail" in e && (a = e.detail),
                    "wheelDelta" in e && (a = -e.wheelDelta / 120),
                    "wheelDeltaY" in e && (a = -e.wheelDeltaY / 120),
                    "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                    "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = a), (a = 0)),
                    (s = 10 * t),
                    (i = 10 * a),
                    "deltaY" in e && (i = e.deltaY),
                    "deltaX" in e && (s = e.deltaX),
                    e.shiftKey && !s && ((s = i), (i = 0)),
                    (s || i) && e.deltaMode && (1 === e.deltaMode ? ((s *= 40), (i *= 40)) : ((s *= 800), (i *= 800))),
                    s && !t && (t = s < 1 ? -1 : 1),
                    i && !a && (a = i < 1 ? -1 : 1),
                    { spinX: t, spinY: a, pixelX: s, pixelY: i }
                );
            },
            handleMouseEnter() {
                this.mouseEntered = !0;
            },
            handleMouseLeave() {
                this.mouseEntered = !1;
            },
            handle(e) {
                let t = e;
                const a = this,
                    s = a.params.mousewheel;
                a.params.cssMode && t.preventDefault();
                let i = a.$el;
                if (
                    ("container" !== a.params.mousewheel.eventsTarged && (i = d(a.params.mousewheel.eventsTarged)),
                    !a.mouseEntered && !i[0].contains(t.target) && !s.releaseOnEdges)
                )
                    return !0;
                t.originalEvent && (t = t.originalEvent);
                let n = 0;
                const r = a.rtlTranslate ? -1 : 1,
                    o = V.normalize(t);
                if (s.forceToAxis)
                    if (a.isHorizontal()) {
                        if (!(Math.abs(o.pixelX) > Math.abs(o.pixelY))) return !0;
                        n = -o.pixelX * r;
                    } else {
                        if (!(Math.abs(o.pixelY) > Math.abs(o.pixelX))) return !0;
                        n = -o.pixelY;
                    }
                else n = Math.abs(o.pixelX) > Math.abs(o.pixelY) ? -o.pixelX * r : -o.pixelY;
                if (0 === n) return !0;
                if ((s.invert && (n = -n), a.params.freeMode)) {
                    const e = { time: p.now(), delta: Math.abs(n), direction: Math.sign(n) },
                        { lastEventBeforeSnap: i } = a.mousewheel,
                        r = i && e.time < i.time + 500 && e.delta <= i.delta && e.direction === i.direction;
                    if (!r) {
                        (a.mousewheel.lastEventBeforeSnap = void 0), a.params.loop && a.loopFix();
                        let i = a.getTranslate() + n * s.sensitivity;
                        const o = a.isBeginning,
                            l = a.isEnd;
                        if (
                            (i >= a.minTranslate() && (i = a.minTranslate()),
                            i <= a.maxTranslate() && (i = a.maxTranslate()),
                            a.setTransition(0),
                            a.setTranslate(i),
                            a.updateProgress(),
                            a.updateActiveIndex(),
                            a.updateSlidesClasses(),
                            ((!o && a.isBeginning) || (!l && a.isEnd)) && a.updateSlidesClasses(),
                            a.params.freeModeSticky)
                        ) {
                            clearTimeout(a.mousewheel.timeout), (a.mousewheel.timeout = void 0);
                            const t = a.mousewheel.recentWheelEvents;
                            t.length >= 15 && t.shift();
                            const s = t.length ? t[t.length - 1] : void 0,
                                i = t[0];
                            if ((t.push(e), s && (e.delta > s.delta || e.direction !== s.direction))) t.splice(0);
                            else if (
                                t.length >= 15 &&
                                e.time - i.time < 500 &&
                                i.delta - e.delta >= 1 &&
                                e.delta <= 6
                            ) {
                                const s = n > 0 ? 0.8 : 0.2;
                                (a.mousewheel.lastEventBeforeSnap = e),
                                    t.splice(0),
                                    (a.mousewheel.timeout = p.nextTick(() => {
                                        a.slideToClosest(a.params.speed, !0, void 0, s);
                                    }, 0));
                            }
                            a.mousewheel.timeout ||
                                (a.mousewheel.timeout = p.nextTick(() => {
                                    (a.mousewheel.lastEventBeforeSnap = e),
                                        t.splice(0),
                                        a.slideToClosest(a.params.speed, !0, void 0, 0.5);
                                }, 500));
                        }
                        if (
                            (r || a.emit("scroll", t),
                            a.params.autoplay && a.params.autoplayDisableOnInteraction && a.autoplay.stop(),
                            i === a.minTranslate() || i === a.maxTranslate())
                        )
                            return !0;
                    }
                } else {
                    const t = { time: p.now(), delta: Math.abs(n), direction: Math.sign(n), raw: e },
                        s = a.mousewheel.recentWheelEvents;
                    s.length >= 2 && s.shift();
                    const i = s.length ? s[s.length - 1] : void 0;
                    if (
                        (s.push(t),
                        i
                            ? (t.direction !== i.direction || t.delta > i.delta || t.time > i.time + 150) &&
                              a.mousewheel.animateSlider(t)
                            : a.mousewheel.animateSlider(t),
                        a.mousewheel.releaseScroll(t))
                    )
                        return !0;
                }
                return t.preventDefault ? t.preventDefault() : (t.returnValue = !1), !1;
            },
            animateSlider(e) {
                const t = this;
                return (
                    (e.delta >= 6 && p.now() - t.mousewheel.lastScrollTime < 60) ||
                    (e.direction < 0
                        ? (t.isEnd && !t.params.loop) || t.animating || (t.slideNext(), t.emit("scroll", e.raw))
                        : (t.isBeginning && !t.params.loop) || t.animating || (t.slidePrev(), t.emit("scroll", e.raw)),
                    (t.mousewheel.lastScrollTime = new o.Date().getTime()),
                    !1)
                );
            },
            releaseScroll(e) {
                const t = this,
                    a = t.params.mousewheel;
                if (e.direction < 0) {
                    if (t.isEnd && !t.params.loop && a.releaseOnEdges) return !0;
                } else if (t.isBeginning && !t.params.loop && a.releaseOnEdges) return !0;
                return !1;
            },
            enable() {
                const e = this,
                    t = V.event();
                if (e.params.cssMode) return e.wrapperEl.removeEventListener(t, e.mousewheel.handle), !0;
                if (!t) return !1;
                if (e.mousewheel.enabled) return !1;
                let a = e.$el;
                return (
                    "container" !== e.params.mousewheel.eventsTarged && (a = d(e.params.mousewheel.eventsTarged)),
                    a.on("mouseenter", e.mousewheel.handleMouseEnter),
                    a.on("mouseleave", e.mousewheel.handleMouseLeave),
                    a.on(t, e.mousewheel.handle),
                    (e.mousewheel.enabled = !0),
                    !0
                );
            },
            disable() {
                const e = this,
                    t = V.event();
                if (e.params.cssMode) return e.wrapperEl.addEventListener(t, e.mousewheel.handle), !0;
                if (!t) return !1;
                if (!e.mousewheel.enabled) return !1;
                let a = e.$el;
                return (
                    "container" !== e.params.mousewheel.eventsTarged && (a = d(e.params.mousewheel.eventsTarged)),
                    a.off(t, e.mousewheel.handle),
                    (e.mousewheel.enabled = !1),
                    !0
                );
            },
        };
        const Y = {
            update() {
                const e = this,
                    t = e.params.navigation;
                if (e.params.loop) return;
                const { $nextEl: a, $prevEl: s } = e.navigation;
                s &&
                    s.length > 0 &&
                    (e.isBeginning ? s.addClass(t.disabledClass) : s.removeClass(t.disabledClass),
                    s[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)),
                    a &&
                        a.length > 0 &&
                        (e.isEnd ? a.addClass(t.disabledClass) : a.removeClass(t.disabledClass),
                        a[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass));
            },
            onPrevClick(e) {
                e.preventDefault(), (this.isBeginning && !this.params.loop) || this.slidePrev();
            },
            onNextClick(e) {
                e.preventDefault(), (this.isEnd && !this.params.loop) || this.slideNext();
            },
            init() {
                const e = this,
                    t = e.params.navigation;
                if (!t.nextEl && !t.prevEl) return;
                let a, s;
                t.nextEl &&
                    ((a = d(t.nextEl)),
                    e.params.uniqueNavElements &&
                        "string" == typeof t.nextEl &&
                        a.length > 1 &&
                        1 === e.$el.find(t.nextEl).length &&
                        (a = e.$el.find(t.nextEl))),
                    t.prevEl &&
                        ((s = d(t.prevEl)),
                        e.params.uniqueNavElements &&
                            "string" == typeof t.prevEl &&
                            s.length > 1 &&
                            1 === e.$el.find(t.prevEl).length &&
                            (s = e.$el.find(t.prevEl))),
                    a && a.length > 0 && a.on("click", e.navigation.onNextClick),
                    s && s.length > 0 && s.on("click", e.navigation.onPrevClick),
                    p.extend(e.navigation, { $nextEl: a, nextEl: a && a[0], $prevEl: s, prevEl: s && s[0] });
            },
            destroy() {
                const e = this,
                    { $nextEl: t, $prevEl: a } = e.navigation;
                t &&
                    t.length &&
                    (t.off("click", e.navigation.onNextClick), t.removeClass(e.params.navigation.disabledClass)),
                    a &&
                        a.length &&
                        (a.off("click", e.navigation.onPrevClick), a.removeClass(e.params.navigation.disabledClass));
            },
        };
        const W = {
            update() {
                const e = this,
                    t = e.rtl,
                    a = e.params.pagination;
                if (!a.el || !e.pagination.el || !e.pagination.$el || 0 === e.pagination.$el.length) return;
                const s = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    i = e.pagination.$el;
                let n;
                const r = e.params.loop
                    ? Math.ceil((s - 2 * e.loopedSlides) / e.params.slidesPerGroup)
                    : e.snapGrid.length;
                if (
                    (e.params.loop
                        ? ((n = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)),
                          n > s - 1 - 2 * e.loopedSlides && (n -= s - 2 * e.loopedSlides),
                          n > r - 1 && (n -= r),
                          n < 0 && "bullets" !== e.params.paginationType && (n = r + n))
                        : (n = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
                    "bullets" === a.type && e.pagination.bullets && e.pagination.bullets.length > 0)
                ) {
                    const s = e.pagination.bullets;
                    let r, o, l;
                    if (
                        (a.dynamicBullets &&
                            ((e.pagination.bulletSize = s.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                            i.css(
                                e.isHorizontal() ? "width" : "height",
                                e.pagination.bulletSize * (a.dynamicMainBullets + 4) + "px"
                            ),
                            a.dynamicMainBullets > 1 &&
                                void 0 !== e.previousIndex &&
                                ((e.pagination.dynamicBulletIndex += n - e.previousIndex),
                                e.pagination.dynamicBulletIndex > a.dynamicMainBullets - 1
                                    ? (e.pagination.dynamicBulletIndex = a.dynamicMainBullets - 1)
                                    : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)),
                            (r = n - e.pagination.dynamicBulletIndex),
                            (o = r + (Math.min(s.length, a.dynamicMainBullets) - 1)),
                            (l = (o + r) / 2)),
                        s.removeClass(
                            `${a.bulletActiveClass} ${a.bulletActiveClass}-next ${a.bulletActiveClass}-next-next ${a.bulletActiveClass}-prev ${a.bulletActiveClass}-prev-prev ${a.bulletActiveClass}-main`
                        ),
                        i.length > 1)
                    )
                        s.each((e, t) => {
                            const s = d(t),
                                i = s.index();
                            i === n && s.addClass(a.bulletActiveClass),
                                a.dynamicBullets &&
                                    (i >= r && i <= o && s.addClass(a.bulletActiveClass + "-main"),
                                    i === r &&
                                        s
                                            .prev()
                                            .addClass(a.bulletActiveClass + "-prev")
                                            .prev()
                                            .addClass(a.bulletActiveClass + "-prev-prev"),
                                    i === o &&
                                        s
                                            .next()
                                            .addClass(a.bulletActiveClass + "-next")
                                            .next()
                                            .addClass(a.bulletActiveClass + "-next-next"));
                        });
                    else {
                        const t = s.eq(n),
                            i = t.index();
                        if ((t.addClass(a.bulletActiveClass), a.dynamicBullets)) {
                            const t = s.eq(r),
                                n = s.eq(o);
                            for (let e = r; e <= o; e += 1) s.eq(e).addClass(a.bulletActiveClass + "-main");
                            if (e.params.loop)
                                if (i >= s.length - a.dynamicMainBullets) {
                                    for (let e = a.dynamicMainBullets; e >= 0; e -= 1)
                                        s.eq(s.length - e).addClass(a.bulletActiveClass + "-main");
                                    s.eq(s.length - a.dynamicMainBullets - 1).addClass(a.bulletActiveClass + "-prev");
                                } else
                                    t
                                        .prev()
                                        .addClass(a.bulletActiveClass + "-prev")
                                        .prev()
                                        .addClass(a.bulletActiveClass + "-prev-prev"),
                                        n
                                            .next()
                                            .addClass(a.bulletActiveClass + "-next")
                                            .next()
                                            .addClass(a.bulletActiveClass + "-next-next");
                            else
                                t
                                    .prev()
                                    .addClass(a.bulletActiveClass + "-prev")
                                    .prev()
                                    .addClass(a.bulletActiveClass + "-prev-prev"),
                                    n
                                        .next()
                                        .addClass(a.bulletActiveClass + "-next")
                                        .next()
                                        .addClass(a.bulletActiveClass + "-next-next");
                        }
                    }
                    if (a.dynamicBullets) {
                        const i = Math.min(s.length, a.dynamicMainBullets + 4),
                            n =
                                (e.pagination.bulletSize * i - e.pagination.bulletSize) / 2 -
                                l * e.pagination.bulletSize,
                            r = t ? "right" : "left";
                        s.css(e.isHorizontal() ? r : "top", n + "px");
                    }
                }
                if (
                    ("fraction" === a.type &&
                        (i.find("." + a.currentClass).text(a.formatFractionCurrent(n + 1)),
                        i.find("." + a.totalClass).text(a.formatFractionTotal(r))),
                    "progressbar" === a.type)
                ) {
                    let t;
                    t = a.progressbarOpposite
                        ? e.isHorizontal()
                            ? "vertical"
                            : "horizontal"
                        : e.isHorizontal()
                          ? "horizontal"
                          : "vertical";
                    const s = (n + 1) / r;
                    let o = 1,
                        l = 1;
                    "horizontal" === t ? (o = s) : (l = s),
                        i
                            .find("." + a.progressbarFillClass)
                            .transform(`translate3d(0,0,0) scaleX(${o}) scaleY(${l})`)
                            .transition(e.params.speed);
                }
                "custom" === a.type && a.renderCustom
                    ? (i.html(a.renderCustom(e, n + 1, r)), e.emit("paginationRender", e, i[0]))
                    : e.emit("paginationUpdate", e, i[0]),
                    i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](a.lockClass);
            },
            render() {
                const e = this,
                    t = e.params.pagination;
                if (!t.el || !e.pagination.el || !e.pagination.$el || 0 === e.pagination.$el.length) return;
                const a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    s = e.pagination.$el;
                let i = "";
                if ("bullets" === t.type) {
                    const n = e.params.loop
                        ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup)
                        : e.snapGrid.length;
                    for (let a = 0; a < n; a += 1)
                        t.renderBullet
                            ? (i += t.renderBullet.call(e, a, t.bulletClass))
                            : (i += `<${t.bulletElement} class="${t.bulletClass}"></${t.bulletElement}>`);
                    s.html(i), (e.pagination.bullets = s.find("." + t.bulletClass));
                }
                "fraction" === t.type &&
                    ((i = t.renderFraction
                        ? t.renderFraction.call(e, t.currentClass, t.totalClass)
                        : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
                    s.html(i)),
                    "progressbar" === t.type &&
                        ((i = t.renderProgressbar
                            ? t.renderProgressbar.call(e, t.progressbarFillClass)
                            : `<span class="${t.progressbarFillClass}"></span>`),
                        s.html(i)),
                    "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0]);
            },
            init() {
                const e = this,
                    t = e.params.pagination;
                if (!t.el) return;
                let a = d(t.el);
                0 !== a.length &&
                    (e.params.uniqueNavElements && "string" == typeof t.el && a.length > 1 && (a = e.$el.find(t.el)),
                    "bullets" === t.type && t.clickable && a.addClass(t.clickableClass),
                    a.addClass(t.modifierClass + t.type),
                    "bullets" === t.type &&
                        t.dynamicBullets &&
                        (a.addClass(`${t.modifierClass}${t.type}-dynamic`),
                        (e.pagination.dynamicBulletIndex = 0),
                        t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                    "progressbar" === t.type && t.progressbarOpposite && a.addClass(t.progressbarOppositeClass),
                    t.clickable &&
                        a.on("click", "." + t.bulletClass, function (t) {
                            t.preventDefault();
                            let a = d(this).index() * e.params.slidesPerGroup;
                            e.params.loop && (a += e.loopedSlides), e.slideTo(a);
                        }),
                    p.extend(e.pagination, { $el: a, el: a[0] }));
            },
            destroy() {
                const e = this.params.pagination;
                if (!e.el || !this.pagination.el || !this.pagination.$el || 0 === this.pagination.$el.length) return;
                const t = this.pagination.$el;
                t.removeClass(e.hiddenClass),
                    t.removeClass(e.modifierClass + e.type),
                    this.pagination.bullets && this.pagination.bullets.removeClass(e.bulletActiveClass),
                    e.clickable && t.off("click", "." + e.bulletClass);
            },
        };
        const U = {
            setTranslate() {
                const e = this;
                if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                const { scrollbar: t, rtlTranslate: a, progress: s } = e,
                    { dragSize: i, trackSize: n, $dragEl: r, $el: o } = t,
                    l = e.params.scrollbar;
                let d = i,
                    c = (n - i) * s;
                a
                    ? ((c = -c), c > 0 ? ((d = i - c), (c = 0)) : -c + i > n && (d = n + c))
                    : c < 0
                      ? ((d = i + c), (c = 0))
                      : c + i > n && (d = n - c),
                    e.isHorizontal()
                        ? (r.transform(`translate3d(${c}px, 0, 0)`), (r[0].style.width = d + "px"))
                        : (r.transform(`translate3d(0px, ${c}px, 0)`), (r[0].style.height = d + "px")),
                    l.hide &&
                        (clearTimeout(e.scrollbar.timeout),
                        (o[0].style.opacity = 1),
                        (e.scrollbar.timeout = setTimeout(() => {
                            (o[0].style.opacity = 0), o.transition(400);
                        }, 1e3)));
            },
            setTransition(e) {
                this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(e);
            },
            updateSize() {
                const e = this;
                if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                const { scrollbar: t } = e,
                    { $dragEl: a, $el: s } = t;
                (a[0].style.width = ""), (a[0].style.height = "");
                const i = e.isHorizontal() ? s[0].offsetWidth : s[0].offsetHeight,
                    n = e.size / e.virtualSize,
                    r = n * (i / e.size);
                let o;
                (o = "auto" === e.params.scrollbar.dragSize ? i * n : parseInt(e.params.scrollbar.dragSize, 10)),
                    e.isHorizontal() ? (a[0].style.width = o + "px") : (a[0].style.height = o + "px"),
                    (s[0].style.display = n >= 1 ? "none" : ""),
                    e.params.scrollbar.hide && (s[0].style.opacity = 0),
                    p.extend(t, { trackSize: i, divider: n, moveDivider: r, dragSize: o }),
                    t.$el[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](
                        e.params.scrollbar.lockClass
                    );
            },
            getPointerPosition(e) {
                return this.isHorizontal()
                    ? "touchstart" === e.type || "touchmove" === e.type
                        ? e.targetTouches[0].clientX
                        : e.clientX
                    : "touchstart" === e.type || "touchmove" === e.type
                      ? e.targetTouches[0].clientY
                      : e.clientY;
            },
            setDragPosition(e) {
                const { scrollbar: t, rtlTranslate: a } = this,
                    { $el: s, dragSize: i, trackSize: n, dragStartPos: r } = t;
                let o;
                (o =
                    (t.getPointerPosition(e) -
                        s.offset()[this.isHorizontal() ? "left" : "top"] -
                        (null !== r ? r : i / 2)) /
                    (n - i)),
                    (o = Math.max(Math.min(o, 1), 0)),
                    a && (o = 1 - o);
                const l = this.minTranslate() + (this.maxTranslate() - this.minTranslate()) * o;
                this.updateProgress(l), this.setTranslate(l), this.updateActiveIndex(), this.updateSlidesClasses();
            },
            onDragStart(e) {
                const t = this,
                    a = t.params.scrollbar,
                    { scrollbar: s, $wrapperEl: i } = t,
                    { $el: n, $dragEl: r } = s;
                (t.scrollbar.isTouched = !0),
                    (t.scrollbar.dragStartPos =
                        e.target === r[0] || e.target === r
                            ? s.getPointerPosition(e) -
                              e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"]
                            : null),
                    e.preventDefault(),
                    e.stopPropagation(),
                    i.transition(100),
                    r.transition(100),
                    s.setDragPosition(e),
                    clearTimeout(t.scrollbar.dragTimeout),
                    n.transition(0),
                    a.hide && n.css("opacity", 1),
                    t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
                    t.emit("scrollbarDragStart", e);
            },
            onDragMove(e) {
                const { scrollbar: t, $wrapperEl: a } = this,
                    { $el: s, $dragEl: i } = t;
                this.scrollbar.isTouched &&
                    (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
                    t.setDragPosition(e),
                    a.transition(0),
                    s.transition(0),
                    i.transition(0),
                    this.emit("scrollbarDragMove", e));
            },
            onDragEnd(e) {
                const t = this,
                    a = t.params.scrollbar,
                    { scrollbar: s, $wrapperEl: i } = t,
                    { $el: n } = s;
                t.scrollbar.isTouched &&
                    ((t.scrollbar.isTouched = !1),
                    t.params.cssMode && (t.$wrapperEl.css("scroll-snap-type", ""), i.transition("")),
                    a.hide &&
                        (clearTimeout(t.scrollbar.dragTimeout),
                        (t.scrollbar.dragTimeout = p.nextTick(() => {
                            n.css("opacity", 0), n.transition(400);
                        }, 1e3))),
                    t.emit("scrollbarDragEnd", e),
                    a.snapOnRelease && t.slideToClosest());
            },
            enableDraggable() {
                const e = this;
                if (!e.params.scrollbar.el) return;
                const { scrollbar: t, touchEventsTouch: a, touchEventsDesktop: s, params: i } = e,
                    r = t.$el[0],
                    o = !(!h.passiveListener || !i.passiveListeners) && { passive: !1, capture: !1 },
                    l = !(!h.passiveListener || !i.passiveListeners) && { passive: !0, capture: !1 };
                h.touch
                    ? (r.addEventListener(a.start, e.scrollbar.onDragStart, o),
                      r.addEventListener(a.move, e.scrollbar.onDragMove, o),
                      r.addEventListener(a.end, e.scrollbar.onDragEnd, l))
                    : (r.addEventListener(s.start, e.scrollbar.onDragStart, o),
                      n.addEventListener(s.move, e.scrollbar.onDragMove, o),
                      n.addEventListener(s.end, e.scrollbar.onDragEnd, l));
            },
            disableDraggable() {
                const e = this;
                if (!e.params.scrollbar.el) return;
                const { scrollbar: t, touchEventsTouch: a, touchEventsDesktop: s, params: i } = e,
                    r = t.$el[0],
                    o = !(!h.passiveListener || !i.passiveListeners) && { passive: !1, capture: !1 },
                    l = !(!h.passiveListener || !i.passiveListeners) && { passive: !0, capture: !1 };
                h.touch
                    ? (r.removeEventListener(a.start, e.scrollbar.onDragStart, o),
                      r.removeEventListener(a.move, e.scrollbar.onDragMove, o),
                      r.removeEventListener(a.end, e.scrollbar.onDragEnd, l))
                    : (r.removeEventListener(s.start, e.scrollbar.onDragStart, o),
                      n.removeEventListener(s.move, e.scrollbar.onDragMove, o),
                      n.removeEventListener(s.end, e.scrollbar.onDragEnd, l));
            },
            init() {
                const e = this;
                if (!e.params.scrollbar.el) return;
                const { scrollbar: t, $el: a } = e,
                    s = e.params.scrollbar;
                let i = d(s.el);
                e.params.uniqueNavElements &&
                    "string" == typeof s.el &&
                    i.length > 1 &&
                    1 === a.find(s.el).length &&
                    (i = a.find(s.el));
                let n = i.find("." + e.params.scrollbar.dragClass);
                0 === n.length && ((n = d(`<div class="${e.params.scrollbar.dragClass}"></div>`)), i.append(n)),
                    p.extend(t, { $el: i, el: i[0], $dragEl: n, dragEl: n[0] }),
                    s.draggable && t.enableDraggable();
            },
            destroy() {
                this.scrollbar.disableDraggable();
            },
        };
        const K = {
            setTransform(e, t) {
                const { rtl: a } = this,
                    s = d(e),
                    i = a ? -1 : 1,
                    n = s.attr("data-swiper-parallax") || "0";
                let r = s.attr("data-swiper-parallax-x"),
                    o = s.attr("data-swiper-parallax-y");
                const l = s.attr("data-swiper-parallax-scale"),
                    c = s.attr("data-swiper-parallax-opacity");
                if (
                    (r || o
                        ? ((r = r || "0"), (o = o || "0"))
                        : this.isHorizontal()
                          ? ((r = n), (o = "0"))
                          : ((o = n), (r = "0")),
                    (r = r.indexOf("%") >= 0 ? parseInt(r, 10) * t * i + "%" : r * t * i + "px"),
                    (o = o.indexOf("%") >= 0 ? parseInt(o, 10) * t + "%" : o * t + "px"),
                    null != c)
                ) {
                    const e = c - (c - 1) * (1 - Math.abs(t));
                    s[0].style.opacity = e;
                }
                if (null == l) s.transform(`translate3d(${r}, ${o}, 0px)`);
                else {
                    const e = l - (l - 1) * (1 - Math.abs(t));
                    s.transform(`translate3d(${r}, ${o}, 0px) scale(${e})`);
                }
            },
            setTranslate() {
                const e = this,
                    { $el: t, slides: a, progress: s, snapGrid: i } = e;
                t
                    .children(
                        "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                    )
                    .each((t, a) => {
                        e.parallax.setTransform(a, s);
                    }),
                    a.each((t, a) => {
                        let n = a.progress;
                        e.params.slidesPerGroup > 1 &&
                            "auto" !== e.params.slidesPerView &&
                            (n += Math.ceil(t / 2) - s * (i.length - 1)),
                            (n = Math.min(Math.max(n, -1), 1)),
                            d(a)
                                .find(
                                    "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                                )
                                .each((t, a) => {
                                    e.parallax.setTransform(a, n);
                                });
                    });
            },
            setTransition(e = this.params.speed) {
                const { $el: t } = this;
                t.find(
                    "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                ).each((t, a) => {
                    const s = d(a);
                    let i = parseInt(s.attr("data-swiper-parallax-duration"), 10) || e;
                    0 === e && (i = 0), s.transition(i);
                });
            },
        };
        const J = {
            getDistanceBetweenTouches(e) {
                if (e.targetTouches.length < 2) return 1;
                const t = e.targetTouches[0].pageX,
                    a = e.targetTouches[0].pageY,
                    s = e.targetTouches[1].pageX,
                    i = e.targetTouches[1].pageY;
                return Math.sqrt((s - t) ** 2 + (i - a) ** 2);
            },
            onGestureStart(e) {
                const t = this,
                    a = t.params.zoom,
                    s = t.zoom,
                    { gesture: i } = s;
                if (((s.fakeGestureTouched = !1), (s.fakeGestureMoved = !1), !h.gestures)) {
                    if ("touchstart" !== e.type || ("touchstart" === e.type && e.targetTouches.length < 2)) return;
                    (s.fakeGestureTouched = !0), (i.scaleStart = J.getDistanceBetweenTouches(e));
                }
                (i.$slideEl && i.$slideEl.length) ||
                ((i.$slideEl = d(e.target).closest("." + t.params.slideClass)),
                0 === i.$slideEl.length && (i.$slideEl = t.slides.eq(t.activeIndex)),
                (i.$imageEl = i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target")),
                (i.$imageWrapEl = i.$imageEl.parent("." + a.containerClass)),
                (i.maxRatio = i.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio),
                0 !== i.$imageWrapEl.length)
                    ? (i.$imageEl && i.$imageEl.transition(0), (t.zoom.isScaling = !0))
                    : (i.$imageEl = void 0);
            },
            onGestureChange(e) {
                const t = this.params.zoom,
                    a = this.zoom,
                    { gesture: s } = a;
                if (!h.gestures) {
                    if ("touchmove" !== e.type || ("touchmove" === e.type && e.targetTouches.length < 2)) return;
                    (a.fakeGestureMoved = !0), (s.scaleMove = J.getDistanceBetweenTouches(e));
                }
                s.$imageEl &&
                    0 !== s.$imageEl.length &&
                    ((a.scale = h.gestures ? e.scale * a.currentScale : (s.scaleMove / s.scaleStart) * a.currentScale),
                    a.scale > s.maxRatio && (a.scale = s.maxRatio - 1 + (a.scale - s.maxRatio + 1) ** 0.5),
                    a.scale < t.minRatio && (a.scale = t.minRatio + 1 - (t.minRatio - a.scale + 1) ** 0.5),
                    s.$imageEl.transform(`translate3d(0,0,0) scale(${a.scale})`));
            },
            onGestureEnd(e) {
                const t = this.params.zoom,
                    a = this.zoom,
                    { gesture: s } = a;
                if (!h.gestures) {
                    if (!a.fakeGestureTouched || !a.fakeGestureMoved) return;
                    if ("touchend" !== e.type || ("touchend" === e.type && e.changedTouches.length < 2 && !x.android))
                        return;
                    (a.fakeGestureTouched = !1), (a.fakeGestureMoved = !1);
                }
                s.$imageEl &&
                    0 !== s.$imageEl.length &&
                    ((a.scale = Math.max(Math.min(a.scale, s.maxRatio), t.minRatio)),
                    s.$imageEl.transition(this.params.speed).transform(`translate3d(0,0,0) scale(${a.scale})`),
                    (a.currentScale = a.scale),
                    (a.isScaling = !1),
                    1 === a.scale && (s.$slideEl = void 0));
            },
            onTouchStart(e) {
                const t = this.zoom,
                    { gesture: a, image: s } = t;
                a.$imageEl &&
                    0 !== a.$imageEl.length &&
                    (s.isTouched ||
                        (x.android && e.cancelable && e.preventDefault(),
                        (s.isTouched = !0),
                        (s.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX),
                        (s.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY)));
            },
            onTouchMove(e) {
                const t = this,
                    a = t.zoom,
                    { gesture: s, image: i, velocity: n } = a;
                if (!s.$imageEl || 0 === s.$imageEl.length) return;
                if (((t.allowClick = !1), !i.isTouched || !s.$slideEl)) return;
                i.isMoved ||
                    ((i.width = s.$imageEl[0].offsetWidth),
                    (i.height = s.$imageEl[0].offsetHeight),
                    (i.startX = p.getTranslate(s.$imageWrapEl[0], "x") || 0),
                    (i.startY = p.getTranslate(s.$imageWrapEl[0], "y") || 0),
                    (s.slideWidth = s.$slideEl[0].offsetWidth),
                    (s.slideHeight = s.$slideEl[0].offsetHeight),
                    s.$imageWrapEl.transition(0),
                    t.rtl && ((i.startX = -i.startX), (i.startY = -i.startY)));
                const r = i.width * a.scale,
                    o = i.height * a.scale;
                if (!(r < s.slideWidth && o < s.slideHeight)) {
                    if (
                        ((i.minX = Math.min(s.slideWidth / 2 - r / 2, 0)),
                        (i.maxX = -i.minX),
                        (i.minY = Math.min(s.slideHeight / 2 - o / 2, 0)),
                        (i.maxY = -i.minY),
                        (i.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX),
                        (i.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY),
                        !i.isMoved && !a.isScaling)
                    ) {
                        if (
                            t.isHorizontal() &&
                            ((Math.floor(i.minX) === Math.floor(i.startX) && i.touchesCurrent.x < i.touchesStart.x) ||
                                (Math.floor(i.maxX) === Math.floor(i.startX) && i.touchesCurrent.x > i.touchesStart.x))
                        )
                            return void (i.isTouched = !1);
                        if (
                            !t.isHorizontal() &&
                            ((Math.floor(i.minY) === Math.floor(i.startY) && i.touchesCurrent.y < i.touchesStart.y) ||
                                (Math.floor(i.maxY) === Math.floor(i.startY) && i.touchesCurrent.y > i.touchesStart.y))
                        )
                            return void (i.isTouched = !1);
                    }
                    e.cancelable && e.preventDefault(),
                        e.stopPropagation(),
                        (i.isMoved = !0),
                        (i.currentX = i.touchesCurrent.x - i.touchesStart.x + i.startX),
                        (i.currentY = i.touchesCurrent.y - i.touchesStart.y + i.startY),
                        i.currentX < i.minX && (i.currentX = i.minX + 1 - (i.minX - i.currentX + 1) ** 0.8),
                        i.currentX > i.maxX && (i.currentX = i.maxX - 1 + (i.currentX - i.maxX + 1) ** 0.8),
                        i.currentY < i.minY && (i.currentY = i.minY + 1 - (i.minY - i.currentY + 1) ** 0.8),
                        i.currentY > i.maxY && (i.currentY = i.maxY - 1 + (i.currentY - i.maxY + 1) ** 0.8),
                        n.prevPositionX || (n.prevPositionX = i.touchesCurrent.x),
                        n.prevPositionY || (n.prevPositionY = i.touchesCurrent.y),
                        n.prevTime || (n.prevTime = Date.now()),
                        (n.x = (i.touchesCurrent.x - n.prevPositionX) / (Date.now() - n.prevTime) / 2),
                        (n.y = (i.touchesCurrent.y - n.prevPositionY) / (Date.now() - n.prevTime) / 2),
                        Math.abs(i.touchesCurrent.x - n.prevPositionX) < 2 && (n.x = 0),
                        Math.abs(i.touchesCurrent.y - n.prevPositionY) < 2 && (n.y = 0),
                        (n.prevPositionX = i.touchesCurrent.x),
                        (n.prevPositionY = i.touchesCurrent.y),
                        (n.prevTime = Date.now()),
                        s.$imageWrapEl.transform(`translate3d(${i.currentX}px, ${i.currentY}px,0)`);
                }
            },
            onTouchEnd() {
                const e = this.zoom,
                    { gesture: t, image: a, velocity: s } = e;
                if (!t.$imageEl || 0 === t.$imageEl.length) return;
                if (!a.isTouched || !a.isMoved) return (a.isTouched = !1), void (a.isMoved = !1);
                (a.isTouched = !1), (a.isMoved = !1);
                let i = 300,
                    n = 300;
                const r = s.x * i,
                    o = a.currentX + r,
                    l = s.y * n,
                    d = a.currentY + l;
                0 !== s.x && (i = Math.abs((o - a.currentX) / s.x)),
                    0 !== s.y && (n = Math.abs((d - a.currentY) / s.y));
                const c = Math.max(i, n);
                (a.currentX = o), (a.currentY = d);
                const u = a.width * e.scale,
                    p = a.height * e.scale;
                (a.minX = Math.min(t.slideWidth / 2 - u / 2, 0)),
                    (a.maxX = -a.minX),
                    (a.minY = Math.min(t.slideHeight / 2 - p / 2, 0)),
                    (a.maxY = -a.minY),
                    (a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX)),
                    (a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY)),
                    t.$imageWrapEl.transition(c).transform(`translate3d(${a.currentX}px, ${a.currentY}px,0)`);
            },
            onTransitionEnd() {
                const e = this.zoom,
                    { gesture: t } = e;
                t.$slideEl &&
                    this.previousIndex !== this.activeIndex &&
                    (t.$imageEl && t.$imageEl.transform("translate3d(0,0,0) scale(1)"),
                    t.$imageWrapEl && t.$imageWrapEl.transform("translate3d(0,0,0)"),
                    (e.scale = 1),
                    (e.currentScale = 1),
                    (t.$slideEl = void 0),
                    (t.$imageEl = void 0),
                    (t.$imageWrapEl = void 0));
            },
            toggle(e) {
                const t = this.zoom;
                t.scale && 1 !== t.scale ? t.out() : t.in(e);
            },
            in(e) {
                const t = this,
                    a = t.zoom,
                    s = t.params.zoom,
                    { gesture: i, image: n } = a;
                if (
                    (i.$slideEl ||
                        (t.params.virtual && t.params.virtual.enabled && t.virtual
                            ? (i.$slideEl = t.$wrapperEl.children("." + t.params.slideActiveClass))
                            : (i.$slideEl = t.slides.eq(t.activeIndex)),
                        (i.$imageEl = i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target")),
                        (i.$imageWrapEl = i.$imageEl.parent("." + s.containerClass))),
                    !i.$imageEl || 0 === i.$imageEl.length)
                )
                    return;
                let r, o, l, d, c, u, p, h, m, f, g, v, b, y, w, S, x, E;
                i.$slideEl.addClass("" + s.zoomedSlideClass),
                    void 0 === n.touchesStart.x && e
                        ? ((r = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX),
                          (o = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY))
                        : ((r = n.touchesStart.x), (o = n.touchesStart.y)),
                    (a.scale = i.$imageWrapEl.attr("data-swiper-zoom") || s.maxRatio),
                    (a.currentScale = i.$imageWrapEl.attr("data-swiper-zoom") || s.maxRatio),
                    e
                        ? ((x = i.$slideEl[0].offsetWidth),
                          (E = i.$slideEl[0].offsetHeight),
                          (l = i.$slideEl.offset().left),
                          (d = i.$slideEl.offset().top),
                          (c = l + x / 2 - r),
                          (u = d + E / 2 - o),
                          (m = i.$imageEl[0].offsetWidth),
                          (f = i.$imageEl[0].offsetHeight),
                          (g = m * a.scale),
                          (v = f * a.scale),
                          (b = Math.min(x / 2 - g / 2, 0)),
                          (y = Math.min(E / 2 - v / 2, 0)),
                          (w = -b),
                          (S = -y),
                          (p = c * a.scale),
                          (h = u * a.scale),
                          p < b && (p = b),
                          p > w && (p = w),
                          h < y && (h = y),
                          h > S && (h = S))
                        : ((p = 0), (h = 0)),
                    i.$imageWrapEl.transition(300).transform(`translate3d(${p}px, ${h}px,0)`),
                    i.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${a.scale})`);
            },
            out() {
                const e = this,
                    t = e.zoom,
                    a = e.params.zoom,
                    { gesture: s } = t;
                s.$slideEl ||
                    (e.params.virtual && e.params.virtual.enabled && e.virtual
                        ? (s.$slideEl = e.$wrapperEl.children("." + e.params.slideActiveClass))
                        : (s.$slideEl = e.slides.eq(e.activeIndex)),
                    (s.$imageEl = s.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target")),
                    (s.$imageWrapEl = s.$imageEl.parent("." + a.containerClass))),
                    s.$imageEl &&
                        0 !== s.$imageEl.length &&
                        ((t.scale = 1),
                        (t.currentScale = 1),
                        s.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
                        s.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),
                        s.$slideEl.removeClass("" + a.zoomedSlideClass),
                        (s.$slideEl = void 0));
            },
            enable() {
                const e = this,
                    t = e.zoom;
                if (t.enabled) return;
                t.enabled = !0;
                const a = !(
                        "touchstart" !== e.touchEvents.start ||
                        !h.passiveListener ||
                        !e.params.passiveListeners
                    ) && { passive: !0, capture: !1 },
                    s = !h.passiveListener || { passive: !1, capture: !0 },
                    i = "." + e.params.slideClass;
                h.gestures
                    ? (e.$wrapperEl.on("gesturestart", i, t.onGestureStart, a),
                      e.$wrapperEl.on("gesturechange", i, t.onGestureChange, a),
                      e.$wrapperEl.on("gestureend", i, t.onGestureEnd, a))
                    : "touchstart" === e.touchEvents.start &&
                      (e.$wrapperEl.on(e.touchEvents.start, i, t.onGestureStart, a),
                      e.$wrapperEl.on(e.touchEvents.move, i, t.onGestureChange, s),
                      e.$wrapperEl.on(e.touchEvents.end, i, t.onGestureEnd, a),
                      e.touchEvents.cancel && e.$wrapperEl.on(e.touchEvents.cancel, i, t.onGestureEnd, a)),
                    e.$wrapperEl.on(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove, s);
            },
            disable() {
                const e = this,
                    t = e.zoom;
                if (!t.enabled) return;
                e.zoom.enabled = !1;
                const a = !(
                        "touchstart" !== e.touchEvents.start ||
                        !h.passiveListener ||
                        !e.params.passiveListeners
                    ) && { passive: !0, capture: !1 },
                    s = !h.passiveListener || { passive: !1, capture: !0 },
                    i = "." + e.params.slideClass;
                h.gestures
                    ? (e.$wrapperEl.off("gesturestart", i, t.onGestureStart, a),
                      e.$wrapperEl.off("gesturechange", i, t.onGestureChange, a),
                      e.$wrapperEl.off("gestureend", i, t.onGestureEnd, a))
                    : "touchstart" === e.touchEvents.start &&
                      (e.$wrapperEl.off(e.touchEvents.start, i, t.onGestureStart, a),
                      e.$wrapperEl.off(e.touchEvents.move, i, t.onGestureChange, s),
                      e.$wrapperEl.off(e.touchEvents.end, i, t.onGestureEnd, a),
                      e.touchEvents.cancel && e.$wrapperEl.off(e.touchEvents.cancel, i, t.onGestureEnd, a)),
                    e.$wrapperEl.off(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove, s);
            },
        };
        const Z = {
            loadInSlide(e, t = !0) {
                const a = this,
                    s = a.params.lazy;
                if (void 0 === e) return;
                if (0 === a.slides.length) return;
                const i =
                    a.virtual && a.params.virtual.enabled
                        ? a.$wrapperEl.children(`.${a.params.slideClass}[data-swiper-slide-index="${e}"]`)
                        : a.slides.eq(e);
                let n = i.find(`.${s.elementClass}:not(.${s.loadedClass}):not(.${s.loadingClass})`);
                !i.hasClass(s.elementClass) ||
                    i.hasClass(s.loadedClass) ||
                    i.hasClass(s.loadingClass) ||
                    (n = n.add(i[0])),
                    0 !== n.length &&
                        n.each((e, n) => {
                            const r = d(n);
                            r.addClass(s.loadingClass);
                            const o = r.attr("data-background"),
                                l = r.attr("data-src"),
                                c = r.attr("data-srcset"),
                                u = r.attr("data-sizes"),
                                p = r.parent("picture");
                            a.loadImage(r[0], l || o, c, u, !1, () => {
                                if (null != a && a && (!a || a.params) && !a.destroyed) {
                                    if (
                                        (o
                                            ? (r.css("background-image", `url("${o}")`),
                                              r.removeAttr("data-background"))
                                            : (c && (r.attr("srcset", c), r.removeAttr("data-srcset")),
                                              u && (r.attr("sizes", u), r.removeAttr("data-sizes")),
                                              p.length &&
                                                  p.children("source").each((e, t) => {
                                                      const a = d(t);
                                                      a.attr("data-srcset") &&
                                                          (a.attr("srcset", a.attr("data-srcset")),
                                                          a.removeAttr("data-srcset"));
                                                  }),
                                              l && (r.attr("src", l), r.removeAttr("data-src"))),
                                        r.addClass(s.loadedClass).removeClass(s.loadingClass),
                                        i.find("." + s.preloaderClass).remove(),
                                        a.params.loop && t)
                                    ) {
                                        const e = i.attr("data-swiper-slide-index");
                                        if (i.hasClass(a.params.slideDuplicateClass)) {
                                            const t = a.$wrapperEl.children(
                                                `[data-swiper-slide-index="${e}"]:not(.${a.params.slideDuplicateClass})`
                                            );
                                            a.lazy.loadInSlide(t.index(), !1);
                                        } else {
                                            const t = a.$wrapperEl.children(
                                                `.${a.params.slideDuplicateClass}[data-swiper-slide-index="${e}"]`
                                            );
                                            a.lazy.loadInSlide(t.index(), !1);
                                        }
                                    }
                                    a.emit("lazyImageReady", i[0], r[0]), a.params.autoHeight && a.updateAutoHeight();
                                }
                            }),
                                a.emit("lazyImageLoad", i[0], r[0]);
                        });
            },
            load() {
                const e = this,
                    { $wrapperEl: t, params: a, slides: s, activeIndex: i } = e,
                    n = e.virtual && a.virtual.enabled,
                    r = a.lazy;
                let o = a.slidesPerView;
                function l(e) {
                    if (n) {
                        if (t.children(`.${a.slideClass}[data-swiper-slide-index="${e}"]`).length) return !0;
                    } else if (s[e]) return !0;
                    return !1;
                }
                function c(e) {
                    return n ? d(e).attr("data-swiper-slide-index") : d(e).index();
                }
                if (
                    ("auto" === o && (o = 0),
                    e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0),
                    e.params.watchSlidesVisibility)
                )
                    t.children("." + a.slideVisibleClass).each((t, a) => {
                        const s = n ? d(a).attr("data-swiper-slide-index") : d(a).index();
                        e.lazy.loadInSlide(s);
                    });
                else if (o > 1) for (let t = i; t < i + o; t += 1) l(t) && e.lazy.loadInSlide(t);
                else e.lazy.loadInSlide(i);
                if (r.loadPrevNext)
                    if (o > 1 || (r.loadPrevNextAmount && r.loadPrevNextAmount > 1)) {
                        const t = r.loadPrevNextAmount,
                            a = o,
                            n = Math.min(i + a + Math.max(t, a), s.length),
                            d = Math.max(i - Math.max(a, t), 0);
                        for (let t = i + o; t < n; t += 1) l(t) && e.lazy.loadInSlide(t);
                        for (let t = d; t < i; t += 1) l(t) && e.lazy.loadInSlide(t);
                    } else {
                        const s = t.children("." + a.slideNextClass);
                        s.length > 0 && e.lazy.loadInSlide(c(s));
                        const i = t.children("." + a.slidePrevClass);
                        i.length > 0 && e.lazy.loadInSlide(c(i));
                    }
            },
        };
        const Q = {
            LinearSpline: function (e, t) {
                const a = (function () {
                    let e, t, a;
                    return (s, i) => {
                        for (t = -1, e = s.length; e - t > 1; ) (a = (e + t) >> 1), s[a] <= i ? (t = a) : (e = a);
                        return e;
                    };
                })();
                let s, i;
                return (
                    (this.x = e),
                    (this.y = t),
                    (this.lastIndex = e.length - 1),
                    (this.interpolate = function (e) {
                        return e
                            ? ((i = a(this.x, e)),
                              (s = i - 1),
                              ((e - this.x[s]) * (this.y[i] - this.y[s])) / (this.x[i] - this.x[s]) + this.y[s])
                            : 0;
                    }),
                    this
                );
            },
            getInterpolateFunction(e) {
                const t = this;
                t.controller.spline ||
                    (t.controller.spline = t.params.loop
                        ? new Q.LinearSpline(t.slidesGrid, e.slidesGrid)
                        : new Q.LinearSpline(t.snapGrid, e.snapGrid));
            },
            setTranslate(e, t) {
                const a = this,
                    s = a.controller.control;
                let i, n;
                function r(e) {
                    const t = a.rtlTranslate ? -a.translate : a.translate;
                    "slide" === a.params.controller.by &&
                        (a.controller.getInterpolateFunction(e), (n = -a.controller.spline.interpolate(-t))),
                        (n && "container" !== a.params.controller.by) ||
                            ((i = (e.maxTranslate() - e.minTranslate()) / (a.maxTranslate() - a.minTranslate())),
                            (n = (t - a.minTranslate()) * i + e.minTranslate())),
                        a.params.controller.inverse && (n = e.maxTranslate() - n),
                        e.updateProgress(n),
                        e.setTranslate(n, a),
                        e.updateActiveIndex(),
                        e.updateSlidesClasses();
                }
                if (Array.isArray(s)) for (let e = 0; e < s.length; e += 1) s[e] !== t && s[e] instanceof A && r(s[e]);
                else s instanceof A && t !== s && r(s);
            },
            setTransition(e, t) {
                const a = this,
                    s = a.controller.control;
                let i;
                function n(t) {
                    t.setTransition(e, a),
                        0 !== e &&
                            (t.transitionStart(),
                            t.params.autoHeight &&
                                p.nextTick(() => {
                                    t.updateAutoHeight();
                                }),
                            t.$wrapperEl.transitionEnd(() => {
                                s &&
                                    (t.params.loop && "slide" === a.params.controller.by && t.loopFix(),
                                    t.transitionEnd());
                            }));
                }
                if (Array.isArray(s)) for (i = 0; i < s.length; i += 1) s[i] !== t && s[i] instanceof A && n(s[i]);
                else s instanceof A && t !== s && n(s);
            },
        };
        const ee = {
            makeElFocusable: (e) => (e.attr("tabIndex", "0"), e),
            makeElNotFocusable: (e) => (e.attr("tabIndex", "-1"), e),
            addElRole: (e, t) => (e.attr("role", t), e),
            addElLabel: (e, t) => (e.attr("aria-label", t), e),
            disableEl: (e) => (e.attr("aria-disabled", !0), e),
            enableEl: (e) => (e.attr("aria-disabled", !1), e),
            onEnterKey(e) {
                const t = this,
                    a = t.params.a11y;
                if (13 !== e.keyCode) return;
                const s = d(e.target);
                t.navigation &&
                    t.navigation.$nextEl &&
                    s.is(t.navigation.$nextEl) &&
                    ((t.isEnd && !t.params.loop) || t.slideNext(),
                    t.isEnd ? t.a11y.notify(a.lastSlideMessage) : t.a11y.notify(a.nextSlideMessage)),
                    t.navigation &&
                        t.navigation.$prevEl &&
                        s.is(t.navigation.$prevEl) &&
                        ((t.isBeginning && !t.params.loop) || t.slidePrev(),
                        t.isBeginning ? t.a11y.notify(a.firstSlideMessage) : t.a11y.notify(a.prevSlideMessage)),
                    t.pagination && s.is("." + t.params.pagination.bulletClass) && s[0].click();
            },
            notify(e) {
                const t = this.a11y.liveRegion;
                0 !== t.length && (t.html(""), t.html(e));
            },
            updateNavigation() {
                const e = this;
                if (e.params.loop || !e.navigation) return;
                const { $nextEl: t, $prevEl: a } = e.navigation;
                a &&
                    a.length > 0 &&
                    (e.isBeginning
                        ? (e.a11y.disableEl(a), e.a11y.makeElNotFocusable(a))
                        : (e.a11y.enableEl(a), e.a11y.makeElFocusable(a))),
                    t &&
                        t.length > 0 &&
                        (e.isEnd
                            ? (e.a11y.disableEl(t), e.a11y.makeElNotFocusable(t))
                            : (e.a11y.enableEl(t), e.a11y.makeElFocusable(t)));
            },
            updatePagination() {
                const e = this,
                    t = e.params.a11y;
                e.pagination &&
                    e.params.pagination.clickable &&
                    e.pagination.bullets &&
                    e.pagination.bullets.length &&
                    e.pagination.bullets.each((a, s) => {
                        const i = d(s);
                        e.a11y.makeElFocusable(i),
                            e.a11y.addElRole(i, "button"),
                            e.a11y.addElLabel(i, t.paginationBulletMessage.replace(/\{\{index\}\}/, i.index() + 1));
                    });
            },
            init() {
                const e = this;
                e.$el.append(e.a11y.liveRegion);
                const t = e.params.a11y;
                let a, s;
                e.navigation && e.navigation.$nextEl && (a = e.navigation.$nextEl),
                    e.navigation && e.navigation.$prevEl && (s = e.navigation.$prevEl),
                    a &&
                        (e.a11y.makeElFocusable(a),
                        e.a11y.addElRole(a, "button"),
                        e.a11y.addElLabel(a, t.nextSlideMessage),
                        a.on("keydown", e.a11y.onEnterKey)),
                    s &&
                        (e.a11y.makeElFocusable(s),
                        e.a11y.addElRole(s, "button"),
                        e.a11y.addElLabel(s, t.prevSlideMessage),
                        s.on("keydown", e.a11y.onEnterKey)),
                    e.pagination &&
                        e.params.pagination.clickable &&
                        e.pagination.bullets &&
                        e.pagination.bullets.length &&
                        e.pagination.$el.on("keydown", "." + e.params.pagination.bulletClass, e.a11y.onEnterKey);
            },
            destroy() {
                const e = this;
                let t, a;
                e.a11y.liveRegion && e.a11y.liveRegion.length > 0 && e.a11y.liveRegion.remove(),
                    e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl),
                    e.navigation && e.navigation.$prevEl && (a = e.navigation.$prevEl),
                    t && t.off("keydown", e.a11y.onEnterKey),
                    a && a.off("keydown", e.a11y.onEnterKey),
                    e.pagination &&
                        e.params.pagination.clickable &&
                        e.pagination.bullets &&
                        e.pagination.bullets.length &&
                        e.pagination.$el.off("keydown", "." + e.params.pagination.bulletClass, e.a11y.onEnterKey);
            },
        };
        const te = {
            init() {
                const e = this;
                if (!e.params.history) return;
                if (!o.history || !o.history.pushState)
                    return (e.params.history.enabled = !1), void (e.params.hashNavigation.enabled = !0);
                const t = e.history;
                (t.initialized = !0),
                    (t.paths = te.getPathValues()),
                    (t.paths.key || t.paths.value) &&
                        (t.scrollToSlide(0, t.paths.value, e.params.runCallbacksOnInit),
                        e.params.history.replaceState || o.addEventListener("popstate", e.history.setHistoryPopState));
            },
            destroy() {
                const e = this;
                e.params.history.replaceState || o.removeEventListener("popstate", e.history.setHistoryPopState);
            },
            setHistoryPopState() {
                (this.history.paths = te.getPathValues()),
                    this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1);
            },
            getPathValues() {
                const e = o.location.pathname
                        .slice(1)
                        .split("/")
                        .filter((e) => "" !== e),
                    t = e.length;
                return { key: e[t - 2], value: e[t - 1] };
            },
            setHistory(e, t) {
                if (!this.history.initialized || !this.params.history.enabled) return;
                const a = this.slides.eq(t);
                let s = te.slugify(a.attr("data-history"));
                o.location.pathname.includes(e) || (s = `${e}/${s}`);
                const i = o.history.state;
                (i && i.value === s) ||
                    (this.params.history.replaceState
                        ? o.history.replaceState({ value: s }, null, s)
                        : o.history.pushState({ value: s }, null, s));
            },
            slugify: (e) =>
                e
                    .toString()
                    .replace(/\s+/g, "-")
                    .replace(/[^\w-]+/g, "")
                    .replace(/--+/g, "-")
                    .replace(/^-+/, "")
                    .replace(/-+$/, ""),
            scrollToSlide(e, t, a) {
                const s = this;
                if (t)
                    for (let i = 0, n = s.slides.length; i < n; i += 1) {
                        const n = s.slides.eq(i);
                        if (te.slugify(n.attr("data-history")) === t && !n.hasClass(s.params.slideDuplicateClass)) {
                            const t = n.index();
                            s.slideTo(t, e, a);
                        }
                    }
                else s.slideTo(0, e, a);
            },
        };
        const ae = {
            onHashCange() {
                const e = this;
                e.emit("hashChange");
                const t = n.location.hash.replace("#", "");
                if (t !== e.slides.eq(e.activeIndex).attr("data-hash")) {
                    const a = e.$wrapperEl.children(`.${e.params.slideClass}[data-hash="${t}"]`).index();
                    if (void 0 === a) return;
                    e.slideTo(a);
                }
            },
            setHash() {
                const e = this;
                if (e.hashNavigation.initialized && e.params.hashNavigation.enabled)
                    if (e.params.hashNavigation.replaceState && o.history && o.history.replaceState)
                        o.history.replaceState(null, null, "#" + e.slides.eq(e.activeIndex).attr("data-hash") || ""),
                            e.emit("hashSet");
                    else {
                        const t = e.slides.eq(e.activeIndex),
                            a = t.attr("data-hash") || t.attr("data-history");
                        (n.location.hash = a || ""), e.emit("hashSet");
                    }
            },
            init() {
                const e = this;
                if (!e.params.hashNavigation.enabled || (e.params.history && e.params.history.enabled)) return;
                e.hashNavigation.initialized = !0;
                const t = n.location.hash.replace("#", "");
                if (t) {
                    const a = 0;
                    for (let s = 0, i = e.slides.length; s < i; s += 1) {
                        const i = e.slides.eq(s);
                        if (
                            (i.attr("data-hash") || i.attr("data-history")) === t &&
                            !i.hasClass(e.params.slideDuplicateClass)
                        ) {
                            const t = i.index();
                            e.slideTo(t, a, e.params.runCallbacksOnInit, !0);
                        }
                    }
                }
                e.params.hashNavigation.watchState && d(o).on("hashchange", e.hashNavigation.onHashCange);
            },
            destroy() {
                const e = this;
                e.params.hashNavigation.watchState && d(o).off("hashchange", e.hashNavigation.onHashCange);
            },
        };
        const se = {
            run() {
                const e = this,
                    t = e.slides.eq(e.activeIndex);
                let a = e.params.autoplay.delay;
                t.attr("data-swiper-autoplay") && (a = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
                    clearTimeout(e.autoplay.timeout),
                    (e.autoplay.timeout = p.nextTick(() => {
                        e.params.autoplay.reverseDirection
                            ? e.params.loop
                                ? (e.loopFix(), e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay"))
                                : e.isBeginning
                                  ? e.params.autoplay.stopOnLastSlide
                                      ? e.autoplay.stop()
                                      : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit("autoplay"))
                                  : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay"))
                            : e.params.loop
                              ? (e.loopFix(), e.slideNext(e.params.speed, !0, !0), e.emit("autoplay"))
                              : e.isEnd
                                ? e.params.autoplay.stopOnLastSlide
                                    ? e.autoplay.stop()
                                    : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay"))
                                : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")),
                            e.params.cssMode && e.autoplay.running && e.autoplay.run();
                    }, a));
            },
            start() {
                return (
                    void 0 === this.autoplay.timeout &&
                    !this.autoplay.running &&
                    ((this.autoplay.running = !0), this.emit("autoplayStart"), this.autoplay.run(), !0)
                );
            },
            stop() {
                const e = this;
                return (
                    !!e.autoplay.running &&
                    void 0 !== e.autoplay.timeout &&
                    (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), (e.autoplay.timeout = void 0)),
                    (e.autoplay.running = !1),
                    e.emit("autoplayStop"),
                    !0)
                );
            },
            pause(e) {
                const t = this;
                t.autoplay.running &&
                    (t.autoplay.paused ||
                        (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
                        (t.autoplay.paused = !0),
                        0 !== e && t.params.autoplay.waitForTransition
                            ? (t.$wrapperEl[0].addEventListener("transitionend", t.autoplay.onTransitionEnd),
                              t.$wrapperEl[0].addEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd))
                            : ((t.autoplay.paused = !1), t.autoplay.run())));
            },
        };
        const ie = {
            setTranslate() {
                const e = this,
                    { slides: t } = e;
                for (let a = 0; a < t.length; a += 1) {
                    const t = e.slides.eq(a);
                    let s = -t[0].swiperSlideOffset;
                    e.params.virtualTranslate || (s -= e.translate);
                    let i = 0;
                    e.isHorizontal() || ((i = s), (s = 0));
                    const n = e.params.fadeEffect.crossFade
                        ? Math.max(1 - Math.abs(t[0].progress), 0)
                        : 1 + Math.min(Math.max(t[0].progress, -1), 0);
                    t.css({ opacity: n }).transform(`translate3d(${s}px, ${i}px, 0px)`);
                }
            },
            setTransition(e) {
                const t = this,
                    { slides: a, $wrapperEl: s } = t;
                if ((a.transition(e), t.params.virtualTranslate && 0 !== e)) {
                    let e = !1;
                    a.transitionEnd(() => {
                        if (e) return;
                        if (!t || t.destroyed) return;
                        (e = !0), (t.animating = !1);
                        const a = ["webkitTransitionEnd", "transitionend"];
                        for (let e = 0; e < a.length; e += 1) s.trigger(a[e]);
                    });
                }
            },
        };
        const ne = {
            setTranslate() {
                const { $el: e, $wrapperEl: t, slides: a, width: s, height: i, rtlTranslate: n, size: r } = this,
                    o = this.params.cubeEffect,
                    l = this.isHorizontal(),
                    c = this.virtual && this.params.virtual.enabled;
                let u,
                    p = 0;
                o.shadow &&
                    (l
                        ? ((u = t.find(".swiper-cube-shadow")),
                          0 === u.length && ((u = d('<div class="swiper-cube-shadow"></div>')), t.append(u)),
                          u.css({ height: s + "px" }))
                        : ((u = e.find(".swiper-cube-shadow")),
                          0 === u.length && ((u = d('<div class="swiper-cube-shadow"></div>')), e.append(u))));
                for (let e = 0; e < a.length; e += 1) {
                    const t = a.eq(e);
                    let s = e;
                    c && (s = parseInt(t.attr("data-swiper-slide-index"), 10));
                    let i = 90 * s,
                        u = Math.floor(i / 360);
                    n && ((i = -i), (u = Math.floor(-i / 360)));
                    const h = Math.max(Math.min(t[0].progress, 1), -1);
                    let m = 0,
                        f = 0,
                        g = 0;
                    s % 4 == 0
                        ? ((m = 4 * -u * r), (g = 0))
                        : (s - 1) % 4 == 0
                          ? ((m = 0), (g = 4 * -u * r))
                          : (s - 2) % 4 == 0
                            ? ((m = r + 4 * u * r), (g = r))
                            : (s - 3) % 4 == 0 && ((m = -r), (g = 3 * r + 4 * r * u)),
                        n && (m = -m),
                        l || ((f = m), (m = 0));
                    const v = `rotateX(${l ? 0 : -i}deg) rotateY(${l ? i : 0}deg) translate3d(${m}px, ${f}px, ${g}px)`;
                    if (
                        (h <= 1 && h > -1 && ((p = 90 * s + 90 * h), n && (p = 90 * -s - 90 * h)),
                        t.transform(v),
                        o.slideShadows)
                    ) {
                        let e = l ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
                            a = l ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                        0 === e.length &&
                            ((e = d(`<div class="swiper-slide-shadow-${l ? "left" : "top"}"></div>`)), t.append(e)),
                            0 === a.length &&
                                ((a = d(`<div class="swiper-slide-shadow-${l ? "right" : "bottom"}"></div>`)),
                                t.append(a)),
                            e.length && (e[0].style.opacity = Math.max(-h, 0)),
                            a.length && (a[0].style.opacity = Math.max(h, 0));
                    }
                }
                if (
                    (t.css({
                        "-webkit-transform-origin": `50% 50% -${r / 2}px`,
                        "-moz-transform-origin": `50% 50% -${r / 2}px`,
                        "-ms-transform-origin": `50% 50% -${r / 2}px`,
                        "transform-origin": `50% 50% -${r / 2}px`,
                    }),
                    o.shadow)
                )
                    if (l)
                        u.transform(
                            `translate3d(0px, ${s / 2 + o.shadowOffset}px, ${-s / 2}px) rotateX(90deg) rotateZ(0deg) scale(${o.shadowScale})`
                        );
                    else {
                        const e = Math.abs(p) - 90 * Math.floor(Math.abs(p) / 90),
                            t = 1.5 - (Math.sin((2 * e * Math.PI) / 360) / 2 + Math.cos((2 * e * Math.PI) / 360) / 2),
                            a = o.shadowScale,
                            s = o.shadowScale / t,
                            n = o.shadowOffset;
                        u.transform(
                            `scale3d(${a}, 1, ${s}) translate3d(0px, ${i / 2 + n}px, ${-i / 2 / s}px) rotateX(-90deg)`
                        );
                    }
                const h = H.isSafari || H.isWebView ? -r / 2 : 0;
                t.transform(
                    `translate3d(0px,0,${h}px) rotateX(${this.isHorizontal() ? 0 : p}deg) rotateY(${this.isHorizontal() ? -p : 0}deg)`
                );
            },
            setTransition(e) {
                const { $el: t, slides: a } = this;
                a
                    .transition(e)
                    .find(
                        ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                    )
                    .transition(e),
                    this.params.cubeEffect.shadow &&
                        !this.isHorizontal() &&
                        t.find(".swiper-cube-shadow").transition(e);
            },
        };
        const re = {
            setTranslate() {
                const e = this,
                    { slides: t, rtlTranslate: a } = e;
                for (let s = 0; s < t.length; s += 1) {
                    const i = t.eq(s);
                    let n = i[0].progress;
                    e.params.flipEffect.limitRotation && (n = Math.max(Math.min(i[0].progress, 1), -1));
                    let r = -180 * n,
                        o = 0,
                        l = -i[0].swiperSlideOffset,
                        c = 0;
                    if (
                        (e.isHorizontal() ? a && (r = -r) : ((c = l), (l = 0), (o = -r), (r = 0)),
                        (i[0].style.zIndex = -Math.abs(Math.round(n)) + t.length),
                        e.params.flipEffect.slideShadows)
                    ) {
                        let t = e.isHorizontal()
                                ? i.find(".swiper-slide-shadow-left")
                                : i.find(".swiper-slide-shadow-top"),
                            a = e.isHorizontal()
                                ? i.find(".swiper-slide-shadow-right")
                                : i.find(".swiper-slide-shadow-bottom");
                        0 === t.length &&
                            ((t = d(`<div class="swiper-slide-shadow-${e.isHorizontal() ? "left" : "top"}"></div>`)),
                            i.append(t)),
                            0 === a.length &&
                                ((a = d(
                                    `<div class="swiper-slide-shadow-${e.isHorizontal() ? "right" : "bottom"}"></div>`
                                )),
                                i.append(a)),
                            t.length && (t[0].style.opacity = Math.max(-n, 0)),
                            a.length && (a[0].style.opacity = Math.max(n, 0));
                    }
                    i.transform(`translate3d(${l}px, ${c}px, 0px) rotateX(${o}deg) rotateY(${r}deg)`);
                }
            },
            setTransition(e) {
                const t = this,
                    { slides: a, activeIndex: s, $wrapperEl: i } = t;
                if (
                    (a
                        .transition(e)
                        .find(
                            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                        )
                        .transition(e),
                    t.params.virtualTranslate && 0 !== e)
                ) {
                    let e = !1;
                    a.eq(s).transitionEnd(function () {
                        if (e) return;
                        if (!t || t.destroyed) return;
                        (e = !0), (t.animating = !1);
                        const a = ["webkitTransitionEnd", "transitionend"];
                        for (let e = 0; e < a.length; e += 1) i.trigger(a[e]);
                    });
                }
            },
        };
        const oe = {
            setTranslate() {
                const { width: e, height: t, slides: a, $wrapperEl: s, slidesSizesGrid: i } = this,
                    n = this.params.coverflowEffect,
                    r = this.isHorizontal(),
                    o = this.translate,
                    l = r ? e / 2 - o : t / 2 - o,
                    c = r ? n.rotate : -n.rotate,
                    u = n.depth;
                for (let e = 0, t = a.length; e < t; e += 1) {
                    const t = a.eq(e),
                        s = i[e],
                        o = ((l - t[0].swiperSlideOffset - s / 2) / s) * n.modifier;
                    let p = r ? c * o : 0,
                        h = r ? 0 : c * o,
                        m = -u * Math.abs(o),
                        f = n.stretch;
                    "string" == typeof f && -1 !== f.indexOf("%") && (f = (parseFloat(n.stretch) / 100) * s);
                    let g = r ? 0 : f * o,
                        v = r ? f * o : 0,
                        b = 1 - (1 - n.scale) * Math.abs(o);
                    Math.abs(v) < 0.001 && (v = 0),
                        Math.abs(g) < 0.001 && (g = 0),
                        Math.abs(m) < 0.001 && (m = 0),
                        Math.abs(p) < 0.001 && (p = 0),
                        Math.abs(h) < 0.001 && (h = 0),
                        Math.abs(b) < 0.001 && (b = 0);
                    const y = `translate3d(${v}px,${g}px,${m}px)  rotateX(${h}deg) rotateY(${p}deg) scale(${b})`;
                    if ((t.transform(y), (t[0].style.zIndex = 1 - Math.abs(Math.round(o))), n.slideShadows)) {
                        let e = r ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
                            a = r ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                        0 === e.length &&
                            ((e = d(`<div class="swiper-slide-shadow-${r ? "left" : "top"}"></div>`)), t.append(e)),
                            0 === a.length &&
                                ((a = d(`<div class="swiper-slide-shadow-${r ? "right" : "bottom"}"></div>`)),
                                t.append(a)),
                            e.length && (e[0].style.opacity = o > 0 ? o : 0),
                            a.length && (a[0].style.opacity = -o > 0 ? -o : 0);
                    }
                }
                if (h.pointerEvents || h.prefixedPointerEvents) {
                    s[0].style.perspectiveOrigin = l + "px 50%";
                }
            },
            setTransition(e) {
                this.slides
                    .transition(e)
                    .find(
                        ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                    )
                    .transition(e);
            },
        };
        const le = {
            init() {
                const e = this,
                    { thumbs: t } = e.params,
                    a = e.constructor;
                t.swiper instanceof a
                    ? ((e.thumbs.swiper = t.swiper),
                      p.extend(e.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                      p.extend(e.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }))
                    : p.isObject(t.swiper) &&
                      ((e.thumbs.swiper = new a(
                          p.extend({}, t.swiper, {
                              watchSlidesVisibility: !0,
                              watchSlidesProgress: !0,
                              slideToClickedSlide: !1,
                          })
                      )),
                      (e.thumbs.swiperCreated = !0)),
                    e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),
                    e.thumbs.swiper.on("tap", e.thumbs.onThumbClick);
            },
            onThumbClick() {
                const e = this,
                    t = e.thumbs.swiper;
                if (!t) return;
                const a = t.clickedIndex,
                    s = t.clickedSlide;
                if (s && d(s).hasClass(e.params.thumbs.slideThumbActiveClass)) return;
                if (null == a) return;
                let i;
                if (
                    ((i = t.params.loop ? parseInt(d(t.clickedSlide).attr("data-swiper-slide-index"), 10) : a),
                    e.params.loop)
                ) {
                    let t = e.activeIndex;
                    e.slides.eq(t).hasClass(e.params.slideDuplicateClass) &&
                        (e.loopFix(), (e._clientLeft = e.$wrapperEl[0].clientLeft), (t = e.activeIndex));
                    const a = e.slides.eq(t).prevAll(`[data-swiper-slide-index="${i}"]`).eq(0).index(),
                        s = e.slides.eq(t).nextAll(`[data-swiper-slide-index="${i}"]`).eq(0).index();
                    i = void 0 === a ? s : void 0 === s ? a : s - t < t - a ? s : a;
                }
                e.slideTo(i);
            },
            update(e) {
                const t = this,
                    a = t.thumbs.swiper;
                if (!a) return;
                const s = "auto" === a.params.slidesPerView ? a.slidesPerViewDynamic() : a.params.slidesPerView,
                    i = t.params.thumbs.autoScrollOffset,
                    n = i && !a.params.loop;
                if (t.realIndex !== a.realIndex || n) {
                    let r,
                        o,
                        l = a.activeIndex;
                    if (a.params.loop) {
                        a.slides.eq(l).hasClass(a.params.slideDuplicateClass) &&
                            (a.loopFix(), (a._clientLeft = a.$wrapperEl[0].clientLeft), (l = a.activeIndex));
                        const e = a.slides.eq(l).prevAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index(),
                            s = a.slides.eq(l).nextAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index();
                        (r = void 0 === e ? s : void 0 === s ? e : s - l == l - e ? l : s - l < l - e ? s : e),
                            (o = t.activeIndex > t.previousIndex ? "next" : "prev");
                    } else (r = t.realIndex), (o = r > t.previousIndex ? "next" : "prev");
                    n && (r += "next" === o ? i : -1 * i),
                        a.visibleSlidesIndexes &&
                            a.visibleSlidesIndexes.indexOf(r) < 0 &&
                            (a.params.centeredSlides
                                ? (r = r > l ? r - Math.floor(s / 2) + 1 : r + Math.floor(s / 2) - 1)
                                : r > l && (r = r - s + 1),
                            a.slideTo(r, e ? 0 : void 0));
                }
                let r = 1;
                const o = t.params.thumbs.slideThumbActiveClass;
                if (
                    (t.params.slidesPerView > 1 && !t.params.centeredSlides && (r = t.params.slidesPerView),
                    t.params.thumbs.multipleActiveThumbs || (r = 1),
                    (r = Math.floor(r)),
                    a.slides.removeClass(o),
                    a.params.loop || (a.params.virtual && a.params.virtual.enabled))
                )
                    for (let e = 0; e < r; e += 1)
                        a.$wrapperEl.children(`[data-swiper-slide-index="${t.realIndex + e}"]`).addClass(o);
                else for (let e = 0; e < r; e += 1) a.slides.eq(t.realIndex + e).addClass(o);
            },
        };
        const de = [
            I,
            D,
            N,
            j,
            B,
            X,
            F,
            {
                name: "mousewheel",
                params: {
                    mousewheel: {
                        enabled: !1,
                        releaseOnEdges: !1,
                        invert: !1,
                        forceToAxis: !1,
                        sensitivity: 1,
                        eventsTarged: "container",
                    },
                },
                create() {
                    p.extend(this, {
                        mousewheel: {
                            enabled: !1,
                            enable: V.enable.bind(this),
                            disable: V.disable.bind(this),
                            handle: V.handle.bind(this),
                            handleMouseEnter: V.handleMouseEnter.bind(this),
                            handleMouseLeave: V.handleMouseLeave.bind(this),
                            animateSlider: V.animateSlider.bind(this),
                            releaseScroll: V.releaseScroll.bind(this),
                            lastScrollTime: p.now(),
                            lastEventBeforeSnap: void 0,
                            recentWheelEvents: [],
                        },
                    });
                },
                on: {
                    init() {
                        const e = this;
                        !e.params.mousewheel.enabled && e.params.cssMode && e.mousewheel.disable(),
                            e.params.mousewheel.enabled && e.mousewheel.enable();
                    },
                    destroy() {
                        const e = this;
                        e.params.cssMode && e.mousewheel.enable(), e.mousewheel.enabled && e.mousewheel.disable();
                    },
                },
            },
            {
                name: "navigation",
                params: {
                    navigation: {
                        nextEl: null,
                        prevEl: null,
                        hideOnClick: !1,
                        disabledClass: "swiper-button-disabled",
                        hiddenClass: "swiper-button-hidden",
                        lockClass: "swiper-button-lock",
                    },
                },
                create() {
                    p.extend(this, {
                        navigation: {
                            init: Y.init.bind(this),
                            update: Y.update.bind(this),
                            destroy: Y.destroy.bind(this),
                            onNextClick: Y.onNextClick.bind(this),
                            onPrevClick: Y.onPrevClick.bind(this),
                        },
                    });
                },
                on: {
                    init() {
                        this.navigation.init(), this.navigation.update();
                    },
                    toEdge() {
                        this.navigation.update();
                    },
                    fromEdge() {
                        this.navigation.update();
                    },
                    destroy() {
                        this.navigation.destroy();
                    },
                    click(e) {
                        const t = this,
                            { $nextEl: a, $prevEl: s } = t.navigation;
                        if (t.params.navigation.hideOnClick && !d(e.target).is(s) && !d(e.target).is(a)) {
                            let e;
                            a
                                ? (e = a.hasClass(t.params.navigation.hiddenClass))
                                : s && (e = s.hasClass(t.params.navigation.hiddenClass)),
                                !0 === e ? t.emit("navigationShow", t) : t.emit("navigationHide", t),
                                a && a.toggleClass(t.params.navigation.hiddenClass),
                                s && s.toggleClass(t.params.navigation.hiddenClass);
                        }
                    },
                },
            },
            {
                name: "pagination",
                params: {
                    pagination: {
                        el: null,
                        bulletElement: "span",
                        clickable: !1,
                        hideOnClick: !1,
                        renderBullet: null,
                        renderProgressbar: null,
                        renderFraction: null,
                        renderCustom: null,
                        progressbarOpposite: !1,
                        type: "bullets",
                        dynamicBullets: !1,
                        dynamicMainBullets: 1,
                        formatFractionCurrent: (e) => e,
                        formatFractionTotal: (e) => e,
                        bulletClass: "swiper-pagination-bullet",
                        bulletActiveClass: "swiper-pagination-bullet-active",
                        modifierClass: "swiper-pagination-",
                        currentClass: "swiper-pagination-current",
                        totalClass: "swiper-pagination-total",
                        hiddenClass: "swiper-pagination-hidden",
                        progressbarFillClass: "swiper-pagination-progressbar-fill",
                        progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
                        clickableClass: "swiper-pagination-clickable",
                        lockClass: "swiper-pagination-lock",
                    },
                },
                create() {
                    p.extend(this, {
                        pagination: {
                            init: W.init.bind(this),
                            render: W.render.bind(this),
                            update: W.update.bind(this),
                            destroy: W.destroy.bind(this),
                            dynamicBulletIndex: 0,
                        },
                    });
                },
                on: {
                    init() {
                        this.pagination.init(), this.pagination.render(), this.pagination.update();
                    },
                    activeIndexChange() {
                        const e = this;
                        (e.params.loop || void 0 === e.snapIndex) && e.pagination.update();
                    },
                    snapIndexChange() {
                        const e = this;
                        e.params.loop || e.pagination.update();
                    },
                    slidesLengthChange() {
                        const e = this;
                        e.params.loop && (e.pagination.render(), e.pagination.update());
                    },
                    snapGridLengthChange() {
                        const e = this;
                        e.params.loop || (e.pagination.render(), e.pagination.update());
                    },
                    destroy() {
                        this.pagination.destroy();
                    },
                    click(e) {
                        const t = this;
                        if (
                            t.params.pagination.el &&
                            t.params.pagination.hideOnClick &&
                            t.pagination.$el.length > 0 &&
                            !d(e.target).hasClass(t.params.pagination.bulletClass)
                        ) {
                            !0 === t.pagination.$el.hasClass(t.params.pagination.hiddenClass)
                                ? t.emit("paginationShow", t)
                                : t.emit("paginationHide", t),
                                t.pagination.$el.toggleClass(t.params.pagination.hiddenClass);
                        }
                    },
                },
            },
            {
                name: "scrollbar",
                params: {
                    scrollbar: {
                        el: null,
                        dragSize: "auto",
                        hide: !1,
                        draggable: !1,
                        snapOnRelease: !0,
                        lockClass: "swiper-scrollbar-lock",
                        dragClass: "swiper-scrollbar-drag",
                    },
                },
                create() {
                    p.extend(this, {
                        scrollbar: {
                            init: U.init.bind(this),
                            destroy: U.destroy.bind(this),
                            updateSize: U.updateSize.bind(this),
                            setTranslate: U.setTranslate.bind(this),
                            setTransition: U.setTransition.bind(this),
                            enableDraggable: U.enableDraggable.bind(this),
                            disableDraggable: U.disableDraggable.bind(this),
                            setDragPosition: U.setDragPosition.bind(this),
                            getPointerPosition: U.getPointerPosition.bind(this),
                            onDragStart: U.onDragStart.bind(this),
                            onDragMove: U.onDragMove.bind(this),
                            onDragEnd: U.onDragEnd.bind(this),
                            isTouched: !1,
                            timeout: null,
                            dragTimeout: null,
                        },
                    });
                },
                on: {
                    init() {
                        this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate();
                    },
                    update() {
                        this.scrollbar.updateSize();
                    },
                    resize() {
                        this.scrollbar.updateSize();
                    },
                    observerUpdate() {
                        this.scrollbar.updateSize();
                    },
                    setTranslate() {
                        this.scrollbar.setTranslate();
                    },
                    setTransition(e) {
                        this.scrollbar.setTransition(e);
                    },
                    destroy() {
                        this.scrollbar.destroy();
                    },
                },
            },
            {
                name: "parallax",
                params: { parallax: { enabled: !1 } },
                create() {
                    p.extend(this, {
                        parallax: {
                            setTransform: K.setTransform.bind(this),
                            setTranslate: K.setTranslate.bind(this),
                            setTransition: K.setTransition.bind(this),
                        },
                    });
                },
                on: {
                    beforeInit() {
                        this.params.parallax.enabled &&
                            ((this.params.watchSlidesProgress = !0), (this.originalParams.watchSlidesProgress = !0));
                    },
                    init() {
                        this.params.parallax.enabled && this.parallax.setTranslate();
                    },
                    setTranslate() {
                        this.params.parallax.enabled && this.parallax.setTranslate();
                    },
                    setTransition(e) {
                        this.params.parallax.enabled && this.parallax.setTransition(e);
                    },
                },
            },
            {
                name: "zoom",
                params: {
                    zoom: {
                        enabled: !1,
                        maxRatio: 3,
                        minRatio: 1,
                        toggle: !0,
                        containerClass: "swiper-zoom-container",
                        zoomedSlideClass: "swiper-slide-zoomed",
                    },
                },
                create() {
                    const e = this,
                        t = {
                            enabled: !1,
                            scale: 1,
                            currentScale: 1,
                            isScaling: !1,
                            gesture: {
                                $slideEl: void 0,
                                slideWidth: void 0,
                                slideHeight: void 0,
                                $imageEl: void 0,
                                $imageWrapEl: void 0,
                                maxRatio: 3,
                            },
                            image: {
                                isTouched: void 0,
                                isMoved: void 0,
                                currentX: void 0,
                                currentY: void 0,
                                minX: void 0,
                                minY: void 0,
                                maxX: void 0,
                                maxY: void 0,
                                width: void 0,
                                height: void 0,
                                startX: void 0,
                                startY: void 0,
                                touchesStart: {},
                                touchesCurrent: {},
                            },
                            velocity: {
                                x: void 0,
                                y: void 0,
                                prevPositionX: void 0,
                                prevPositionY: void 0,
                                prevTime: void 0,
                            },
                        };
                    "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out"
                        .split(" ")
                        .forEach((a) => {
                            t[a] = J[a].bind(e);
                        }),
                        p.extend(e, { zoom: t });
                    let a = 1;
                    Object.defineProperty(e.zoom, "scale", {
                        get: () => a,
                        set(t) {
                            if (a !== t) {
                                const a = e.zoom.gesture.$imageEl ? e.zoom.gesture.$imageEl[0] : void 0,
                                    s = e.zoom.gesture.$slideEl ? e.zoom.gesture.$slideEl[0] : void 0;
                                e.emit("zoomChange", t, a, s);
                            }
                            a = t;
                        },
                    });
                },
                on: {
                    init() {
                        const e = this;
                        e.params.zoom.enabled && e.zoom.enable();
                    },
                    destroy() {
                        this.zoom.disable();
                    },
                    touchStart(e) {
                        this.zoom.enabled && this.zoom.onTouchStart(e);
                    },
                    touchEnd(e) {
                        this.zoom.enabled && this.zoom.onTouchEnd(e);
                    },
                    doubleTap(e) {
                        const t = this;
                        t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && t.zoom.toggle(e);
                    },
                    transitionEnd() {
                        const e = this;
                        e.zoom.enabled && e.params.zoom.enabled && e.zoom.onTransitionEnd();
                    },
                    slideChange() {
                        const e = this;
                        e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && e.zoom.onTransitionEnd();
                    },
                },
            },
            {
                name: "lazy",
                params: {
                    lazy: {
                        enabled: !1,
                        loadPrevNext: !1,
                        loadPrevNextAmount: 1,
                        loadOnTransitionStart: !1,
                        elementClass: "swiper-lazy",
                        loadingClass: "swiper-lazy-loading",
                        loadedClass: "swiper-lazy-loaded",
                        preloaderClass: "swiper-lazy-preloader",
                    },
                },
                create() {
                    p.extend(this, {
                        lazy: {
                            initialImageLoaded: !1,
                            load: Z.load.bind(this),
                            loadInSlide: Z.loadInSlide.bind(this),
                        },
                    });
                },
                on: {
                    beforeInit() {
                        const e = this;
                        e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1);
                    },
                    init() {
                        const e = this;
                        e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && e.lazy.load();
                    },
                    scroll() {
                        const e = this;
                        e.params.freeMode && !e.params.freeModeSticky && e.lazy.load();
                    },
                    resize() {
                        const e = this;
                        e.params.lazy.enabled && e.lazy.load();
                    },
                    scrollbarDragMove() {
                        const e = this;
                        e.params.lazy.enabled && e.lazy.load();
                    },
                    transitionStart() {
                        const e = this;
                        e.params.lazy.enabled &&
                            (e.params.lazy.loadOnTransitionStart ||
                                (!e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded)) &&
                            e.lazy.load();
                    },
                    transitionEnd() {
                        const e = this;
                        e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load();
                    },
                    slideChange() {
                        const e = this;
                        e.params.lazy.enabled && e.params.cssMode && e.lazy.load();
                    },
                },
            },
            {
                name: "controller",
                params: { controller: { control: void 0, inverse: !1, by: "slide" } },
                create() {
                    p.extend(this, {
                        controller: {
                            control: this.params.controller.control,
                            getInterpolateFunction: Q.getInterpolateFunction.bind(this),
                            setTranslate: Q.setTranslate.bind(this),
                            setTransition: Q.setTransition.bind(this),
                        },
                    });
                },
                on: {
                    update() {
                        const e = this;
                        e.controller.control &&
                            e.controller.spline &&
                            ((e.controller.spline = void 0), delete e.controller.spline);
                    },
                    resize() {
                        const e = this;
                        e.controller.control &&
                            e.controller.spline &&
                            ((e.controller.spline = void 0), delete e.controller.spline);
                    },
                    observerUpdate() {
                        const e = this;
                        e.controller.control &&
                            e.controller.spline &&
                            ((e.controller.spline = void 0), delete e.controller.spline);
                    },
                    setTranslate(e, t) {
                        this.controller.control && this.controller.setTranslate(e, t);
                    },
                    setTransition(e, t) {
                        this.controller.control && this.controller.setTransition(e, t);
                    },
                },
            },
            {
                name: "a11y",
                params: {
                    a11y: {
                        enabled: !0,
                        notificationClass: "swiper-notification",
                        prevSlideMessage: "Previous slide",
                        nextSlideMessage: "Next slide",
                        firstSlideMessage: "This is the first slide",
                        lastSlideMessage: "This is the last slide",
                        paginationBulletMessage: "Go to slide {{index}}",
                    },
                },
                create() {
                    const e = this;
                    p.extend(e, {
                        a11y: {
                            liveRegion: d(
                                `<span class="${e.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`
                            ),
                        },
                    }),
                        Object.keys(ee).forEach((t) => {
                            e.a11y[t] = ee[t].bind(e);
                        });
                },
                on: {
                    init() {
                        this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation());
                    },
                    toEdge() {
                        this.params.a11y.enabled && this.a11y.updateNavigation();
                    },
                    fromEdge() {
                        this.params.a11y.enabled && this.a11y.updateNavigation();
                    },
                    paginationUpdate() {
                        this.params.a11y.enabled && this.a11y.updatePagination();
                    },
                    destroy() {
                        this.params.a11y.enabled && this.a11y.destroy();
                    },
                },
            },
            {
                name: "history",
                params: { history: { enabled: !1, replaceState: !1, key: "slides" } },
                create() {
                    p.extend(this, {
                        history: {
                            init: te.init.bind(this),
                            setHistory: te.setHistory.bind(this),
                            setHistoryPopState: te.setHistoryPopState.bind(this),
                            scrollToSlide: te.scrollToSlide.bind(this),
                            destroy: te.destroy.bind(this),
                        },
                    });
                },
                on: {
                    init() {
                        const e = this;
                        e.params.history.enabled && e.history.init();
                    },
                    destroy() {
                        const e = this;
                        e.params.history.enabled && e.history.destroy();
                    },
                    transitionEnd() {
                        const e = this;
                        e.history.initialized && e.history.setHistory(e.params.history.key, e.activeIndex);
                    },
                    slideChange() {
                        const e = this;
                        e.history.initialized &&
                            e.params.cssMode &&
                            e.history.setHistory(e.params.history.key, e.activeIndex);
                    },
                },
            },
            {
                name: "hash-navigation",
                params: { hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 } },
                create() {
                    p.extend(this, {
                        hashNavigation: {
                            initialized: !1,
                            init: ae.init.bind(this),
                            destroy: ae.destroy.bind(this),
                            setHash: ae.setHash.bind(this),
                            onHashCange: ae.onHashCange.bind(this),
                        },
                    });
                },
                on: {
                    init() {
                        const e = this;
                        e.params.hashNavigation.enabled && e.hashNavigation.init();
                    },
                    destroy() {
                        const e = this;
                        e.params.hashNavigation.enabled && e.hashNavigation.destroy();
                    },
                    transitionEnd() {
                        const e = this;
                        e.hashNavigation.initialized && e.hashNavigation.setHash();
                    },
                    slideChange() {
                        const e = this;
                        e.hashNavigation.initialized && e.params.cssMode && e.hashNavigation.setHash();
                    },
                },
            },
            {
                name: "autoplay",
                params: {
                    autoplay: {
                        enabled: !1,
                        delay: 3e3,
                        waitForTransition: !0,
                        disableOnInteraction: !0,
                        stopOnLastSlide: !1,
                        reverseDirection: !1,
                    },
                },
                create() {
                    const e = this;
                    p.extend(e, {
                        autoplay: {
                            running: !1,
                            paused: !1,
                            run: se.run.bind(e),
                            start: se.start.bind(e),
                            stop: se.stop.bind(e),
                            pause: se.pause.bind(e),
                            onVisibilityChange() {
                                "hidden" === document.visibilityState && e.autoplay.running && e.autoplay.pause(),
                                    "visible" === document.visibilityState &&
                                        e.autoplay.paused &&
                                        (e.autoplay.run(), (e.autoplay.paused = !1));
                            },
                            onTransitionEnd(t) {
                                e &&
                                    !e.destroyed &&
                                    e.$wrapperEl &&
                                    t.target === this &&
                                    (e.$wrapperEl[0].removeEventListener("transitionend", e.autoplay.onTransitionEnd),
                                    e.$wrapperEl[0].removeEventListener(
                                        "webkitTransitionEnd",
                                        e.autoplay.onTransitionEnd
                                    ),
                                    (e.autoplay.paused = !1),
                                    e.autoplay.running ? e.autoplay.run() : e.autoplay.stop());
                            },
                        },
                    });
                },
                on: {
                    init() {
                        const e = this;
                        e.params.autoplay.enabled &&
                            (e.autoplay.start(),
                            document.addEventListener("visibilitychange", e.autoplay.onVisibilityChange));
                    },
                    beforeTransitionStart(e, t) {
                        const a = this;
                        a.autoplay.running &&
                            (t || !a.params.autoplay.disableOnInteraction ? a.autoplay.pause(e) : a.autoplay.stop());
                    },
                    sliderFirstMove() {
                        const e = this;
                        e.autoplay.running &&
                            (e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause());
                    },
                    touchEnd() {
                        const e = this;
                        e.params.cssMode &&
                            e.autoplay.paused &&
                            !e.params.autoplay.disableOnInteraction &&
                            e.autoplay.run();
                    },
                    destroy() {
                        const e = this;
                        e.autoplay.running && e.autoplay.stop(),
                            document.removeEventListener("visibilitychange", e.autoplay.onVisibilityChange);
                    },
                },
            },
            {
                name: "effect-fade",
                params: { fadeEffect: { crossFade: !1 } },
                create() {
                    p.extend(this, {
                        fadeEffect: {
                            setTranslate: ie.setTranslate.bind(this),
                            setTransition: ie.setTransition.bind(this),
                        },
                    });
                },
                on: {
                    beforeInit() {
                        if ("fade" !== this.params.effect) return;
                        this.classNames.push(this.params.containerModifierClass + "fade");
                        const e = {
                            slidesPerView: 1,
                            slidesPerColumn: 1,
                            slidesPerGroup: 1,
                            watchSlidesProgress: !0,
                            spaceBetween: 0,
                            virtualTranslate: !0,
                        };
                        p.extend(this.params, e), p.extend(this.originalParams, e);
                    },
                    setTranslate() {
                        "fade" === this.params.effect && this.fadeEffect.setTranslate();
                    },
                    setTransition(e) {
                        "fade" === this.params.effect && this.fadeEffect.setTransition(e);
                    },
                },
            },
            {
                name: "effect-cube",
                params: { cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } },
                create() {
                    p.extend(this, {
                        cubeEffect: {
                            setTranslate: ne.setTranslate.bind(this),
                            setTransition: ne.setTransition.bind(this),
                        },
                    });
                },
                on: {
                    beforeInit() {
                        if ("cube" !== this.params.effect) return;
                        this.classNames.push(this.params.containerModifierClass + "cube"),
                            this.classNames.push(this.params.containerModifierClass + "3d");
                        const e = {
                            slidesPerView: 1,
                            slidesPerColumn: 1,
                            slidesPerGroup: 1,
                            watchSlidesProgress: !0,
                            resistanceRatio: 0,
                            spaceBetween: 0,
                            centeredSlides: !1,
                            virtualTranslate: !0,
                        };
                        p.extend(this.params, e), p.extend(this.originalParams, e);
                    },
                    setTranslate() {
                        "cube" === this.params.effect && this.cubeEffect.setTranslate();
                    },
                    setTransition(e) {
                        "cube" === this.params.effect && this.cubeEffect.setTransition(e);
                    },
                },
            },
            {
                name: "effect-flip",
                params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
                create() {
                    p.extend(this, {
                        flipEffect: {
                            setTranslate: re.setTranslate.bind(this),
                            setTransition: re.setTransition.bind(this),
                        },
                    });
                },
                on: {
                    beforeInit() {
                        if ("flip" !== this.params.effect) return;
                        this.classNames.push(this.params.containerModifierClass + "flip"),
                            this.classNames.push(this.params.containerModifierClass + "3d");
                        const e = {
                            slidesPerView: 1,
                            slidesPerColumn: 1,
                            slidesPerGroup: 1,
                            watchSlidesProgress: !0,
                            spaceBetween: 0,
                            virtualTranslate: !0,
                        };
                        p.extend(this.params, e), p.extend(this.originalParams, e);
                    },
                    setTranslate() {
                        "flip" === this.params.effect && this.flipEffect.setTranslate();
                    },
                    setTransition(e) {
                        "flip" === this.params.effect && this.flipEffect.setTransition(e);
                    },
                },
            },
            {
                name: "effect-coverflow",
                params: {
                    coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: !0 },
                },
                create() {
                    p.extend(this, {
                        coverflowEffect: {
                            setTranslate: oe.setTranslate.bind(this),
                            setTransition: oe.setTransition.bind(this),
                        },
                    });
                },
                on: {
                    beforeInit() {
                        "coverflow" === this.params.effect &&
                            (this.classNames.push(this.params.containerModifierClass + "coverflow"),
                            this.classNames.push(this.params.containerModifierClass + "3d"),
                            (this.params.watchSlidesProgress = !0),
                            (this.originalParams.watchSlidesProgress = !0));
                    },
                    setTranslate() {
                        "coverflow" === this.params.effect && this.coverflowEffect.setTranslate();
                    },
                    setTransition(e) {
                        "coverflow" === this.params.effect && this.coverflowEffect.setTransition(e);
                    },
                },
            },
            {
                name: "thumbs",
                params: {
                    thumbs: {
                        swiper: null,
                        multipleActiveThumbs: !0,
                        autoScrollOffset: 0,
                        slideThumbActiveClass: "swiper-slide-thumb-active",
                        thumbsContainerClass: "swiper-container-thumbs",
                    },
                },
                create() {
                    p.extend(this, {
                        thumbs: {
                            swiper: null,
                            init: le.init.bind(this),
                            update: le.update.bind(this),
                            onThumbClick: le.onThumbClick.bind(this),
                        },
                    });
                },
                on: {
                    beforeInit() {
                        const { thumbs: e } = this.params;
                        e && e.swiper && (this.thumbs.init(), this.thumbs.update(!0));
                    },
                    slideChange() {
                        this.thumbs.swiper && this.thumbs.update();
                    },
                    update() {
                        this.thumbs.swiper && this.thumbs.update();
                    },
                    resize() {
                        this.thumbs.swiper && this.thumbs.update();
                    },
                    observerUpdate() {
                        this.thumbs.swiper && this.thumbs.update();
                    },
                    setTransition(e) {
                        const t = this.thumbs.swiper;
                        t && t.setTransition(e);
                    },
                    beforeDestroy() {
                        const e = this.thumbs.swiper;
                        e && this.thumbs.swiperCreated && e && e.destroy();
                    },
                },
            },
        ];
        void 0 === A.use && ((A.use = A.Class.use), (A.installModule = A.Class.installModule)), A.use(de);
        t.a = A;
    },
    238: function (e, t, a) {},
    287: function (e, t, a) {
        "use strict";
        a.r(t);
        a(238), a(18);
        function s() {
            const e = document.querySelectorAll("[data-dropdown]");
            e.length &&
                e.forEach((e) => {
                    !(function (e) {
                        if (null === e) return;
                        const t = e.querySelector("[data-dropdown-toggle]"),
                            a = e.querySelector("[data-dropdown-list]"),
                            s = e.querySelectorAll("[data-dropdown-option]"),
                            d = e.querySelector("[data-dropdown-input]"),
                            c = e.querySelector("[data-dropdown-overlay]"),
                            u = e.querySelector("[data-dropdown-option][aria-selected]");
                        t.addEventListener("keydown", i),
                            t.addEventListener("click", i),
                            a.addEventListener("keydown", r),
                            s.forEach((e) => {
                                e.addEventListener("click", o), e.addEventListener("keydown", o);
                            }),
                            c.addEventListener("click", () => n(e)),
                            d.addEventListener("change", o),
                            u && l(u, e);
                    })(e);
                });
        }
        function i(e) {
            const t = document.querySelectorAll("[data-dropdown]");
            if (e.code && ("Space" !== e.code || "Enter" !== e.code)) return;
            const a = e.target.closest("[data-dropdown]"),
                s = a.querySelector("[data-dropdown-list]");
            a.classList.contains("is-active")
                ? n(a)
                : (t.forEach((e) => n(e)),
                  a.classList.add("is-active"),
                  a.setAttribute("aria-expanded", "true"),
                  s.removeAttribute("hidden"),
                  setTimeout(() => {
                      s.focus();
                  }, 100));
        }
        function n(e) {
            const t = e.querySelector("[data-dropdown-list]");
            e.classList.remove("is-active"), e.setAttribute("aria-expanded", "false"), t.setAttribute("hidden", "");
        }
        function r(e) {
            const t = e.keyCode,
                a = e.currentTarget.closest("[data-dropdown]"),
                s = a.querySelectorAll("[data-dropdown-option]"),
                i = [...s].indexOf(a.querySelector('[aria-activedescendant="true"]'));
            let r = 0;
            switch (t) {
                case 13:
                case 32:
                    e.preventDefault(), o(e);
                    break;
                case 27:
                    e.preventDefault(), n(a);
                    break;
                case 35:
                    e.preventDefault(), (r = s.length - 1), d(r, i);
                    break;
                case 36:
                    e.preventDefault(), (r = s[0]), d(r, i);
                    break;
                case 38:
                    e.preventDefault(), (r = i > 0 ? i - 1 : 0), d(r, i);
                    break;
                case 40:
                    e.preventDefault(), (r = i < s.length - 1 ? i + 1 : s.length - 1), d(r, i);
            }
        }
        function o(e) {
            let t, a;
            "change" === e.type
                ? ((a = e.target.closest("[data-dropdown]")),
                  (t = a.querySelector(`[data-dropdown-option][data-value="${e.target.value}"]`)))
                : ((t =
                      (e.code && "Enter" === e.code) || "Space" === e.code
                          ? e.target.querySelector("[aria-activedescendant]")
                          : e.target),
                  (a = t.closest("[data-dropdown]"))),
                l(t, a, e);
        }
        function l(e, t, a = null) {
            const s = e.querySelector("[data-dropdown-option-text]"),
                i = t.querySelector("[data-dropdown-toggle-text]"),
                r = t.querySelectorAll("[data-dropdown-option]"),
                o = t.querySelector("[data-dropdown-input]"),
                l = o.closest("form");
            r.forEach((e) => {
                e.removeAttribute("aria-selected"), e.removeAttribute("aria-activedescendant");
            }),
                e.setAttribute("aria-selected", "true"),
                e.setAttribute("aria-activedescendant", "true");
            let d = "";
            (d = null === s ? e.innerText : s.innerHTML),
                t.dataset.preLabel && (d = `<strong>${t.dataset.preLabel}:</strong> ${d}`),
                (i.innerHTML = d);
            const c = "number" === o.type ? Number(e.dataset.value) : e.dataset.value;
            (o.value = c),
                a &&
                    "change" !== a.type &&
                    (o.dispatchEvent(new Event("change")), l && l.dispatchEvent(new Event("change"))),
                n(t);
        }
        function d(e, t) {
            const a = event.currentTarget.querySelectorAll("[data-dropdown-option]");
            let s = a[e];
            void 0 !== s &&
                "hidden" !== s.dataset.state &&
                (s.hasAttribute("aria-selected") && e > t
                    ? (s = a[e + 1])
                    : s.hasAttribute("aria-selected") && e < t && (s = a[e - 1]),
                null != s &&
                    (a.forEach((e) => e.removeAttribute("aria-activedescendant")),
                    s.setAttribute("aria-activedescendant", "true"),
                    setTimeout(() => {
                        s.focus();
                    }, 10)));
        }
        document.addEventListener("DOMContentLoaded", () => {
            s();
        });
        var c = a(6),
            u = a.n(c),
            p = a(4),
            h = a(162);
        function m() {
            const e = document.querySelector("[data-collection-bundle-drawer]"),
                t = document.querySelector("[data-collection-grid-wrapper]"),
                a = t.getAttribute("data-collection-handle"),
                s = t.getAttribute("data-collection-name"),
                i = "collection_bundle_selected_items_" + a,
                n = "collection_bundle_pack_size_" + a,
                r = document.querySelector("[data-collection-json]"),
                o = JSON.parse(r.innerHTML),
                l = document.querySelector("[data-collection-bundle-price-original]"),
                d = document.querySelector("[data-collection-bundle-price-original-value]"),
                c = document.querySelector("[data-collection-bundle-price-bundle-value]"),
                h = document.querySelector("[data-bundle-add-to-cart]"),
                m = document.querySelectorAll("[data-collection-bundle-item]"),
                f = document.querySelector("[data-collection-bundle-pack-size-input]"),
                g = document.querySelector("[data-collection-bundle-slot-grid]"),
                v = document.querySelectorAll("[data-collection-bundle-slot]"),
                b = document.querySelector('[data-collection-bundle-slot="4"]'),
                y = document.querySelector('[data-collection-bundle-pack-button][data-pack="4"]'),
                w = document.querySelector("[data-site-body]");
            let S = null,
                x = [],
                E = null,
                T = null,
                C = null,
                M = 0;
            function L(e) {
                const t = document.querySelector(`[data-collection-bundle-item][data-product-id="${e}"]`);
                if (!t) return;
                const a = t.querySelector("[data-collection-item-added-count]"),
                    s = x.reduce((t, a) => (a.productId === e ? t + parseInt(a.quantity, 10) : t), 0);
                (a.textContent = s), s > 0 ? t.classList.add("is-added") : t.classList.remove("is-added");
            }
            function $() {
                u.a.set(i, JSON.stringify(x), { expires: 7 });
            }
            function k() {
                const e = x.reduce((e, t) => e + parseInt(t.quantity, 10), 0);
                M = e;
            }
            function P(e) {
                const t = document.querySelector(`[data-collection-bundle-item][data-product-id="${e.productId}"]`),
                    a = t.querySelector("[data-collection-bundle-item-img]"),
                    s = t.querySelector("[data-product-json]"),
                    i = JSON.parse(s.innerHTML).variants.find((t) => t.id === parseInt(e.variantId, 10)),
                    n = document.querySelectorAll('[data-collection-bundle-slot][data-state="empty"]');
                if (n.length) {
                    for (let t = 0; t < e.quantity; t++) {
                        const s = n[t];
                        if (!s) break;
                        3 === S &&
                            "4" === s.getAttribute("data-collection-bundle-slot") &&
                            (s.classList.remove("hide"), (f.value = 4), f.dispatchEvent(new Event("change")));
                        const r = s.querySelector("[data-collection-bundle-slot-image]");
                        let o = a.src,
                            l = i.title;
                        i.featured_image &&
                            i.featured_image.src &&
                            (o = i.featured_image.src.replace(".png", "_360x.png")),
                            i.featured_image && i.featured_image.alt && (l = i.featured_image.alt),
                            s.classList.remove("empty"),
                            s.setAttribute("data-state", "full"),
                            s.setAttribute("data-variant-id", e.variantId),
                            (r.innerHTML = `<img src="${o}" alt="${l}" />`);
                    }
                    if (i.featured_image && i.featured_image.src) {
                        const e = i.featured_image.src.replace(".png", "_720x.png");
                        a.src = e;
                    }
                    L(e.productId), k(), A(), O(), I();
                }
            }
            function z(t) {
                const a = document.querySelector("[data-collection-bundle-select-pack]"),
                    s = document.querySelector("[data-collection-bundle-builder]");
                e.classList.add("active"),
                    s.classList.remove("hide"),
                    a.classList.add("hide"),
                    (f.value = t),
                    f.dispatchEvent(new Event("change"));
            }
            function q(e) {
                const t = x.find((t) => parseInt(t.variantId, 10) === parseInt(e.dataset.variantId, 10));
                if (!t) return;
                const a = x.indexOf(t),
                    s = e.querySelector("[data-collection-bundle-slot-image]");
                parseInt(t.quantity, 10) > 1 ? (t.quantity -= 1) : x.splice(a, 1),
                    (s.innerHTML = ""),
                    e.removeAttribute("data-variant-id"),
                    e.setAttribute("data-state", "empty"),
                    e.classList.add("empty"),
                    L(t.productId),
                    k(),
                    I(),
                    O(),
                    A(),
                    $();
            }
            function O() {
                if (!x.length)
                    return (
                        (c.textContent = Shopify.formatMoney(0, theme.moneyFormat)),
                        (d.textContent = Shopify.formatMoney(0, theme.moneyFormat)),
                        void l.classList.add("hide")
                    );
                const e = x.reduce((e, t) => e + t.price * t.quantity, 0);
                let t = 0;
                "dollar" === E ? (t = e - T * M * 100) : "percent" === E && (t = e - e * (T / 100)),
                    l.classList.remove("hide"),
                    (c.textContent = Shopify.formatMoney(t, theme.moneyFormat)),
                    (d.textContent = Shopify.formatMoney(e, theme.moneyFormat));
            }
            function A() {
                M < S
                    ? ((h.innerHTML = `${M}/${S} products`), h.setAttribute("disabled", !0))
                    : ((h.innerHTML = h.dataset.addToCartText), h.removeAttribute("disabled"));
            }
            function I() {
                const e = 4 - M;
                m.forEach((t) => {
                    const a = t.querySelector("[data-collection-bundle-item-quantity]"),
                        s = t.querySelector("[data-collection-bundle-item-form]"),
                        i = t.querySelector("[data-collection-bundle-item-bundle-full-notice]");
                    a.setAttribute("max", e),
                        4 === S && e < 1
                            ? (s.classList.add("hide"), i.classList.remove("hide"))
                            : (s.classList.remove("hide"), i.classList.add("hide")),
                        a.value > e ? (a.value = e) : (a.value = 1);
                });
            }
            function D(e, t) {
                return {
                    id: e.variantId,
                    quantity: 1,
                    properties: {
                        _bundle_id: `${a}_${Date.now()}`,
                        _bundle_name: `${C} ${s}`,
                        _bundle_collection_handle: a,
                        _bundle_discount_type: E,
                        _bundle_discount_amount: T,
                        _bundle_item: t,
                    },
                };
            }
            m.length &&
                (h.addEventListener("click", function () {
                    if (!x.length || M < S) return;
                    const e = { items: [] };
                    let t = 0;
                    x.forEach((a) => {
                        if (a.quantity > 1)
                            for (let s = 0; s < a.quantity; s++) {
                                const s = D(a, t);
                                e.items.push(s), t++;
                            }
                        else {
                            const s = D(a, t);
                            e.items.push(s), t++;
                        }
                    }),
                        (function (e) {
                            const t = document.querySelector("[data-cart-route]").dataset.cartAddRoute + ".js";
                            fetch(t, {
                                method: "POST",
                                credentials: "same-origin",
                                headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                                body: JSON.stringify(e),
                            })
                                .then((e) => e.json())
                                .then((e) => {
                                    if (e.status) throw new Error(e.description);
                                    return (
                                        Object(p.a)(!0),
                                        Object(p.b)(),
                                        v.forEach((e) => {
                                            q(e);
                                        }),
                                        null
                                    );
                                })
                                .catch((e) => {
                                    alert(e);
                                });
                        })(e);
                }),
                m.forEach((e) => {
                    !(function (e) {
                        const t = e.querySelector("[data-bundle-item-variant-id]"),
                            a = e.querySelectorAll("[data-collection-bundle-option-input]"),
                            s = e.querySelectorAll("[data-collection-bundle-option-select]"),
                            i = e.querySelector("[data-product-json]"),
                            n = JSON.parse(i.innerHTML),
                            r = e.querySelector("[data-collection-bundle-item-add-to-cart]"),
                            o = e.querySelector("[data-collection-bundle-flip-button]"),
                            l = e.querySelector("[data-collection-bundle-item-close]"),
                            d = e.querySelector("[data-collection-bundle-item-quantity]");
                        let c = n.variants.find((e) => e.id === parseInt(t.value, 10));
                        a.length &&
                            s.forEach((e) => {
                                e.querySelector("[data-collection-bundle-option-input]").addEventListener(
                                    "change",
                                    () => {
                                        const e = [...a].reduce(
                                            (e, t) => (
                                                (e[t.getAttribute("data-collection-bundle-option-input")] = t.value), e
                                            ),
                                            {}
                                        );
                                        if (
                                            ((c = n.variants.find((t) => {
                                                const a = [];
                                                for (const [s, i] of Object.entries(e)) a.push(t[s] === i);
                                                return !a.includes(!1);
                                            })),
                                            void 0 === c)
                                        )
                                            (r.innerHTML = r.getAttribute("data-unavailable-text")),
                                                r.setAttribute("disabled", !0);
                                        else if (!1 === c.available)
                                            (r.innerHTML = r.getAttribute("data-sold-out-text")),
                                                r.setAttribute("disabled", !0);
                                        else {
                                            t.value = c.id;
                                            let e = r.getAttribute("data-available-text");
                                            (e = e.replace("[price]", Shopify.formatMoney(c.price, theme.moneyFormat))),
                                                (r.innerHTML = e),
                                                r.removeAttribute("disabled");
                                        }
                                    }
                                );
                            });
                        o.addEventListener("click", (t) => {
                            t.preventDefault(), e.classList.add("active"), null === S && y.click();
                        }),
                            l.addEventListener("click", (t) => {
                                t.preventDefault(), e.classList.remove("active"), o.focus();
                            }),
                            r.addEventListener("click", (t) => {
                                t.preventDefault();
                                const a = {
                                    productId: parseInt(e.dataset.productId, 10),
                                    variantId: c.id,
                                    quantity: parseInt(d.value, 10),
                                    price: c.price,
                                };
                                x.push(a), P(a), $(), e.classList.remove("active");
                            });
                    })(e),
                        (function (e) {
                            const t = e.querySelectorAll("[data-collection-bundle-item-quantity-button]"),
                                a = e.querySelector("[data-collection-bundle-item-quantity]"),
                                s = e.querySelector("[data-collection-bundle-item-close]");
                            if (!t.length || !a) return;
                            t.forEach((e) => {
                                e.addEventListener("click", () => {
                                    const t = parseInt(a.value, 10);
                                    "plus" === e.getAttribute("data-action")
                                        ? (a.value = t < a.max ? t + 1 : a.max)
                                        : "minus" === e.getAttribute("data-action") &&
                                          ((a.value = t > 2 ? t - 1 : 1), 1 === t && s.click());
                                });
                            });
                        })(e);
                }),
                f.addEventListener("change", () => {
                    !(function (t) {
                        const a = parseInt(t, 10),
                            s = document.querySelectorAll('[data-collection-bundle-slot][data-state="emtpy"]');
                        let i = null;
                        (E = o.custom_fields[t + "_pack_discount_type"]),
                            (T = o.custom_fields[t + "_pack_discount_amount"]),
                            e.classList.add("active"),
                            w.classList.remove("bundle-pack-selected-3", "bundle-pack-selected-4"),
                            w.classList.add("bundle-pack-selected-" + t),
                            3 === a
                                ? (g.classList.remove("pack-4"),
                                  g.classList.add("pack-3"),
                                  s.length ? (i = s[s.length - 1]) : ((i = v[v.length - 1]), q(i)),
                                  i.classList.add("hide"),
                                  i.setAttribute("data-state", "empty"))
                                : 4 === a &&
                                  (g.classList.remove("pack-3"),
                                  g.classList.add("pack-4"),
                                  b.classList.remove("hide"),
                                  b.setAttribute("data-state", "empty"));
                        (S = a),
                            (C = o.custom_fields[S + "_pack_display_name"]),
                            u.a.set(n, S, { expires: 7 }),
                            A(),
                            I(),
                            O();
                    })(f.value);
                }),
                (function () {
                    const e = u.a.get(n);
                    if (null == e) return;
                    z(parseInt(e, 10));
                })(),
                (function () {
                    const e = u.a.get(i);
                    null != e &&
                        ((x = JSON.parse(e)),
                        x.length &&
                            x.forEach((e) => {
                                P(e);
                            }));
                })(),
                (function () {
                    const e = document.querySelectorAll("[data-collection-bundle-pack-button]");
                    e.length &&
                        e.forEach((e) => {
                            e.addEventListener("click", () => {
                                z(parseInt(e.dataset.pack, 10));
                            });
                        });
                })(),
                (function () {
                    const e = document.querySelectorAll("[data-collection-bundle-slot-remove]");
                    e.length &&
                        e.forEach((e) => {
                            e.addEventListener("click", () => {
                                q(e.closest("[data-collection-bundle-slot]"));
                            });
                        });
                })(),
                I());
        }
        document.addEventListener("DOMContentLoaded", () => {
            m(),
                (function () {
                    const e = document.querySelector("[data-site-body]");
                    let t = 0;
                    window.addEventListener("scroll", function () {
                        const a = window.pageYOffset || document.documentElement.scrollTop;
                        a > 200 && e.classList.add("bundle-scrolled"),
                            a > t
                                ? e.classList.remove("bundle-up-scroll")
                                : a < t && e.classList.add("bundle-up-scroll"),
                            (t = a <= 0 ? 0 : a);
                    });
                })(),
                (async function () {
                    const e = document.querySelectorAll("[data-size-guide-target]");
                    if (e.length) {
                        for (let t = 0; t < e.length; t++) {
                            const a = e[t],
                                s = a.dataset.sectionUrl;
                            await fetch(s)
                                .then((e) => e.text())
                                .then((e) => ((a.innerHTML = e), e))
                                .catch((e) => {
                                    alert(e);
                                });
                        }
                        Object(h.a)();
                    }
                })();
        });
    },
    3: function (e, t, a) {
        "use strict";
        function s(e, t) {
            t = t || {};
            var a = e.tabIndex;
            (e.tabIndex = -1),
                (e.dataset.tabIndex = a),
                e.focus(),
                void 0 !== t.className && e.classList.add(t.className),
                e.addEventListener("blur", function s(i) {
                    i.target.removeEventListener(i.type, s),
                        (e.tabIndex = a),
                        delete e.dataset.tabIndex,
                        void 0 !== t.className && e.classList.remove(t.className);
                });
        }
        function i(e) {
            e = e || {};
            var t = window.location.hash,
                a = document.getElementById(t.slice(1));
            if (a && e.ignore && a.matches(e.ignore)) return !1;
            t && a && s(a, e);
        }
        function n(e) {
            return (
                (e = e || {}),
                Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (t) {
                    if ("#" === t.hash || "" === t.hash) return !1;
                    if (e.ignore && t.matches(e.ignore)) return !1;
                    var a = document.querySelector(t.hash);
                    return (
                        !!a &&
                        (t.addEventListener("click", function () {
                            s(a, e);
                        }),
                        !0)
                    );
                })
            );
        }
        a.d(t, "b", function () {
            return i;
        }),
            a.d(t, "a", function () {
                return n;
            }),
            a.d(t, "d", function () {
                return o;
            }),
            a.d(t, "c", function () {
                return l;
            });
        var r = {};
        function o(e, t) {
            t = t || {};
            var a = (function (e) {
                    return Array.prototype.slice
                        .call(
                            e.querySelectorAll(
                                "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
                            )
                        )
                        .filter(function (e) {
                            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
                        });
                })(e),
                i = t.elementToFocus || e,
                n = a[0],
                o = a[a.length - 1];
            l(),
                (r.focusin = function (t) {
                    e === t.target || e.contains(t.target) || n.focus(),
                        (t.target !== e && t.target !== o && t.target !== n) ||
                            document.addEventListener("keydown", r.keydown);
                }),
                (r.focusout = function () {
                    document.removeEventListener("keydown", r.keydown);
                }),
                (r.keydown = function (t) {
                    9 === t.keyCode &&
                        (t.target !== o || t.shiftKey || (t.preventDefault(), n.focus()),
                        (t.target !== e && t.target !== n) || !t.shiftKey || (t.preventDefault(), o.focus()));
                }),
                document.addEventListener("focusout", r.focusout),
                document.addEventListener("focusin", r.focusin),
                s(i, t);
        }
        function l() {
            document.removeEventListener("focusin", r.focusin),
                document.removeEventListener("focusout", r.focusout),
                document.removeEventListener("keydown", r.keydown);
        }
    },
    4: function (e, t, a) {
        "use strict";
        a.d(t, "a", function () {
            return f;
        }),
            a.d(t, "b", function () {
                return g;
            });
        var s = a(1),
            i = a(3),
            n = a(2),
            r = a(5),
            o = a(8);
        function l() {
            const e = document.querySelector("[data-cart-route]").dataset.cartRoute + ".js",
                t = document.querySelector("[data-cart-route]").dataset.cartAddRoute + ".js";
            Object(s.a)(e, {
                method: "GET",
                credentials: "same-origin",
                headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
            })
                .then((e) => e.json())
                .then((e) => {
                    let a = !1;
                    for (let t = 0; t < e.items.length; t++)
                        if (Object.values(e.items[t].properties).includes("free_gift")) {
                            a = !0;
                            break;
                        }
                    if (a) f(!0), g();
                    else {
                        const e = {
                            id: document.querySelector("body").dataset.autoGiftVarId,
                            quantity: 1,
                            properties: { _discount: "free_gift" },
                        };
                        Object(s.a)(t, {
                            method: "POST",
                            credentials: "same-origin",
                            headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                            body: JSON.stringify(e),
                        })
                            .then((e) => e.json())
                            .then((e) => {
                                if (e.status) throw new Error(e.description);
                                return f(!0), g(), null;
                            });
                    }
                });
        }
        function d(e, t) {
            const a = { id: e, quantity: t },
                i = document.querySelector("[data-cart-route]").dataset.cartChangeRoute + ".js";
            Object(s.a)(i, {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                body: JSON.stringify(a),
            })
                .then((e) => e.json())
                .then((e) => {
                    f();
                })
                .catch((e) => {
                    console.log(e);
                });
        }
        function c(e) {
            const t = e.querySelectorAll("[data-recipe-item]");
            if (!t.length) return;
            const a = { updates: {} };
            t.forEach((e) => {
                a.updates[e.dataset.lineItemKey] = 0;
            }),
                m(a);
        }
        function u(e) {
            const t = e.querySelectorAll("[data-bundle-item]");
            if (!t.length) return;
            const a = { updates: {} };
            t.forEach((e) => {
                a.updates[e.dataset.lineItemKey] = 0;
            }),
                m(a);
        }
        async function p() {
            document.querySelector(".sidecart-gamification") &&
                (await Object(s.a)(window.Shopify.routes.root + "?section_id=sidecart-gamification")
                    .then((e) => e.text())
                    .then((e) => {
                        document.querySelector(".drawer__header").innerHTML = e;
                    }));
        }
        function h(e, t) {
            let a = document.querySelector("[data-product-handle]");
            if (
                a ||
                document.body.classList.contains("template-collection") ||
                document.body.classList.contains("template-search")
            ) {
                const i = new URLSearchParams(window.location.search).get("variant");
                let n = e || i,
                    r = t ? t.getAttribute("data-handle") : "",
                    o = !1;
                if ((r && (o = r), a && (o = a.getAttribute("data-product-handle")), !o)) return !1;
                Object(s.a)(`/products/${o}?variant=${n}&section_id=product-price`)
                    .then((e) => e.text())
                    .then((e) => {
                        let a = document.createElement("div");
                        a.innerHTML = e;
                        let s = a.querySelector("product-price");
                        (t
                            ? t.querySelector("product-price")
                            : document.querySelector(".product-single__meta product-price")
                        ).innerHTML = s.innerHTML;
                    });
            }
        }
        async function m(e, t = !0) {
            const a = document.querySelector("[data-cart-route]").dataset.cartUpdateRoute + ".js";
            return await Object(s.a)(a, {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                body: JSON.stringify(e),
            })
                .then((e) => e.json())
                .then((e) => (!0 === t && (f(), g(e)), e))
                .catch((e) => (console.log(e), null));
        }
        function f(e) {
            const t = document.querySelector("[data-ajaxcart-content]"),
                a = document.querySelector("[data-cart-content]"),
                n = document.querySelector("[data-drawer-right]"),
                l = document.querySelector("[data-site-html]"),
                c = document.querySelector("[data-site-body]"),
                u = document.querySelector("[data-site-overlay]"),
                m = document.querySelector("[data-cart-route]").dataset.cartRoute;
            Object(s.a)(m + "?view=ajax", {
                credentials: "same-origin",
                headers: {
                    "X-Requested-With": "xmlhttprequest",
                    "Cache-Control": "no-cache, no-store, must-revalidate",
                    Pragma: "no-cache",
                    Expires: 0,
                },
            })
                .then((e) => e.text())
                .then((m) => {
                    !(async function (e) {
                        let t = document.querySelector(e);
                        t &&
                            (await Object(s.a)(window.Shopify.routes.root + "?section_id=sidecart-gamification")
                                .then((e) => e.text())
                                .then((e) => {
                                    t.innerHTML = e;
                                }));
                    })("#heroBannerGamification"),
                        p(),
                        document.body.classList.contains("template-collection") &&
                            Object(s.a)(`${window.location.pathname}${window.location.search}`)
                                .then((e) => e.text())
                                .then((e) => {
                                    let t = document.createElement("div");
                                    t.innerHTML = e;
                                    let a = t.querySelector('div[id*="collection_main"]');
                                    document.querySelector('div[id*="collection_main"]').innerHTML = a.outerHTML;
                                    let s = new CustomEvent("shopify:section:load");
                                    document.dispatchEvent(s);
                                }),
                        h(),
                        (function () {
                            const e = document.querySelector("#freegift");
                            e &&
                                "US" == window.Shopify.country &&
                                Object(s.a)("/cart.js")
                                    .then((e) => e.json())
                                    .then((t) => {
                                        const a = e.value,
                                            i = e.dataset.quantity,
                                            n = Number(e.dataset.minPrice).toFixed();
                                        if (
                                            t.total_price / 100 -
                                                (t.items.find((e) => "true" == e.properties._discount)
                                                    ? t.items.find((e) => "true" == e.properties._discount)
                                                          .final_line_price
                                                    : 0) /
                                                    100 >=
                                            n
                                        ) {
                                            t.items.find((e) => e.id == a) ||
                                                Object(s.a)("/cart/add.js", {
                                                    method: "POST",
                                                    headers: { "Content-Type": "application/json" },
                                                    body: JSON.stringify({
                                                        id: a,
                                                        quantity: i,
                                                        properties: { _discount: "true" },
                                                    }),
                                                })
                                                    .then((e) => e.json())
                                                    .then((e) => {
                                                        f();
                                                        alert("Product added to your cart.");
                                                    })
                                                    .catch((e) => {
                                                        console.error("Error al agregar el producto:", e);
                                                    });
                                        } else {
                                            let e = t.items.find((e) => e.id == a && "true" == e.properties._discount);
                                            e &&
                                                Object(s.a)(`/cart/change.js?id=${e.key}&quantity=0`, {
                                                    method: "POST",
                                                })
                                                    .then((e) => e.json())
                                                    .then((e) => {
                                                        f();
                                                    })
                                                    .catch((e) => {
                                                        console.error("Error al remover el producto:", e);
                                                    });
                                        }
                                    })
                                    .catch((e) => {
                                        console.error("Error al obtener el carrito:", e);
                                    });
                        })();
                    const g = new DOMParser().parseFromString(m, "text/html"),
                        v = g.querySelector("[data-site-body]").getAttribute("data-line-item-count");
                    if ((document.querySelector("[data-site-body]").setAttribute("data-line-item-count", v), t)) {
                        const e = g.querySelector("[data-ajaxcart-content]").innerHTML;
                        t.innerHTML = e;
                    }
                    if (a) {
                        const e = g.querySelector("[data-cart-content]").innerHTML;
                        a.innerHTML = e;
                    }
                    null != document.querySelector("[data-upsell-item]") && Object(r.a)();
                    null != document.querySelector("[data-gift-order-form]") && Object(o.giftOrder)(),
                        e &&
                            (n.removeAttribute("hidden"),
                            setTimeout(() => {
                                n.classList.add("active");
                            }, 10),
                            l.classList.add("drawer-active"),
                            c.classList.add("drawer-active"),
                            u.classList.add("active"),
                            Object(i.d)(n));
                    const y = document.querySelector(".promo-banner__action"),
                        w = g.querySelector("[data-discount-count]").dataset.discountCount;
                    if (y) {
                        let e = "";
                        0 == w
                            ? (e = "Add 2 More Full Price items for 20% Off")
                            : 1 == w
                              ? (e = "Add 1 More Full Price item for 20% Off")
                              : 2 == w
                                ? (e = "Add 1 More Full Price item for 25% Off")
                                : 3 == w
                                  ? (e = "Add 1 More Full Price item for 30% Off")
                                  : w > 3 && (e = "You're getting 30% Off!"),
                            (y.innerText = e);
                    }
                    return (
                        (function () {
                            if ("true" !== document.body.dataset.dataTariffSurcharge) return;
                            Object(s.a)("/cart.js")
                                .then((e) => e.json())
                                .then((e) => {
                                    let t,
                                        a,
                                        i = e.total_price,
                                        n = !1;
                                    const r = { id: null, quantity: 1 },
                                        o = document.querySelector("[data-cart-route]").dataset.cartAddRoute + ".js";
                                    for (let s = 0; s < e.items.length; s++)
                                        if (e.items[s].title.includes("Tariff")) {
                                            (n = !0),
                                                (t = e.items[s].price),
                                                (a = e.items[s].key),
                                                (i = (e.total_price - t) / 100);
                                            break;
                                        }
                                    if (i > 5 && i <= 50) {
                                        if (500 == t) return;
                                        (r.id = 42873833259096),
                                            Object(s.a)(o, {
                                                method: "POST",
                                                credentials: "same-origin",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "X-Requested-With": "xmlhttprequest",
                                                },
                                                body: JSON.stringify(r),
                                            }).then(() => {
                                                d(a, 0);
                                            });
                                    } else if (i > 50 && i <= 100) {
                                        if (700 == t) return;
                                        (r.id = 42873833291864),
                                            Object(s.a)(o, {
                                                method: "POST",
                                                credentials: "same-origin",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "X-Requested-With": "xmlhttprequest",
                                                },
                                                body: JSON.stringify(r),
                                            }).then(() => {
                                                d(a, 0);
                                            });
                                    } else if (i > 100) {
                                        if (900 == t) return;
                                        (r.id = 42873833324632),
                                            Object(s.a)(o, {
                                                method: "POST",
                                                credentials: "same-origin",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "X-Requested-With": "xmlhttprequest",
                                                },
                                                body: JSON.stringify(r),
                                            }).then(() => {
                                                d(a, 0);
                                            });
                                    } else {
                                        if (!(i <= 5)) return;
                                        if (!n) return;
                                        d(a, 0);
                                    }
                                })
                                .catch((e) => {
                                    console.error("Error al obtener el carrito:", e);
                                });
                        })(),
                        b(),
                        (function () {
                            const e = document.querySelector(".btn-free-shipping"),
                                t = document.querySelector(".button_default-free-shipping");
                            if (!e && !t) return;
                            const a = document.querySelectorAll("[data-cart-subtotals]")[0];
                            let s = "0";
                            a &&
                                ((s = a.innerText ? a.innerText : void 0),
                                s || (s = a.textContent ? a.textContent : "0"));
                            const i = parseFloat(s.replace(/[^0-9-]+/g, "")),
                                n = document.querySelector(".disclosure__button"),
                                r = n.textContent ? n.textContent : void 0;
                            r || (r = n.innerText ? n.innerText : "");
                            const o = document.querySelector(".product-single__price"),
                                l = o.innerText ? o.innerText : void 0;
                            l || (l = o.textContent ? o.textContent : void 0);
                            const d = parseFloat(l.replace(/[^0-9-]+/g, "")),
                                c = document.getElementById("free-shipping-texts"),
                                u = JSON.parse(c.textContent);
                            i > 4900 && "US" == r.trim()
                                ? (t.classList.remove("show"),
                                  t.classList.add("hide"),
                                  e.classList.remove("hide"),
                                  e.classList.add("show"),
                                  (e.innerText = u.free_shipping_text))
                                : i + d > 4900 && "US" == r.trim()
                                  ? (t.classList.remove("show"),
                                    t.classList.add("hide"),
                                    e.classList.remove("hide"),
                                    e.classList.add("show"),
                                    (e.innerText = u.to_free_shipping_text))
                                  : (e.classList.remove("show"),
                                    e.classList.add("hide"),
                                    t.classList.remove("hide"),
                                    t.classList.add("show"));
                        })(),
                        null
                    );
                })
                .catch((e) => {
                    console.log(e);
                });
        }
        async function g(e = null) {
            const t =
                null === e
                    ? await (async function () {
                          const e = document.querySelector("[data-cart-route]").dataset.cartRoute + ".js";
                          return await Object(s.a)(e, {
                              method: "GET",
                              credentials: "same-origin",
                              headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                          })
                              .then((e) => e.json())
                              .then((e) => e)
                              .catch((e) => (console.log(e), null));
                      })()
                    : e;
            if (null === t) return;
            const a = document.querySelector("[data-cart-item-count]"),
                i = document.querySelectorAll("[data-cart-icon-full]"),
                n = document.querySelectorAll("[data-cart-subtotal]");
            let r = 0,
                o = 0,
                l = 0;
            const d = {},
                c = {};
            document.querySelector("[data-cart-total]").setAttribute("data-cart-total", t.total_price),
                t.items.forEach((e) => {
                    void 0 === e.properties._bundle_id && void 0 === e.properties.RecipeID
                        ? (r += e.quantity)
                        : void 0 === e.properties.RecipeID || e.properties.RecipeID.includes("uc-")
                          ? void 0 !== e.properties._bundle_id && (d[e.properties._bundle_id] = e.quantity)
                          : (c[e.properties.RecipeID.replace("uc-", "")] = e.quantity);
                });
            const u = Object.values(d),
                p = Object.values(c);
            u.length &&
                u.forEach((e) => {
                    o += e;
                }),
                p.length &&
                    p.forEach((e) => {
                        l += e;
                    }),
                (a.innerHTML = r + o + l),
                i.forEach((e) => {
                    (e.innerHTML = r + o + l), t.item_count > 0 ? e.classList.remove("hide") : e.classList.add("hide");
                }),
                t.item_count;
            const h = document.querySelector("[data-cart-discount]");
            if (h) {
                let e = 0;
                document.querySelectorAll("[data-item-discount]").forEach((t) => {
                    const a = t.closest("[data-ajax-cart-line-item]").querySelector("[data-quantity-input]"),
                        s = parseInt(t.getAttribute("data-item-discount")) * a.value;
                    e += s;
                }),
                    (h.innerHTML = `Discount: <span>-${Shopify.formatMoney(e, theme.moneyFormat)}</span>`),
                    h.classList.toggle("hide", 0 == e);
            }
            n.forEach((e) => {
                e.innerHTML = Shopify.formatMoney(t.total_price, theme.moneyFormat);
            });
            const m = document.querySelector("[data-free-gift]");
            if (m) {
                const e = m.dataset.giftId,
                    n = 100 * m.dataset.giftThreshold;
                let d = !1;
                for (let e = 0; e < t.items.length; e++)
                    if (Object.values(t.items[e].properties).indexOf("free_gift") > -1) {
                        d = !0;
                        break;
                    }
                if (t.total_price > n && 0 == d) {
                    const n = { id: e, quantity: 1, properties: { _discount: "free_gift" } },
                        d = document.querySelector("[data-cart-route]").dataset.cartAddRoute + ".js";
                    Object(s.a)(d, {
                        method: "POST",
                        credentials: "same-origin",
                        headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                        body: JSON.stringify(n),
                    }).then((e) => {
                        (a.innerHTML = r + o + l + 1),
                            i.forEach((e) => {
                                (e.innerHTML = r + o + l + 1),
                                    t.item_count > 0 ? e.classList.remove("hide") : e.classList.add("hide");
                            }),
                            f();
                    });
                } else if (t.total_price < 1e4 && d)
                    for (let e = 0; e < t.items.length; e++)
                        if (Object.values(t.items[e].properties).indexOf("free_gift") > -1) {
                            const n = { id: t.items[e].key, quantity: 0 },
                                d = document.querySelector("[data-cart-route]").dataset.cartChangeRoute + ".js";
                            Object(s.a)(d, {
                                method: "POST",
                                credentials: "same-origin",
                                headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                                body: JSON.stringify(n),
                            }).then((e) => {
                                (a.innerHTML = r + o + l - 1),
                                    i.forEach((e) => {
                                        (e.innerHTML = r + o + l - 1),
                                            t.item_count > 0 ? e.classList.remove("hide") : e.classList.add("hide");
                                    }),
                                    f();
                            });
                        }
            }
            setTimeout(() => {
                v();
            }, 1e3);
        }
        function v() {
            new n.a(".swiper-container--personalization", {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: !1,
                observer: !0,
                observeParents: !0,
                parallax: !0,
                speed: 700,
                effect: "fade",
                fadeEffect: { crossFade: !0 },
                pagination: { el: ".swiper-pagination", clickable: !0 },
                lazy: { loadPrevNext: !0 },
            });
        }
        function b() {
            const e = document.querySelector(".cart-recommendations");
            new IntersectionObserver(
                (t, a) => {
                    if (!t[0].isIntersecting) return;
                    a.unobserve(e);
                    const i = e.dataset.url;
                    Object(s.a)(i)
                        .then((e) => e.text())
                        .then((t) => {
                            const a = document.createElement("div");
                            a.innerHTML = t;
                            const s = a.querySelector(".cart-recommendations");
                            s && s.innerHTML.trim().length && (e.innerHTML = s.innerHTML);
                        })
                        .catch((e) => {
                            console.error(e);
                        });
                },
                { rootMargin: "0px 0px 200px 0px" }
            ).observe(e);
        }
        function y(e) {
            if (e) {
                const t = e.getAttribute("data-line-variant-id-remove");
                t &&
                    document.dispatchEvent(
                        new CustomEvent("removeLineItemVariantCustom", { detail: { lineItemVariantId: t } })
                    );
            }
        }
        (window.renderProductPrice = h),
            document.addEventListener("DOMContentLoaded", () => {
                p(),
                    (function () {
                        let e;
                        const t = document.querySelectorAll("[data-add-to-cart]"),
                            a = document.querySelectorAll("[data-upsell-item]"),
                            i = document.querySelector('[data-popup-open-button="product-upsells"]');
                        null != a && Object(r.a)(),
                            t &&
                                document.addEventListener("click", (t) => {
                                    const a = document.querySelector("[data-add-to-cart-form]"),
                                        n = document.querySelector("[data-product-quantity]");
                                    if (t.target.hasAttribute("data-sold-out-product")) return;
                                    if (!t.target.hasAttribute("data-add-to-cart")) return;
                                    t.preventDefault();
                                    let r = !0;
                                    t.target.hasAttribute("data-has-upsell-popup") && i && (r = !1),
                                        (e =
                                            null === t.target.closest("[data-add-to-cart-form]")
                                                ? a.querySelector("[data-product-select]").value
                                                : parseFloat(
                                                      t.target
                                                          .closest("[data-add-to-cart-form]")
                                                          .querySelector("[data-product-select]").value
                                                  ));
                                    let o = 1;
                                    n && (o = parseFloat(n.value));
                                    const d = t.target.closest("[data-add-to-cart-form]"),
                                        c = {};
                                    let u;
                                    (u =
                                        null != d
                                            ? d.querySelectorAll("input, select, textarea")
                                            : a.querySelectorAll("input, select, textarea")),
                                        u.length &&
                                            u.forEach((e) => {
                                                const t = e.getAttribute("name"),
                                                    a = e.getAttribute("type");
                                                if (t && t.indexOf("properties") >= 0) {
                                                    const s = t.split("[")[1].replace("]", "");
                                                    let i = "";
                                                    (a && "radio" === a) || (a && "checkbox" === a)
                                                        ? !0 === e.checked && (i = e.value)
                                                        : (i = e.value),
                                                        "" !== i && (c[s] = i);
                                                }
                                            }),
                                        t.target.hasAttribute("data-osp") &&
                                            (c._osp = t.target.getAttribute("data-osp"));
                                    let p = { items: [{ id: e, quantity: o, properties: c }] };
                                    const h = document.querySelector("[data-cart-route]").dataset.cartAddRoute + ".js";
                                    Object(s.a)(h, {
                                        method: "POST",
                                        credentials: "same-origin",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Requested-With": "xmlhttprequest",
                                        },
                                        body: JSON.stringify(p),
                                    })
                                        .then((e) => e.json())
                                        .then((e) => {
                                            if (e.status) throw new Error(e.description);
                                            if ("true" != document.querySelector("body").dataset.autoGift)
                                                return f(r), g(), null;
                                            l();
                                        })
                                        .catch((e) => {
                                            console.log(e, "error");
                                        });
                                });
                    })(),
                    document.addEventListener("click", (e) => {
                        if (!e.target.hasAttribute("data-line-item-remove")) return;
                        e.preventDefault();
                        const t = e.target.getAttribute("data-line-item-key"),
                            a = e.target.getAttribute("data-line-variant-id-remove");
                        a &&
                            document.dispatchEvent(
                                new CustomEvent("removeLineItemVariantCustom", { detail: { lineItemVariantId: a } })
                            ),
                            d(t, 0);
                    }),
                    document.addEventListener("click", (e) => {
                        e.target.hasAttribute("data-line-item-remove-custom") &&
                            (e.preventDefault(), c(e.target.closest("[data-recipe-item-group]")));
                    }),
                    document.addEventListener("click", (e) => {
                        e.target.hasAttribute("data-bundle-item-remove") &&
                            (e.preventDefault(), u(e.target.closest("[data-bundle-item-group]")));
                    }),
                    document.addEventListener("click", async (e) => {
                        if (!e.target.hasAttribute("data-quantity-adjust")) return;
                        const t = e.target.closest("[data-ajax-cart-line-item]"),
                            a = e.target.parentElement.childNodes[3],
                            s = a.getAttribute("data-line-item-key"),
                            i = parseFloat(a.max);
                        let n = parseFloat(a.value),
                            r = t.querySelector(".ajax__item__remove");
                        if (
                            (e.target.hasAttribute("data-quantity-minus")
                                ? a.value > 1
                                    ? (n -= 1)
                                    : (n = 0)
                                : e.target.hasAttribute("data-quantity-plus") && a.value < i && (n += 1),
                            t && t.hasAttribute("data-bundle-item-group"))
                        ) {
                            if (0 === n) return u(t), void y(r);
                            const e = { updates: {} };
                            t.querySelectorAll("[data-bundle-item]").forEach((t) => {
                                e.updates[t.dataset.lineItemKey] = n;
                            });
                            const s = await m(e, !1);
                            (a.value = n), g(s);
                        } else if (t && t.hasAttribute("data-recipe-item-group")) {
                            if (0 === n) return c(t), void y(r);
                            const e = { updates: {} };
                            t.querySelectorAll("[data-recipe-item]").forEach((t) => {
                                "false" === t.dataset.doubleUpcharge
                                    ? (e.updates[t.dataset.lineItemKey] = n)
                                    : (e.updates[t.dataset.lineItemKey] = 2 * n);
                            });
                            const s = await m(e, !0);
                            (a.value = n), g(s);
                        } else d(s, n), 0 == n && y(r);
                    }),
                    document.addEventListener("change", (e) => {
                        if (!e.target.hasAttribute("data-quantity-input")) return;
                        const t = e.target.getAttribute("data-line-item-key"),
                            a = parseFloat(e.target.max);
                        let s = parseFloat(e.target.value);
                        s > a ? (s = a) : s < 1 && (s = 0), d(t, s);
                    }),
                    document.addEventListener("click", (e) => {
                        const t = e.target;
                        if (0 == t.hasAttribute("data-collection-item-add-to-cart")) return;
                        let a,
                            i,
                            n = { items: [{ id: t.getAttribute("data-variant-id"), quantity: 1 }] },
                            r = !1;
                        t.hasAttribute("data-recipe-id") &&
                            ((r = !0),
                            (a = t.dataset.recipeId),
                            (i = { RecipeID: t.dataset.recipeId }),
                            (n.items[0].properties = i)),
                            (n.items[0].properties = { _osp: 0.8 });
                        const o = document.querySelector("[data-cart-route]").dataset.cartAddRoute + ".js";
                        Object(s.a)(o, {
                            method: "POST",
                            credentials: "same-origin",
                            headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                            body: JSON.stringify(n),
                        })
                            .then((e) => e.json())
                            .then((e) => {
                                if (e.status) throw new Error(e.description);
                                if (r) {
                                    const t = {
                                        id: 33460764901464,
                                        quantity: 1,
                                        properties: { upcharge_parent_key: e.items[0].key, RecipeID: "uc-" + a },
                                    };
                                    setTimeout(function () {
                                        Object(s.a)(o, {
                                            method: "POST",
                                            credentials: "same-origin",
                                            headers: {
                                                "Content-Type": "application/json",
                                                "X-Requested-With": "xmlhttprequest",
                                            },
                                            body: JSON.stringify(t),
                                        }).then((e) => (f(!0), g(), null), 100);
                                    });
                                }
                                if ("true" != document.querySelector("body").dataset.autoGift) return f(!0), g(), null;
                                l();
                            })
                            .catch((e) => {
                                alert(e);
                            });
                    }),
                    v(),
                    b();
            });
    },
    5: function (e, t, a) {
        "use strict";
        function s() {
            if (!document.querySelectorAll("[data-upsell-item]").length) return;
            const e = window.matchMedia("(min-width: 750px)");
            function t(t) {
                if (!t.target.hasAttribute("data-variant-swatch-cart")) return;
                if (t.target.classList.contains("selected")) return;
                let a = t.target.getAttribute("data-image-src"),
                    s = t.target.getAttribute("data-variant-url");
                const i = t.target.closest("[data-upsell-item]"),
                    n = i.querySelector("[data-upsell-item-image]"),
                    r = i.querySelector("[data-upsell-item-image] img"),
                    o = i.querySelector("[data-upsell-link]"),
                    l = i.querySelector("[data-upsell-price]");
                o.setAttribute("href", s),
                    (l.innerHTML = t.target.getAttribute("data-price")),
                    !1 === e.matches && t.target.hasAttribute("data-mobile-image-src")
                        ? ((a = t.target.getAttribute("data-mobile-image-src")), n.classList.add("lifestyle-image"))
                        : n.classList.remove("lifestyle-image"),
                    r.setAttribute("src", a),
                    r.setAttribute("data-srcset", a),
                    r.setAttribute("srcset", a),
                    t.target.hasAttribute("data-mobile-image-src")
                        ? r.classList.add("is-lifestyle-image")
                        : r.classList.remove("is-lifestyle-image");
                i.querySelector("[data-product-select]").value = t.target.getAttribute("data-variant-id");
                t.target.parentElement.querySelectorAll("[data-variant-swatch]").forEach((e) => {
                    e.classList.remove("selected");
                }),
                    t.target.classList.add("selected");
            }
            document.addEventListener("click", t), document.addEventListener("keydown", t);
        }
        a.d(t, "a", function () {
            return s;
        });
    },
    6: function (e, t, a) {
        var s, i;
        /*!
         * JavaScript Cookie v2.2.1
         * https://github.com/js-cookie/js-cookie
         *
         * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
         * Released under the MIT license
         */ !(function (n) {
            if (
                (void 0 === (i = "function" == typeof (s = n) ? s.call(t, a, t, e) : s) || (e.exports = i),
                !0,
                (e.exports = n()),
                !!0)
            ) {
                var r = window.Cookies,
                    o = (window.Cookies = n());
                o.noConflict = function () {
                    return (window.Cookies = r), o;
                };
            }
        })(function () {
            function e() {
                for (var e = 0, t = {}; e < arguments.length; e++) {
                    var a = arguments[e];
                    for (var s in a) t[s] = a[s];
                }
                return t;
            }
            function t(e) {
                return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
            }
            return (function a(s) {
                function i() {}
                function n(t, a, n) {
                    if ("undefined" != typeof document) {
                        "number" == typeof (n = e({ path: "/" }, i.defaults, n)).expires &&
                            (n.expires = new Date(1 * new Date() + 864e5 * n.expires)),
                            (n.expires = n.expires ? n.expires.toUTCString() : "");
                        try {
                            var r = JSON.stringify(a);
                            /^[\{\[]/.test(r) && (a = r);
                        } catch (e) {}
                        (a = s.write
                            ? s.write(a, t)
                            : encodeURIComponent(String(a)).replace(
                                  /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                                  decodeURIComponent
                              )),
                            (t = encodeURIComponent(String(t))
                                .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
                                .replace(/[\(\)]/g, escape));
                        var o = "";
                        for (var l in n) n[l] && ((o += "; " + l), !0 !== n[l] && (o += "=" + n[l].split(";")[0]));
                        return (document.cookie = t + "=" + a + o);
                    }
                }
                function r(e, a) {
                    if ("undefined" != typeof document) {
                        for (
                            var i = {}, n = document.cookie ? document.cookie.split("; ") : [], r = 0;
                            r < n.length;
                            r++
                        ) {
                            var o = n[r].split("="),
                                l = o.slice(1).join("=");
                            a || '"' !== l.charAt(0) || (l = l.slice(1, -1));
                            try {
                                var d = t(o[0]);
                                if (((l = (s.read || s)(l, d) || t(l)), a))
                                    try {
                                        l = JSON.parse(l);
                                    } catch (e) {}
                                if (((i[d] = l), e === d)) break;
                            } catch (e) {}
                        }
                        return e ? i[e] : i;
                    }
                }
                return (
                    (i.set = n),
                    (i.get = function (e) {
                        return r(e, !1);
                    }),
                    (i.getJSON = function (e) {
                        return r(e, !0);
                    }),
                    (i.remove = function (t, a) {
                        n(t, "", e(a, { expires: -1 }));
                    }),
                    (i.defaults = {}),
                    (i.withConverter = a),
                    i
                );
            })(function () {});
        });
    },
    8: function (e, t, a) {
        "use strict";
        a.r(t),
            a.d(t, "giftOrder", function () {
                return i;
            });
        var s = a(1);
        function i() {
            const e = document.querySelectorAll("[data-gift-order-form]");
            e.length < 1 ||
                e.forEach((e) => {
                    const t = e.querySelector("[data-gift-order-checkbox]"),
                        a = e.querySelector("[data-gift-text]"),
                        i = e.querySelector("[data-error-message]"),
                        n = document.querySelector("[data-cart-checkout-btn]");
                    !0 === t.checked ? a.classList.remove("hide") : a.classList.add("hide"),
                        e.addEventListener("change", () => {
                            let e = "";
                            const r = a.getAttribute("data-blocked-character");
                            let o = [];
                            for (let e = 0; e < r.length; e++) o.push(r.charAt(e));
                            const l = i.getAttribute("data-error-message");
                            let d = "",
                                c = !1;
                            if (
                                (a.classList.remove("has-errors"),
                                (i.innerHTML = ""),
                                n.classList.remove("disabled"),
                                !0 === t.checked)
                            ) {
                                a.classList.remove("hide");
                                const t = a.querySelector("textarea").value;
                                o.forEach((e) => {
                                    t.includes(e) &&
                                        ((c = !0),
                                        (d = `${d} ${e}`),
                                        a.classList.add("has-errors"),
                                        (i.innerHTML = `${l} ${d}`),
                                        n.classList.add("disabled"));
                                }),
                                    (e = a.querySelector("textarea").value);
                            } else a.classList.add("hide"), (e = "");
                            if (!0 === c) return;
                            const u = { attributes: { "Gift Order": t.checked, "Gift Message": e } },
                                p = document.querySelector("[data-cart-route]").dataset.cartUpdateRoute + ".js";
                            Object(s.a)(p, {
                                method: "POST",
                                credentials: "same-origin",
                                headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                                body: JSON.stringify(u),
                            })
                                .then((e) => e.json())
                                .catch((e) => {
                                    console.log(e);
                                });
                        });
                });
        }
        document.addEventListener("DOMContentLoaded", () => {
            i();
        }),
            document.addEventListener("shopify:section:load", () => {
                i();
            });
    },
});
